export default {
  date: {
    formats: {
      default: '%d-%m-%Y',
      short: '%-d %B',
      long: '%-d %B, %Y',
      with_day: '%A, %-d %B %Y',
      without_day: '%-d %B %Y',
    },
    day_names: [
      'Sonntag',
      'Montag',
      'Dienstag',
      'Mittwoch',
      'Donnerstag',
      'Freitag',
      'Samstag',
    ],
    abbr_day_names: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    month_names: [
      null,
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember',
    ],
    abbr_month_names: [
      null,
      'Jan',
      'Feb',
      'Mär',
      'Apr',
      'Mai',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Okt',
      'Nov',
      'Dez',
    ],
    order: [':Jahr', ':Monat', ':Tag'],
  },
  number: {
    format: {
      separator: ',',
      delimiter: '.',
      precision: 2,
      round_mode: 'default',
      significant: false,
      strip_insignificant_zeros: false,
    },
    currency: {
      format: {
        format: '%n %u',
        unit: '€',
        separator: ',',
        delimiter: '.',
        precision: 2,
        significant: false,
        strip_insignificant_zeros: false,
      },
      EUR: '€',
      USD: 'US-Dollar',
      CAD: 'CAD',
      AUD: 'AUD',
      GBP: '£',
      DKK: 'kr',
      NOK: 'kr',
      SEK: 'kr',
    },
    percentage: {
      format: {
        delimiter: '',
        format: '%n %',
      },
    },
    precision: {
      format: {
        delimiter: '',
      },
    },
    human: {
      format: {
        delimiter: '',
        precision: 1,
        significant: true,
        strip_insignificant_zeros: true,
      },
      storage_units: {
        format: '%n %u',
        units: {
          byte: {
            one: 'Byte',
            other: 'Bytes',
          },
          kb: 'KB',
          mb: 'MB',
          gb: 'GB',
          tb: 'TB',
          pb: 'PB',
          eb: 'EB',
        },
      },
      decimal_units: {
        format: '%n %u',
        units: {
          unit: '',
          thousand: 'Tausend',
          million: 'Millionen',
          billion: {
            one: 'Milliarde',
            other: 'Milliarden',
          },
          trillion: 'Billionen',
          quadrillion: {
            one: 'Billiarde',
            other: 'Billiarden',
          },
        },
      },
    },
    nth: {
      ordinals: {},
      ordinalized: {},
    },
  },
  datetime: {
    distance_in_words: {
      half_a_minute: 'eine halbe Minute',
      less_than_x_seconds: {
        one: 'weniger als eine Sekunde',
        other: 'weniger als %{count} Sekunden',
        few: 'weniger als %{count} Sekunden',
        many: 'weniger als %{count} Sekunden',
      },
      x_seconds: {
        one: '1 Sekunde',
        other: '%{count} Sekunden',
        few: '%{count} Sekunden',
        many: '%{count} Sekunden',
      },
      less_than_x_minutes: {
        one: 'weniger als eine Minute',
        other: 'weniger als %{count} Minuten',
        few: 'weniger als %{count} Minuten',
        many: 'weniger als %{count} Minuten',
      },
      x_minutes: {
        one: '1 Minute',
        other: '%{count} Minuten',
        few: '%{count} Minuten',
        many: '%{count} Minuten',
      },
      about_x_hours: {
        one: 'etwa eine Stunde',
        other: 'etwa %{count} Stunden',
        few: 'etwa %{count} Stunden',
        many: 'etwa %{count} Stunden',
      },
      x_days: {
        one: '1 Tag',
        other: '%{count} Tage',
        few: '%{count} Tage',
        many: '%{count} Tage',
      },
      about_x_months: {
        one: 'etwa 1 Monat',
        other: 'etwa %{count} Monate',
        few: 'etwa %{count} Monate',
        many: 'etwa %{count} Monate',
      },
      x_months: {
        one: '1 Monat',
        other: '%{count} Monate',
        few: '%{count} Monate',
        many: '%{count} Monate',
      },
      about_x_years: {
        one: 'etwa ein Jahr',
        other: 'etwa %{count} Jahre',
        few: 'etwa %{count} Jahre',
        many: 'etwa %{count} Jahre',
      },
      over_x_years: {
        one: 'mehr als ein Jahr',
        other: 'mehr als %{count} Jahre',
        few: 'mehr als %{count} Jahre',
        many: 'mehr als %{count} Jahre',
      },
      almost_x_years: {
        one: 'fast ein Jahr',
        other: 'fast %{count} Jahre',
        few: 'fast %{count} Jahre',
        many: 'fast %{count} Jahre',
      },
      x_years: {
        one: 'ein Jahr',
        other: '%{count} Jahr',
      },
      x_weeks: {
        one: '1 Woche',
        other: '%{count} Wochen',
        few: '%{count} Wochen',
        many: '%{count} Wochen',
      },
      x_hours: {
        one: '1 Stunde',
        other: '%{count} Stunden',
      },
    },
    prompts: {
      year: 'Jahr',
      month: 'Monat',
      day: 'Tag',
      hour: 'Stunde',
      minute: 'Minute',
      second: 'Sekunden',
    },
  },
  'custom-wallpaper': {
    'aria-title': 'Wallpaper',
    'aria-label': 'Set Wallpaper',
    'aria-author': 'author:',
  },
  page: {
    plus: {
      button: {
        text: 'Hole dir Pro',
      },
    },
    profile: {
      wallpapers: {
        best_1: 'Bis zu fünf unterschiedliche Bilder',
        best_2: 'JPEG oder PNG',
        best_3: 'Bis zu %{size}',
        best_4: '%{resolution} Pixel oder höher',
        best_5: 'Keine GIFs oder Videos (sorry)',
        best_title: 'Das Wichtigste:',
        text: 'Rücke dich oder deine Marke mit bis zu fünf rotierenden Videos oder Hintergrundbildern auf deiner Seite sichtbar in den Vordergrund:',
        best_five: '%{videoResolution} Pixel für Videos',
        best_four: '%{resolution} Pixel für Bilder',
        best_one: 'Bis zu fünf Videos oder Bilder',
        best_six:
          'Hintergrundbilder rotieren alle %{rotationInterval} Sekunden, Videos, die länger sind als %{rotationInterval}, werden gekürzt',
        best_three: 'Maximal %{size} pro Video/Bild',
        best_two: 'JPEG, PNG oder MP4',
        notice:
          "Trommelwirbel bitte — Video-Hintergründe sind da! <a href='/profile'>Verwende ein Video als Hintergrund</a>.",
      },
      upsell: {
        benefit_one_alt: 'Erhalte deine eigene WeTransfer-Seite',
        heading_alt: 'Liefere deine Arbeit mit Stil ab',
        benefit_one: 'Sichere dir deine WeTransfer-Domain',
        benefit_three: 'Gestalte deine Übertragungs-E-Mails',
        benefit_two:
          'Nutze selbst erstellte Hintergründe, wenn deine Dateien heruntergeladen werden',
        button: {
          action: 'Klingt interessant',
        },
        heading: 'Präsentiere deine Marke mit WeTransfer Pro',
      },
      branding: {
        headline:
          '<strong>Sende nur das Beste.</strong> Hinterlasse jedes Mal einen tollen Eindruck, wenn die Leute deine Dateien herunterladen.<br /> <strong>Empfange Dateien völlig mühelos.</strong> Mit deinem Plan können alle Dateien an dich senden.',
        protip: {
          text: '<strong>Profi-Tipp:</strong> Du möchtest eine Übertragung von jemandem beantragen? Teile einen speziellen Link, um die Beschreibung für sie vorab auszufüllen.',
          link: 'Mehr Info',
        },
      },
      pagename: 'Profileinstellungen',
      'onboarding-step-two':
        "Gestalte dein WeTransfer-Profil individuell und präsentiere deine Dateien in deinem Style. Das Resultat kannst du unter <a href='%{href}'>%{domain}</a> bewundern.",
      email_backgrounds: 'E-Mail-Hintergründe',
      sent_you_files: 'hat dir einige Dateien gesendet',
      email_background_instruction_with_spec:
        'Hebe deine Begleitmails hervor – mit einem eigenen Hintergrundbild. \nDie besten Resultate erhälst du, wenn dein Bild %{resolution} Pixel hat (Bilder, die breiter sind, müssen wir leider beschneiden). Die Datei darf maximal %{size} groß sein.',
      receiving: 'Profil-E-Mail',
      choose_wallpapers: 'Hintergrundbilder',
      'step-one-banner':
        'Um loszulegen, wähle eine URL für deine WeTransfer-Seite. Du kannst dies später jederzeit ändern.',
      description: {
        pro: 'Über deine eigene WeTransfer-Seite kannst du jedes Mal einen tollen Eindruck hinterlassen, wenn andere deine Dateien herunterladen. Hier können andere dir auch Übertragungen von 200 GB senden. Das ist Teil deines WeTransfer Premium-Abos.',
        premium:
          'Über deine eigene WeTransfer-Seite kannst du jedes Mal einen tollen Eindruck hinterlassen, wenn andere deine Dateien herunterladen. Hier können andere dir auch Übertragungen ohne Größenbeschränkungen senden. Das ist Teil deines WeTransfer Premium-Abos.',
      },
      'instructions-1':
        'Ändere deinen Namen und deine URL so oft, wie es nötig ist.',
      'instructions-2':
        'Sobald du eine neue URL ausgewählt hast, wird deine Seite sofort aktualisiert.',
      title: 'Bearbeite deine Seite',
      profile_url: 'Profil-URL',
    },
    payment: {
      never_actived_retry:
        'Dein Konto ist noch nicht aktiv. Schließe deine Registrierung ab, um mit <a href="/payment/retry">%{planName}</a> zu starten',
      pagename: 'Abo und Zahlung',
      autorenew_heading: 'Zahlungsinformationen',
      autorenew_notice:
        'Dein %{planName}-Abonnement zum Preis von %{deal} wird am %{autorenewal_attempt} automatisch verlängert.',
      will_expire_notice:
        "Dein Pro-Abo <span class='payment__notice'>endet in %{daysBetween} Tagen</span>. Verlängere es jetzt oder wähle automatische Verlängerung.",
      never_actived_notice:
        'Dein Konto wurde noch nicht aktiviert. <a href="/payment/retry">Schließ deine Registrierung ab, damit du Pro nutzen kannst.</a>',
      manual_renewal_expiry_notice: 'Dein Pro-Konto endet am %{expiry}.',
      to_checkout: 'Zur Bezahlung',
      updating: 'Wird aktualisiert...',
      yes_disable: 'Ja, deaktivieren',
      review_billing_link: 'Willst du deine Zahlungsart ändern?',
      autorenew_failed:
        "Dein Pro-Abo für %{deal}/%{period} <span class='payment__notice'><strong>endet in %{daysBetween} Tagen</strong>. Wir konnten dein Konto nicht automatisch verlängern – bitte verlängere es manuell bis spätestens <strong>%{expiry}</strong>.</span>",
      confirm_disable_autorenew:
        'Willst du die automatische Verlängerung wirklich deaktivieren?',
      disable_autorenewal: 'Automatische Verlängerung deaktivieren',
      enable_autorenewal: 'Automatische Verlängerung aktivieren',
      renew_now: 'Jetzt verlängern',
      subscription_expired: 'Dein Pro-Konto ist abgelaufen',
      cancel_heading: 'Zeit für was Neues?',
      cancel_info:
        'Das verstehen wir. So spielt das Leben eben. Nach der Kündigung deines Abos werden wir deine Dateien noch für 30 weitere Tage speichern –  nur für den Fall, dass du irgendwas auf unseren Servern vergessen solltest. Du kannst dein Abo übrigens jederzeit reaktivieren.',
      cancel_info_subscription:
        'Das verstehen wir. So spielt das Leben eben. Nach der Kündigung deines Abos kannst du dein Pro-Benutzerkonto bis zum %{subscriptionExpiryDate} nutzen. Anschließend werden wir deine Dateien für weitere 30 Tage speichern – nur für den Fall, dass du irgendwas auf unseren Servern vergessen haben solltest. Du kannst dein Abo übrigens jederzeit reaktivieren.',
      cancel_now: 'Abonnement beenden',
      cancelling: 'Wird beendet...',
      confirm_cancel_subscription:
        'Bist du sicher, dass du dein Abo beenden möchtest?',
      confirm_reactivate_subscription:
        'Ausgezeichnete Idee! Nur noch ein Klick und deine Zahlungsart wird reaktiviert',
      manual_renewal_in_future_notice:
        'Dein Pro-Abo für %{deal}/%{period} endet in %{daysBetween} Tagen. Du kannst es ab %{manual_renewal_available_at} manuell verlängern – oder aktiviere jetzt die automatische Verlängerung.',
      reactivate_heading: 'Und noch einmal.',
      reactivate_content_top_pro:
        'Du kannst dein %{planName}-Abonnement wieder aktivieren und es ist, als hättest du es nie gekündigt. Oder du entscheidest dich für ein Upgrade auf WeTransfer Premium.',
      reactivate_content_top_premium:
        'Du kannst dein %{planName}-Abonnement wieder aktivieren und es ist, als hättest du es nie gekündigt.',
      reactivate_content_bottom_pro:
        'Wenn du ein Upgrade auf Premium vornimmst, werden dir %{upfront_payment} berechnet und du kannst sofort mit WeTransfer Premium loslegen. Dein neues %{recurring_payment}/%{interval}-Abonnement wird am %{recurring_date} verlängert.',
      reactivate_pro: 'Pro wieder aktivieren',
      reactivate_premium: 'Premium wieder aktivieren',
      reactivate_upgrade_to_premium: 'Upgrade auf Premium',
      reactivating: 'Reaktivierung läuft...',
      subscription_cancelled:
        'Dein Abo wurde beendet und läuft in %{daysBetween} Tagen automatisch aus.',
      subscription_reactivate_expired_notice: 'Dein Pro-Konto wurde gekündigt.',
      subscription_reactivate_notice_pro:
        'Dein %{planName}-Abonnement wurde gekündigt und endet in%{daysBetween} Tagen.',
      subscription_reactivate_notice_premium:
        'Dein %{planName}-Abonnement wurde gekündigt und endet in %{daysBetween} Tagen.Hast du es dir anders überlegt? Keine Panik, es ist ganz einfach, alles wieder in Gang zu bringen.',
      subscription_reactivate_notice_trial_before:
        'Dein %{planName}-Abonnement wurde gekündigt und endet in%{daysBetween} Tagen.\nDu kannst deine WeTransfer Premium-Probephase weiterhin genießen, bis dein Abonnement endet.',
      subscription_reactivate_notice_trial_after:
        'Dein %{planName}-Abonnement wurde gekündigt und endet in%{daysBetween} Tagen.\nDu kannst deine WeTransfer Premium-Probephase weiterhin bis zum %{trialExpiryDate} genießen.',
      update_method_link: 'Zahlungsdaten aktualisieren',
      autorenew_notice_teams:
        'Dein %{planName}-Abonnement zum Preis von %{deal} für dein Team mit %{number_of_members} Mitgliedern wird am %{autorenewal_attempt} automatisch verlängert.',
      cancellation_cta: 'Abonnement beenden',
      cancellation_heading: 'Du kommst ohne die Vorteile von %{planName} aus?',
      cancellation_heading_trial: 'Abonnement kündigen',
      cancellation_text:
        'Wenn du dein Abo beendest, kannst du deine Pro-Funktionen bis zum %{subscriptionExpiryDate} weiterhin verwenden. Danach wird dein WeTransfer Pro-Konto in ein kostenloses WeTransfer-Konto umgewandelt und werden deine gelisteten Übertragungen 28 Tage später gelöscht.',
      cancellation_text_item_1: 'Bis zu %{transfer_limit} versenden',
      cancellation_text_item_2: 'Passwortschutz für Übertragungen',
      cancellation_text_item_3:
        '%{storage_limit} an Übertragungen speichern und verwalten',
      cancellation_text_item_4:
        'Eigene URL wählen und Pro-Seite selbst gestalten',
      cancellation_text_item_heading:
        'Mit einem kostenlosen Konto kannst du nur noch bis zu %{free_size_limit} pro Übertragung versenden. Was dann nicht mehr möglich ist:',
      cancellation_text_new:
        'Wenn du dein Abonnement jetzt kündigst, kannst du %{planName} noch bis zum %{subscriptionExpiryDate} nutzen. Danach wirst du auf das kostenlose Abo zurückgestuft.<br /><br />Zur Info: Deine vorhandenen Übertragungen laufen spätestens 28 Tage nach Ablauf deines Abonnements ab.',
      cancellation_text_teams:
        'Wenn du dein Abonnement jetzt kündigst, könnt ihr, dein Team und du, %{planName} bis zum %{subscriptionExpiryDate} nutzen. <br /><br />Danach ist es nicht mehr möglich, im Team Dateien zu übertragen, und zusammen Präsentationsfolien und Boards zu erstellen. Du wirst auf ein kostenloses Abo herabgestuft und kannst dich nur noch bei deinem eigenen WeTransfer-Konto anmelden.<br /><br />Zur Info: Deine vorhandenen Übertragungen laufen spätestens 28 Tage nach Ablauf deines Abonnements ab.',
      premium_trial: {
        feature_list_item_1: 'Keine Größenbeschränkungen für Übertragungen',
      },
      premium_upgrade: {
        cta: 'Zu Premium wechseln',
        description:
          'Du bezahlst %{upfront_payment} und kannst direkt loslegen mit WeTransfer Premium. Dein neues %{recurring_payment}/%{interval}-Abonnement wird am %{recurring_date} verlängert.',
        feature_list_item_1:
          'Versende Übertragungen ohne Dateigrößenbeschränkungen',
        feature_list_item_2: 'Unbegrenzter Speicherplatz',
        feature_list_item_3: 'Unbegrenzt viele Portale und Reviews',
        feature_list_item_4: '%{storageLimit} Speicherplatz',
        heading: 'Möchtest du dein Abo upgraden?',
      },
      unpaid_invoices: {
        heading: 'Du hast unbezahlte Rechnungen',
        item: {
          issued_on: 'Ausgestellt am',
          pay_invoice: 'Rechnung bezahlen',
          pending_invoice: 'Ausstehend ...',
        },
        subheading:
          'Es scheint ein Problem mit deinen vorherigen Zahlungen zu geben. Bitte bezahle alle ausstehenden Rechnungen, sonst wird dein Pro-Abonnement möglicherweise gekündigt.',
        subheading_2:
          'Wenn du ausstehende Rechnungen hast, bleib ganz ruhig—wir versuchen es in ein paar Tagen nochmal und du kannst loslegen, sobald die Zahlung erfolgt ist.',
      },
      upgrade_cta: 'Upgraden',
      app_subscription_banner: {
        title: 'Du hast von %{app_name} abonniert',
        content:
          'Um dein Abonnement anzuzeigen oder zu verwalten, melde dich von deinem Telefon oder Computer aus bei deinem %{app_name}-Konto an.',
        go_to: 'Gehe zu',
        learn_more: 'Mehr erfahren',
      },
    },
    'payment_cancel-verify': {
      cancellation_cta: 'Abonnement beenden',
      cancellation_disclaimer:
        '*Zur Info: Deine vorhandenen Übertragungen werden 28 Tage nach der Herabstufung deines Kontos gelöscht.',
      'current-plan': 'Aktuelles Konto',
      'free-forever': 'Immer kostenlos',
      'free-usp-1': 'Sende bis zu 2 GB',
      'free-usp-2': 'Kein Speicherplatz',
      'free-usp-3': 'Übertragungen laufen nach 7 Tagen* ab',
      'heading-free': 'WeTransfer',
      'heading-pro': 'We Transfer Pro',
      intro:
        'Wenn du dein Abonnement jetzt kündigst, kannst du WeTransfer Pro noch bis zum <b>%{expiration_date}</b> verwenden. Anschließend wird dein Konto in ein kostenloses WeTransfer-Konto umgewandelt – das übrigens immer noch ziemlich knorke ist.',
      pagename: 'Kein Bedarf mehr an den Pro-Vorzügen?',
      'pro-usp-1': 'Sende und übertrage bis zu %{transfer_limit}',
      'pro-usp-2': '1 TB Speicherplatz',
      'pro-usp-3': 'Entscheide, wann Übertragungen verfallen',
      'pro-usp-4':
        '<p>Deine eigene <a href="/profile?utm_source=pro_pass&utm_medium=usp_4_link&utm_campaign=cancel_verify">Pro-Seite</a></p>',
      'pro-usp-5':
        '<a href="https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=usp_5_link&utm_campaign=cancel_verify">Schalte Paste® Pro and Collect Pro frei</a>',
    },
    payment_cancel: {
      info_with_end_date:
        '<p>Du hast dein Abonnement beendet. Dein Konto wird nach dem <b>%{ends_at}</b> auf ein kostenloses WeTransfer-Konto herabgestuft.</p>\n<p>Es würde uns freuen, wenn du uns sagen würdest, warum du uns verlässt. Wir werden WeTransfer dann in Gedanken an dich weiter verbessern.</p>',
      reason_header: 'Wie schade, dass du uns verlässt',
      cancel: 'Zurück',
      info: 'Es würde uns freuen, wenn du uns sagen würdest, warum du uns verlässt. Wir werden WeTransfer Pro dann in Gedanken an dich weiter verbessern.',
      pagename: 'Bevor du gehst',
      yes_disable: 'Ja, bitte',
    },
    payment_failed: {
      selected_product: 'Ein %{duration} mit %{planTier}',
      change: 'Aktualisieren',
      complete_order: 'Bestellung platzieren',
      description: 'Prüfe deine Daten und schließ deine Bestellung ab',
      description_error:
        'Irgendwas ist schiefgelaufen – bitte prüfe deine Daten und setze den Vorgang fort',
      description_refused:
        "Wir konnten deine Zahlung nicht bearbeiten – bitte prüfe deine Zahlungsdaten und versuch's nochmal",
      discount: 'Rabatt',
      product_description: 'Ein %{duration} WeTransfer Pro',
      title: 'Fast fertig!',
      total: 'Summe',
      vat: 'MwSt.',
      your_details: 'Deine Daten',
      your_order: 'Deine Bestellung',
      title_error: 'Mmh, da ist etwas schiefgelaufen',
      title_refused: 'Mmh, da ist etwas schiefgelaufen',
      payment_status_message:
        'Deine Zahlung war erfolgreich, aber etwas ist schiefgelaufen und wir konnten dein Abo nicht automatisch aktualisieren. <a href="https://wetransfer.zendesk.com/hc/en-us/requests/new" rel="external">Wende dich an unseren Support</a>',
    },
    payment_methods: {
      billed_now: 'Jetzt abzurechnen',
      info_content: {
        cancel_bullet:
          'Keine Sorge, die Option zu kündigen findest du unter Kontoeinstellungen > Zahlungen.',
        initial_payment_bullet:
          'Nach deiner Zahlung stellen wir dir %{interval} %{price} in Rechnung (es sei denn, du entscheidest dich, dein Abonnement zu kündigen – aber das würdest du niemals tun, oder? Oder?!)',
        update_payment_bullet:
          'Du kannst deine Zahlungsinformationen und/oder Rechnungsdaten jederzeit ändern, bevor die nächste Zahlung fällig ist.',
        month:
          '– Nach der ersten Zahlung stellen wir dir jeden Monat %{price} in Rechnung (es sei denn, du entscheidest dich, dein Pro-Abonnement zu kündigen – aber das würdest du nicht tun, oder? Oder?!)\n – Keine Sorge, die Option zu kündigen findest du in Kontoeinstellungen > Zahlung.\n– Du kannst deine Zahlungsinformationen und/oder Rechnungsdaten jederzeit ändern, bevor die nächste Zahlung fällig ist.',
        year: '- Nach deiner ersten Zahlung stellen wir dir jährlich %{price} in Rechnung, bis du dich entscheidest, dein WeTransfer Pro Abonnement zu kündigen. \n- Du kannst jederzeit kündigen unter: Kontoeinstellungen > Zahlungen. \n- Du kannst deine Zahlungsart und/oder deine Unternehmensdaten jederzeit ändern, bevor die nächste Zahlung fällig ist.',
      },
      payment_cta: 'Zahlung abschließen',
      payment_term: {
        monthly: 'einmal im Monat',
        yearly: 'einmal im Jahr',
      },
      payment_title: 'Zahlung',
      plan_details: {
        premium: 'WeTransfer Premium',
        pro: 'We Transfer Pro',
        month: 'monatlich',
        year: 'jährlich',
      },
      subtotal: 'Zwischensumme',
      legislation_text:
        'Ich fordere und stimme ausdrücklich zu, dass Sie mit der von mir bestellten Dienstleistung vor Ablauf der Widerrufsfrist beginnen. Mir ist bekannt, dass mein Widerrufsrecht mit vollständiger Vertragserfüllung erlischt.*',
      legislation_footer:
        '* Hier finden Sie die <a href="/legal/terms?overrideLanguage=de" target="_blank">Nutzungsbedingungen</a> und <a href="/documents/Datenschutz_und_Cookierichtlinie.pdf" target="_blank">Datenschutz- und Cookie-Erklärung.</a>',
      your_payment_method: 'Deine Zahlungsmethode',
      bancontact: 'Bancontact',
      card: 'Kreditkarte',
      card_cvc: 'CVC',
      card_expiration: 'MM/JJ',
      card_name: 'Name des Karteninhabers',
      card_number: 'Kartennummer',
      complete_payment: 'Vervollständige deine Zahlung',
      creditcard: 'Kreditkarte',
      discount: 'Rabatt',
      do_not_refresh: 'Bitte die Seite nicht aktualisieren und nicht schließen',
      ideal: 'iDEAL',
      ideal_info:
        'iDEAL ist eine niederländische Online-Zahlungsart, bei der die Verbraucher für die Zahlung das Online-Banking der eigenen Bank nutzen.',
      info: 'Wiederkehrende Zahlung und Aktualisierung der Zahlungsart',
      payment_in_progress: 'Der Zahlungsvorgang läuft...',
      paypal: 'PayPal',
      plan_name: 'We Transfer Pro',
      price_period: {
        month: '/Monat',
        year: '/Jahr',
      },
      select_bank: 'Wähle deine Bank',
      select_country: 'Land auswählen',
      sofort: 'SOFORT',
      tax: 'MwSt.',
      title: 'Wähle deine Zahlungsart',
      total: 'Summe',
    },
    projects: {
      actions: {
        go_back: 'Alle Projekte',
        discard: 'Änderungen verwerfen',
        edit: 'Bearbeiten',
        remove_transfer:
          'Diese Übertragung löschen? Dateien werden aus diesem Projekt entfernt und Übertragungen gesendet.',
        save: 'Speichern',
        share: 'Teilen',
      },
      transfer_actions: {
        download: 'Download',
      },
      added_at: 'um %{timeOfDay}',
      clipboard_modal: {
        copy_link: 'Link kopieren',
        link_copied: 'Link in die Zwischenablage kopiert',
        content_label: 'Link zu diesem Projekt kopieren',
        list_item_1: 'Nur Zugriff herunterladen und anzeigen',
        list_item_2: 'Der Link bleibt für immer derselbe',
        title: 'Projekt teilen',
      },
      content: {
        empty_state:
          'Dein Projekt ist momentan leer. Starte, indem du deiner Projektzeitleiste einige Dateien hinzufügst.',
      },
      logo_title: 'Geh zurück zu wetransfer.com',
      logo_tooltip_caption: 'Zurück zu WeTransfer',
      timestamp: 'vor %{timeAgo}',
      chat: {
        owner_button_label: 'Psst ... sprich mit uns',
        owner_offline_greeting:
          'Wir sind zurzeit offline, aber lass uns wissen, womit du Probleme hast und wir melden uns innerhalb eines Werktages bei dir.',
        owner_online_greeting:
          'Lass uns wissen, womit du Probleme hast und wir melden uns so schnell wie möglich bei dir.',
        receiver_button_label: 'Fragen? Wir sind hier, um dir zu helfen',
        receiver_offline_greeting:
          'Lass uns wissen, womit du Probleme hast und wir melden uns so schnell wie möglich bei dir.',
        receiver_online_greeting:
          'Lass uns wissen, womit du Probleme hast und wir melden uns so schnell wie möglich bei dir.',
      },
      created_by: 'Erstellt von %{user}',
      created_by_fallback: 'Erstellt',
      deliverable_clipboard_modal: {
        content_label: 'Link zu diesem Arbeitsergebnis kopieren',
        info: 'Die Leute können dein Projekt auch sehen',
        title: 'Arbeitsergebnis teilen',
      },
      deliverables: {
        add_deliverable: 'Add a deliverable',
        add_files: 'Add files',
        cancel_upload: 'Cancel this upload?',
        clear_all_files_option: 'Clear all files',
        create_deliverable: {
          input_placeholder_0: 'Rough illustrations',
          input_placeholder_1: 'Brand guidelines',
          input_placeholder_2: 'Royalty-free SFX samples',
          input_placeholder_3: 'Color corrected video',
          input_placeholder_4: 'Voiceover recordings from my closet',
          input_placeholder_5: 'Quick sketches for quick approval',
          input_placeholder_6: '10,000 storyboard options',
          input_placeholder_7: 'The first video cut is the deepest',
          input_placeholder_8: 'Raw photos (for selection)',
          input_placeholder_9: 'My music reco (plus five lousy other options)',
        },
        create_deliverable_cancel: 'Cancel',
        create_deliverable_label: 'What will you deliver?',
        create_deliverable_save: 'Save',
        date: {
          updated_today: 'Updated today',
          updated_yesterday: 'Updated yesterday',
        },
        delete_option: 'Delete',
        deliverable_cleared:
          'Cleared all files from <strong><u>%{deliverableName}</u></strong>',
        deliverable_deleted:
          '<strong><u>%{deliverableName}</u></strong> has been deleted',
        deliverable_label: 'Deliverable',
        edit_option: 'Edit',
        edit_prompt: 'Rename this deliverable or add a description',
        empty_deliverable_state: 'No files yet. Coming soon',
        more_option: 'More',
        no_deliverables: {
          heading: 'Add a deliverable<br />to upload files',
        },
        no_deliverables_not_project_owner: {
          heading:
            '%{projectOwner} hasn’t added any deliverables for this project yet.',
        },
        processing_deliverable_state: 'Processing...',
        rename_option: 'Rename',
        share_option: 'Share',
        upload_cancel: 'Cancel',
        upload_files: 'Upload files',
        uploading: 'Uploading...',
        uploading_paused: 'Upload paused...',
        view: 'View',
      },
      errors: {
        blank: 'Das ist nicht das Projekt, nach dem du suchst ...',
        limit:
          'Dein Potenzial ist unendlich, aber du hast dein Zeichenlimit erreicht',
        required:
          'Du weißt, wie es funktioniert. Du kannst das Ausfüllen hier nicht überspringen.',
      },
      event: {
        project_created_byline:
          'Fügen einige Dateien hinzu, um zu zeigen, woran du gerade arbeitest.',
        project_created_title: 'Start des Projekts',
      },
      file_count: {
        one: '%{count} Datei',
        other: '%{count} Dateien',
      },
      just_now: 'genau jetzt',
      labels: {
        description: 'Beschreibung',
        name: 'Name',
        new_name: 'Gib deinem Projekt einen Namen',
      },
      logo: {
        cta: 'Füge ein Logo hinzu',
        errors: {
          dimensions:
            'Dein Logo ist kleiner als 220 x 220 px. Versuche es mit einem größeren Bild.',
          general:
            'Hmm, irgendetwas ist schiefgelaufen. Bitte versuche es nochmal.',
          size: 'Dein Logo ist größer als 5 MB. Versuche es mit einer kleineren Datei.',
          type: 'Dein Logo ist kein JPEG, GIF oder PNG. Versuche es mit einem anderen Bild.',
        },
        instructions:
          'Dein Logo kann bis zu 5 MB groß sein. JPEGs und GIFs sind okay, aber PNGs mit transparentem Hintergrund funktionieren am besten.',
        'instructions-title': 'Zeige deine Marke von ihrer besten Seite',
      },
      name_modal: {
        content_label: 'Gib deinem Projekt einen Namen oder benenne es um',
        input_placeholder_0: 'Definitiv ein Cannes-Löwe',
        input_placeholder_1: 'Ein Heilmittel gegen Erkältung',
        input_placeholder_2: 'Das perfekte Verbrechen',
        input_placeholder_3: 'Ich schreibe Songs, keine Titel',
        input_placeholder_4: 'Preisgekrönte Idee',
        input_placeholder_5: 'Brandneue Marken-Kampagne',
        input_placeholder_6: 'Weltherrschaft',
        save: 'Speichern',
        text: 'Beschreibe, woran du gerade arbeitest.',
        title: 'Gib deinem Projekt einen Namen',
      },
      new_project_label: 'Starte ein neues Projekt',
      noticebar: {
        'button-cancel': 'Abbrechen',
        'button-clear-all-files': 'Alles löschen',
        'button-close': 'Schließen',
        'button-delete': 'Löschen',
        'button-no': 'Nein',
        'button-share': 'Teilen',
        'button-yes': 'Ja',
        'confirm-cancel': 'Übertragung abbrechen?',
        'confirm-clear-files-deliverable':
          'Alle Dateien von <strong><u>%{deliverableName}</u></strong> löschen?',
        'confirm-complete':
          'Hochladen abgeschlossen! Lass alle wissen, dass du weitere Dateien hinzugefügt hast.',
        'confirm-delete-deliverable':
          '<strong><u>%{deliverableName}</u></strong>und alle Dateien, die du darauf hochgeladen hast, löschen?',
        'confirm-first-complete':
          'Upload abgeschlossen! Teile dieses Projekt, damit deine Dateien heruntergeladen werden können.',
        deliverable_not_found_error:
          'Hmm, sieht so aus, als ob das Arbeitsergebnis gelöscht wurde',
        general_error: 'Das hat nicht geklappt. Versuche es bitte noch einmal.',
      },
      'onboarding-promise': {
        description:
          'Gib einen Überblick über die gesamte Arbeit, die du für ein Projekt lieferst und optimiere die Art und Weise, wie du sie teilst. Erstelle eine Liste mit Arbeitsergebnissen, füge dann Dateien hinzu während du Fortschritte machst—ohne verschiedene Download-Links.',
        title: 'Starte auf Kurs, um auf Kurs zu bleiben',
      },
      onboarding: {
        banner:
          'Achtung! Du gehörst zu den wenigen Auserwählten, die Zugriff auf Projects haben, während es noch gebaut (und verbessert) wird. Kann sein, dass wir dich um Feedback bitten werden.',
      },
      pagename: 'Projects',
      placeholders: {
        description: 'Verfasse eine kurze Beschreibung deines Projekts',
        loading: 'Wird geladen ...',
      },
      project: {
        notification: {
          name_saved: 'Name gespeichert! Dein Projekt klingt nach Erfolg.',
        },
      },
      share_button_label: 'Teilen',
      unnamed_project_title: 'Unbenanntes Projekt',
      watch_video: 'Video ansehen',
    },
    transfer: {
      display_name_fallback: 'Übertragung ohne Titel',
      does_not_expire: 'kein <u>Verfallsdatum</u>',
      expires_in: 'Läuft in <span>%{time}</span> ab',
      downloaded_at: 'Heruntergeladen am %{date} um %{time}',
      not_downloaded: 'Noch nicht heruntergeladen',
      email_bounced: 'Mit der Empfängeradresse scheint etwas nicht zu stimmen',
      count_files: {
        one: '%{count} Datei',
        other: '%{count} Dateien',
      },
      sent_datetime: 'Gesendet am %{date} um %{time}',
      never_expires: 'Kein Verfallsdatum',
      and_more: 'Und noch %{count}',
      read_more: 'mehr',
      copy_link: 'Link kopieren',
      message: 'Nachricht',
      total_downloads: 'Downloads insgesamt',
      sent_to_recipients: {
        one: 'Gesendet an %{count} Person',
        other: 'Gesendet an %{count} Personen',
      },
      no_transfers:
        'Alle von dir versendeten Übertragungen werden hier angezeigt',
      add_first_description:
        'Download-Status checken oder Downloads ändern, weiterleiten oder löschen',
      mobile: {
        download: 'Alle Dateien herunterladen',
        remove: 'Übertragung löschen',
      },
      delete_datetime: 'Gelöscht am %{date} um %{time}',
      detail: {
        plus_download_stats:
          'Hol dir Pro, um zu sehen, wie oft deine Übertragungen heruntergeladen wurden.',
        plus_password_expiration:
          'Hol dir Pro, um für deine Übertragungen Passwörter und Verfallsdaten einzustellen.',
        plus_transfer_actions:
          'Hol dir Pro, um deine Übertragungen nach deinen Vorstellungen zu verwalten und zu löschen.',
        title: 'Details zu deinen Übertragungen',
      },
      download_status_email: '%{count} von %{total} Empfängern',
      download_status_email_text: {
        zero: 'Noch nicht heruntergeladen',
        one: '%{count}/%{total} Empfänger(n)',
        other: '%{count}/%{total} Empfänger(n)',
      },
      download_status_link: {
        one: 'einmal',
        other: '%{count} Mal',
      },
      download_status_link_text: {
        zero: 'Noch nicht heruntergeladen',
        one: '1 mal',
        other: '%{count} mal',
      },
      sent_moment: 'Versendet %{moment}',
      total_downloads_tooltip:
        'Nicht das, was du erwartet hast? Wir haben vor kurzem eine kleine Änderung vorgenommen. Diese Zahl zeigt nur abgeschlossene Downloads an.',
      display_name: {
        label: 'Titel',
        label_mobile:
          'Füge einen Titel hinzu, sodass jeder weiß, was deine Übertragung enthält.',
      },
      download_status_received_text: {
        zero: 'Noch nicht heruntergeladen',
        one: 'Heruntergeladen',
        other: 'Heruntergeladen',
      },
      edit_display_name: {
        cancel: 'Abbrechen',
        save: 'Speichern',
        title: 'Titel',
      },
      received_datetime: 'Erhalten am %{date} um %{time}',
      received_from: 'Erhalten von',
      received_moment: 'Erhalten am %{moment}',
      teams: {
        received_by: 'Empfangen von',
        self: 'mir',
        sent_by: 'Gesendet von',
      },
      title: 'Titel',
      set_password: {
        added: 'Zugefügt',
        change: 'Ändern',
        remove: 'Entfernen',
        description:
          'Lege ein Passwort fest, um zu steuern, wer Zugriff auf diese Übertragung hat.',
        remove_warning: 'Passwortschutz von dieser Übertragung entfernen?',
        yes_remove: 'Ja, entfernen',
      },
      set_expiration: {
        description:
          'Lege ein Ablaufdatum fest, um den Zugriff auf diese Übertragung einzuschränken.',
        label: 'Läuft ab in',
      },
      anon_upsell_no_account:
        'Um Downloads für diese Übertragung zu bearbeiten oder zu verfolgen, bevor sie abläuft, <a href="%{href}">registriere dich</a> kostenlos.',
      anon_upsell_found_account:
        'Um Downloads für diese Übertragung zu bearbeiten oder zu verfolgen, bevor sie abläuft, <a href="%{href}">melde dich an</a>.',
      anon_upsell_no_account_with_button:
        'Du kannst diese Übertragung bearbeiten, bevor sie abläuft, indem du ein Konto erstellst.',
      create_free_account: 'Erstelle ein kostenloses Konto',
    },
    transfers: {
      space_used_unlimited: ' %{space} deines Speicherplatzes belegt',
      pagename: 'Übertragungen',
      search: 'Datei suchen',
      search_results: {
        one: '%{count} Suchergebnis',
        other: '%{count} Suchergebnisse',
        none: 'Nichts gefunden',
        retry:
          "Wir konnten leider keine Übertragung finden, die zu deiner Suche passt – versuch's doch noch einmal.",
      },
      space_used: '%{space} von %{totalSpace} genutzt',
      selected_text: {
        one: '%{count} Übertragung ausgewählt (%{size})',
        other: '%{count} Übertragungen ausgewählt (%{size})',
      },
      last_7_days: 'In den letzten 7 Tagen versendet',
      over_7_days: 'Vor mehr als 7 Tagen versendet',
      sort_on: 'Sortieren nach:',
      size: 'Größe',
      name: 'Name',
      date: 'Datum',
      delete: 'Löschen',
      download: 'Herunterladen',
      forward: 'Weiterleiten',
      remove: 'Löschen',
      select: 'Auswählen',
      copy_link: 'Link kopieren',
      sent_time_ago: 'Vor %{timeAgo} versendet',
      files: {
        one: '%{count} Datei',
        other: '%{count} Dateien',
      },
      confirm_transfer_delete:
        'Moment! Willst du diese Übertragung wirklich löschen?',
      confirm_forward:
        'Diese Weiterleitung ersetzt die laufende Übertragung. Fortfahren?',
      confirm_expired_transfer_delete:
        'Die Dateien und Übertragungsinfos werden hierdurch dauerhaft gelöscht. Fortfahren?',
      deleting_now: 'Wir löschen das jetzt für dich',
      deselect_all_transfers: {
        one: 'Auswahl aller Übertragungen aufheben',
        other: 'Auswahl aller %{count} Übertragungen aufheben',
      },
      downloads: 'Downloads',
      expiration: 'Verfallsdatum',
      expiration_next: 'Verfällt in %{days}',
      expiration_no_date: 'Kein Verfallsdatum',
      expiration_not_soon: 'Noch länger verfügbar',
      include_archived_switch_label: 'Archivierte Übertragungen hinzufügen',
      include_archived_switch_tooltip:
        'Bei der Berechnung des noch verfügbaren Speichers wird dies nicht berücksichtigt',
      notify_completed:
        'Übertragung beendet. Du kannst das hier jetzt schließen - oder auch nicht. Wie du magst.',
      preview: 'Vorschau',
      remove_permanently: 'Informationen endgültig löschen',
      search_placeholder: 'Anhand des Dateinamens oder der E-Mail suchen',
      select_all_transfers: {
        one: 'Alle Übertragungen auswählen',
        other: 'Alle %{count} Übertragungen auswählen',
      },
      space_left: 'Noch %{space} von %{totalSpace} verfügbar',
      teams_tip: {
        subtitle:
          'Auf dieser Seite werden dir deine eigenen Übertragungsaktivitäten angezeigt. Nur für den Fall, dass du dir diese Frage stellen solltest: Auch deine Teammitglieder können nur ihre jeweils eigenen Übertragungen einsehen.',
        title: 'Dein Pro Team nimmt Formen an…',
      },
      title: 'Übertragungen senden',
      view_details: 'Details anzeigen',
      edit_display_name: 'Titel bearbeiten',
      received_time_ago: 'Erhalten vor %{timeAgo}',
      search_title_placeholder: 'Nach Titel, Dateiname oder E-Mail suchen',
      see_all: 'Alle (%{count}) anzeigen',
      sender: 'Absender',
      sort_by_title: 'Titel',
    },
    accountinfo: {
      pagename: 'Kontodaten',
      signed_in_as: 'Angemeldet als %{name}',
      sign_out: 'Abmelden',
      paid_on: 'Bezahlt am',
      no_invoices:
        'Deine Rechnungen werden hier angezeigt, aber wie es aussieht hast du noch keine.',
      subscription_info:
        'Dein Pro-Abo für %{deal} wird am %{autorenewal_attempt} automatisch verlängert.',
      payment_success: {
        monthly:
          'Schön – jetzt kannst du WeTransfer Pro einen ganzen Monat lang nutzen',
        monthly_renewal:
          'Schön – jetzt kannst du Pro für einen weiteren Monat nutzen',
        yearly:
          'Schön – jetzt kannst du WeTransfer Pro ein ganzes Jahr lang nutzen',
        yearly_renewal:
          'Schön – jetzt kannst du Pro für ein weiteres Jahr nutzen',
      },
    },
    changepassword: {
      pagename: 'Passwort ändern',
    },
    invoices: {
      pagename: 'Rechnungen',
    },
    reviewbilling: {
      pagename: 'Bitte bestätige deine Zahlungsdaten',
      information:
        'Wenn du deine Zahlungsmethode ändern möchtest, müssen wir gleichzeitig dein Abo verlängern',
      information_payment:
        'Für die nächsten %{period} mit Pro zahlst du %{deal} – dein Abo ist dann bis zum %{expiry} gültig',
    },
    renewbilling: {
      pagename: 'Prüfe deine Daten und verlängere',
    },
    link_downloads_unsubscribe: {
      body: 'Du kannst dich von Mitteilungen über Downloads per Übertragungslink abmelden – mit deiner "Versendet"-Übersicht hast auch danach noch den vollen Überblick über deine Downloads.',
      cta: 'Gehe zu meinen versendeten Übetragungen',
    },
    onboarding: {
      step_two: {
        wallpaper: {
          choose_button: 'Aus Galerie wählen',
        },
        next_button: 'Startklar!',
        description:
          'Du bestimmst den Hintergrund deiner Profil- und Download-Seiten. Nicht schlecht, oder? Lade deinen eigenen Hintergrund hoch oder wähle eines unserer Motive aus.',
      },
      upload_wallpaper: {
        add_text: 'Ein Bild hochladen',
        add_description:
          'Die besten Resultate erhälst du, wenn du ein Bild hochlädst, das 2560 x 1600 Pixel hat. Die Datei darf max. 3 MB groß sein.',
        upload_text: 'Ein Bild oder ein Video hochladen',
      },
      preview: {
        wallpaper_credits_prefix: 'Hintergrundbild durch',
      },
      1: {
        description:
          '&quot;Gestalte das, was deine Empfänger jedes Mal sehen, wenn du ihnen Dateien sendest, auf deine eigene Weise. Und mit deiner eigenen WeTransfer-Seite können dir alle %{transfer_limit} Übertragungen senden—sie brauchen dazu nur deine URL. Deine E-Mail-Adresse wird auf der Seite angezeigt, damit deine Kunden darauf vertrauen können, dass ihre Dateien an dich gesendet werden.<br /><br />\nWähle als erstes deine URL aus.&quot;',
        next: 'Weiter',
        skip: 'Überspringen',
        warning:
          '<strong> Achtung, </strong> du kannst es nachher nicht mehr ändern!',
        'blurb-1':
          'Erstelle deine eigene WeTransfer-Seite, um jedes Mal professionell zu wirken, wenn jemand deine Dateien herunterlädt und mach es (noch) einfacher für alle, dir Übertragungen zu senden.',
        'blurb-2': 'Als erstes wählst du deine URL aus.',
        welcome:
          'Schaffe mit deiner eigenen WeTransfer-Seite optimale Voraussetzungen',
        information:
          'Keine Sorge, du kannst dies später jederzeit unter <strong>Branding</strong> ändern.',
        description_unlimited:
          'Entscheide, was andere zu sehen bekommen, wenn sie dir Dateien senden. Mit deiner eigenen WeTransfer-Seite kann jeder dir Übertragungen von beliebiger Größe senden – du musst ihnen nur deine URL geben. Deine E-Mail-Adresse wird auf der Seite angezeigt, sodass die Besucher der Seite wissen, dass ihre Dateien an dich, und nur an dich gesendet werden.<br /><br /> \nDer erste Schritt: Wähle deine URL.',
      },
      2: {
        description:
          'Du kannst bis zu fünf unterschiedliche Hintergrundbilder für dein Profil wählen.\n\nDamit stehen du oder deine Marke im Mittelpunkt und deine Übertragungen spiegeln deinen Stil wieder',
        pick: 'Aus unserer Galerie auswählen',
        title: 'Mache mit jeder Übertragung einen guten Eindruck',
        upload: 'Dein eigenes Hintergrundbild hochladen',
      },
      3: {
        description:
          '<strong>%{customLink}</strong> ist eingerichtet. Du kannst diesen Link jetzt zu deiner Website hinzufügen. Dann können andere dir %{transfer_limit} Übertragungen senden—und du kannst natürlich auch senden.',
        done: 'Fertig',
        title: 'Was für ein tolles Profil',
        description_unlimited:
          '<strong>%{customLink}</strong> ist eingerichtet. Diesen Link kannst du deiner Website hinzufügen. Andere können dir darüber Übertragungen von beliebiger Größe senden – selbst etwas versenden klappt natürlich auch.',
      },
    },
    contact: {
      add_contact: 'Kontakt hinzufügen',
      add_first_description:
        'Wir speichern hier auch alle E-Mail-Adressen, an die du Dateien sendest',
      add_to_transfer: 'Zur Übertragung hinzufügen',
      remove_from_transfer: 'Aus Übertragung entfernen',
      confirm_delete: {
        one: 'Möchtest du diesen Kontakt wirklich löschen?',
        other: 'Möchtest du diese %{count} Kontakte wirklich löschen?',
      },
      contact_count: {
        one: '%{count} Kontakt',
        other: '%{count} Kontakte',
      },
      edit: 'Bearbeiten',
      mobile: {
        add: 'Kontakt hinzufügen',
      },
      no_contacts: 'Füge deinen ersten Kontakt hinzu!',
      pagename: 'Kontakte',
      remove: 'Löschen',
      search_count: {
        one: '%{count} Suchergebnis',
        other: '%{count} Suchergebnisse',
      },
      search_placeholder: 'Suche nach E-Mail-Adressen, Name oder Firma',
      select: 'Auswählen',
      selected_text: {
        one: '%{count} ausgewählter Kontakt',
        other: '%{count} ausgewählte Kontakte',
      },
      teams_tip: {
        subtitle:
          'Wenn du jemandem eine Übertragung schickst, fügen wir diese Person deiner Kontaktliste hinzu. Jedes Teammitglied baut eine eigene Kontaktliste auf.',
        title: 'Dein Pro Team nimmt Formen an…',
      },
    },
    unsubscribeexpiration: {
      button: 'Abmelden',
      button_unsubscribed: 'Zurück zu WeTransfer',
      description:
        'Du bekommst schon genug E-Mails von uns? Kein Problem! Wenn du willst, schicken wir dir keine Mails mehr in Bezug auf ablaufende Übertragungen.',
      description_unsubscribed:
        'Wir werden dir keine E-Mails mehr über ablaufende Übertragungen schicken',
      no_email: 'dir',
      title: 'Erinnerungsmails abbestellen',
      title_unsubscribed: 'Fertig!',
      downloaded: {
        body: 'Verstanden. Du kannst dich von E-Mails abmelden, die dich daran erinnern, dass deine Übertragungen bald ablaufen, wenn deine Dateien bereits heruntergeladen worden sind. Für Übertragungen, deren Dateien noch nicht heruntergeladen wurden, werden wir dir weiterhin Erinnerungen schicken.',
        cta: 'Abmelden',
        title:
          '"Meine Dateien wurden heruntergeladen. Ich brauche keine E-Mails, die mich daran erinnern, dass meine Übertragungen ablaufen."',
      },
      not_downloaded: {
        body: 'Kein Problem. Du kannst dich von den E-Mails abmelden, die dich daran erinnern, dass deine Übertragungen ablaufen, auch wenn deine Dateien bisher noch nicht heruntergeladen wurden.',
        cta: 'Abbmelden',
        title:
          'Du brauchst keine E-Mails, die dich daran erinnern, dass deine Übertragungen ablaufen?',
      },
      pro: {
        body_1:
          'Gar kein Problem. Du kannst dich von diesen Erinnerungen abmelden. In deinen Übertragungsdetails kannst du immer noch sehen, wann Übertragungen ablaufen und das Verfallsdatum eventuell ändern.',
        body_2:
          'Psst... Hast du deine Meinung geändert oder kommst du irgendwie nicht weiter? Halb so schlimm. Schick uns einfach eine E-Mail an <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a>.',
        cta: 'Abmelden',
        title:
          'Du brauchst keine E-Mails, die dich daran erinnern, dass deine Übertragungen ablaufen?',
      },
    },
    about: {
      legal: {
        actionbar: {
          text: 'Bist du sicher, dass du deine Cookies löschen möchtest?',
        },
      },
    },
    about_plus: {
      checklist: {
        title: 'Auf Pro upgraden für %{currency}%{price}/Monat',
      },
    },
    advertise: {
      gallery: {
        preview: 'Vorschau',
      },
      guidelines: {
        advert_static: {
          title: 'Statische Platzierung',
        },
      },
    },
    billinginfo: {
      pagename: 'Rechnungsinformationen',
    },
    help: {
      button_all_answers: 'Mehr Antworten',
      page_title: 'Schnelle Hilfe',
      read_more: 'Weiterlesen',
      search_button: 'Suchen',
      search_placeholder: 'Womit können wir dir helfen?',
    },
    payment_redirect_loader: {
      title: 'Just a moment',
      subtitle: 'Please resist the temptation to refresh or close this page',
    },
    payment_pending: {
      order_in_progress: 'Wird geladen...',
    },
    payment_update: {
      bancontact: {
        info: 'Nur damit du Bescheid weißt – Zur Überprüfung, ob die von dir eingetragenen Daten korrekt sind, wird Bancontact einmalig einen Betrag von 0,50 € von deinem Konto abbuchen.',
      },
      confirm_update: 'Bestätigen',
      ideal: {
        info: 'Nur damit du Bescheid weißt – Zur Überprüfung, ob die von dir eingetragenen Daten korrekt sind, wird iDEAL einmalig einen Betrag von 0,01 € von deinem Konto abbuchen.',
      },
      info: 'Nur damit du Bescheid weißt – Zur Überprüfung, ob die von dir eingetragenen Daten korrekt sind, wird iDEAL einmalig einen Betrag von 0,01 € von deinem Konto abbuchen.',
      sofort: {
        info: 'Nur damit du Bescheid weißt – Zur Überprüfung, ob die von dir eingetragenen Daten korrekt sind, wird SOFORT einmalig einen Betrag von 1,00 € von deinem Konto abbuchen.',
      },
      title: 'Zahlungsdaten aktualisieren',
      update_in_progress: 'Zahlungsdaten werden aktualisiert...',
    },
    sign_in: {
      account: 'Du hast noch kein Konto?',
      upgrade: 'Auf WeTransfer Pro upgraden',
    },
    signin: {
      account_cta: 'Erstelle ein Konto',
      account_item_1: 'Sende bis zu %{size_limit}',
      account_item_2: 'Verwalte Übertragungen',
      account_item_3: 'Speichere bis zu %{storage_limit}',
      account_subtitle: 'Gratis',
      plus_cta: 'Hol dir WeTransfer Pro',
      plus_item_1: 'Sende bis zu %{size_limit}',
      plus_item_2: 'Verwalte Übertragungen',
      plus_item_3: 'Speichere bis zu %{storage_limit}',
      plus_item_4: 'Deine eigenen Bildschirmhintergründe',
      plus_item_5: 'Eine eigene URL',
      plus_item_6: 'Passwortgeschützte Übertragungen',
      plus_month: '/Monat',
    },
    teams: {
      invitee: {
        action_cancel_invite: 'Einladung zurückziehen',
      },
      invitees: {
        title: 'Eingeladen – Antwort steht noch aus',
      },
      member: {
        action_demote: 'Als Administrator entfernen',
        action_promote: 'Zum Administrator ernennen',
        action_revoke: 'Aus dem Team nehmen',
      },
      members: {
        title: 'In Ihrem Team',
      },
      no_access: {
        description: 'Wir lassen es dich wissen, wenn du sie nutzen kannst. ',
        title: 'Ups, diese Funktion ist wohl noch streng geheim. ',
      },
      subtitle: {
        members: {
          one: '%{count} Mitglied',
          other: '%{count} Mitglieder',
        },
        pending: '%{pendingCount} eingeladen',
      },
      tip: {
        button: 'Erfahren Sie mehr',
        subtitle:
          'Mit unserer "Pro for Teams"-Funktion haben wir die bestmögliche WeTransfer-Erfahrung noch einmal optimiert! Das Hinzufügen neuer Mitglieder ist kostenlos. Nutze hierzu folgendes Formular - sobald deine Einladungen akzeptiert wurden, könnt ihr loslegen!',
        title: 'Lieber Teamwork als One-Man-Show ...',
      },
      title: 'Team',
    },
    transfer_progress: {
      meta: {
        expires_in: 'Läuft in %{expiry} ab',
      },
      recipients: 'Wird versendet an',
      upsell: {
        benefit_one: 'Sehen, wann deine Dateien heruntergeladen wurden',
        benefit_three: 'Alte Übertragungen prüfen und erneut verschicken',
        benefit_two: 'Sehen, wer deine Dateien heruntergeladen hat',
        button: {
          action: 'Mehr erfahren',
          cancel: 'Nein danke!',
        },
        heading: 'Mühelose Verwaltung deiner Übertragungen mit WeTransfer Pro',
        title: 'Details zu deiner Übertragung',
      },
    },
    transferReceived: {
      'empty-description':
        'Hier findest du alle an dich gesendeten Übertragungen — keine Sorge, sie belegen keinen Speicherplatz.',
      'empty-title': 'Deine Übertragungen nachverfolgen',
      empty: {
        description:
          'Hier findest du alle an dich per E-Mail gesendeten oder hochgeladenen Übertragungen – keine Sorge, sie belegen keinen Speicherplatz.',
      },
      banner: {
        freeUser: {
          text: 'Mach ein Upgrade, um Dateien problemlos zu empfangen. Hol dir eine benutzerdefinierte URL <strong>yourname.wetransfer.com</strong> und für Uploads eine Seite, die mit einer Marke versehen ist.',
          link: 'Mehr Info',
          cta: 'Upgrade',
        },
        paidUser: {
          withUrl: {
            text: 'Jeder kann dir unter <strong>%{personalisedUrl}</strong> 200 GB-Übertragungen senden.',
            cta: 'URL kopieren',
          },
          withoutUrl: {
            text: 'Leg deine URL <strong>yourname.wetransfer.com</strong> fest und jeder kann Dateien für dich hochladen.',
            link: 'Mehr Info',
            cta: 'Gehe zu Branding',
          },
        },
      },
    },
    unsubscribeonboarding: {
      action: 'Abmelden',
      back: 'Zurück zu WeTransfer',
      contact:
        'Psst, wenn du irgendwann einmal nicht mehr weiter wissen solltest, dann melde dich einfach: <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a>.',
      done: 'Das wäre erledigt!',
      message:
        'Von unseren erklärenden E-Mails kannst du dich abmelden — keine Sorge, alle wichtigen Infos wirst du dann weiterhin erhalten.',
      title: 'Fängt dein Posteingang schon an zu qualmen?',
    },
    userinfo: {
      pagename: 'Angaben zur Person',
    },
    free_onboarding: {
      close: 'Schließen',
      finish_tour: 'Fertig',
      next: 'Weiter',
      send_files: 'Gehe einfach zu Dateien senden',
      start_tour: 'Sieh, was wir sonst noch haben',
      step_one: {
        body_1:
          'Jetzt, da du deine E-Mail-Adresse für dein Konto verifiziert hast, musst du dies nicht mehr bei jeder Übertragung tun. Keine Verifizierungscodes mehr!',
        body_2:
          'Behalte an einem Ort den Überblick über all deine versendeten und empfangenen Übertragungen. Sieh nach, wie oft deine Dateien heruntergeladen werden. Sende deine Übertragungen erneut, leite sie weiter oder lösche sie mit einem Klick.',
        header_1: 'Einmalig für alles verifiziert',
        header_2: 'Verwalte deine Übertragungen',
        subtitle:
          'Die Zeiten von Verifizierungscodes und verlorenen Download-Links sind vorbei. Mit deinem Konto kannst du ganz einfach große Dateien senden – gratis.',
        title_1: 'Sende Dateien <strong>zu deinen Bedingungen</strong>',
        title_2: 'mit WeTransfer',
      },
      step_three: {
        body_1:
          'Ob es sich um ein Video auf deinem Telefon oder um einen Link auf deinem Desktop handelt, speichere all deine Inspiration an einem Ort. Öffne hierzu Collect mit dem Launcher (das ist das Ding in der oberen linken Ecke) oder verwende den Link unten.',
        cta: 'Gehe zu Collect',
        title_1: '<strong>Inspiration</strong> unterwegs speichern',
        title_2: 'mit Collect',
      },
      step_two: {
        body_1:
          'Präsentiere Ideen. Zeige unfertige Arbeiten. Bleibe synchronisiert. Ohne jemals wieder eine Folie zu formatieren. Öffne hierzu Paste mit dem Launcher (das ist das Ding in der oberen linken Ecke) oder verwende den Link unten.',
        cta: 'Gehe zu Paste',
        title_1: 'Erstelle <strong>Folien in Sekunden</strong>',
        title_2: 'mit Paste®',
      },
    },
    modal: {
      portals_intro: {
        cta: 'Portals ausprobieren',
        pill: 'Brandneues Tool',
        text: 'Voilà hier ist <strong>Portals</strong>, die einfachste Art, die Unterschrift zu bekommen, die du brauchst. Lade Kunden und Partner ein, sich Files anzusehen und Favoriten zu selektieren—ohne Downloads.',
        title: 'Teile deine Arbeit. Empfange Feedback. Alles in einem.',
      },
    },
    not_found: {
      body: 'Kehre zurück zu <a href="https://wetransfer.com/">wetransfer.com</a> oder beglücke deine Netzhaut mit ein paar <a href="https://wepresent.wetransfer.com/">coolen Artikeln aus unserer Feder</a>.',
      image_alt: 'Das hat nicht geklappt',
      title: 'Hoppla, die Seite wurde wohl vom Erdboden verschluckt.',
    },
    password_and_security: {
      title: 'Passwort und Sicherheit',
      'two-factor-authentication': {
        description: {
          enabled: 'Seit %{date}',
        },
        disable: 'Abschalten',
        done: 'Fertig',
        enable: 'Aktivieren',
        get_recovery_codes: 'Wiederherstellungscodes erstellen',
        next_step: 'Weiter',
        recovery_code_action: 'Neue Codes generieren',
        recovery_code_keep_safe:
          'Jeder dieser Codes kann nur einmal verwendet werden, aber bei Bedarf kannst du auch noch mehr bekommen.',
        recovery_code_need_more:
          'Du benötigst mehr Wiederherstellungscodes? Es ist immer möglich, neue Codes zu generieren, deine aktuellen Codes verlieren damit allerdings ihre Gültigkeit.',
        recovery_code_title: 'Deine Wiederherstellungscodes',
        require_password_action: 'Bestätigen',
        require_password_text: 'Trage zum Fortfahren dein Passwort ein',
        step_one_action: {
          app_store: 'Über den App Store downloaden',
          google_play: 'Über Google Play downloaden',
        },
        step_one_label: 'Schritt 1 (von 3)',
        step_one_text:
          'Du benötigst eine Authenticator-App auf deinem Smartphone. Wenn du Google Authenticator (oder eine vergleichbare App) bereits besitzt, klicke auf weiter.',
        step_one_title: 'Google Authenticator herunterladen',
        step_three_label: 'Schritt 3 (du bist startklar!)',
        step_three_text:
          'Für den Fall, dass du dein Smartphone nicht bei dir hast (das soll vorkommen!), kannst du auch diese Wiederherstellungscodes verwenden. Wir werden diese Codes nicht für dich speichern und sie dir später auch nicht noch einmal anzeigen. Schnapp Sie dir also jetzt – und bewahre sie so sicher auf, wie die PIN-Nummer für dein Bankkonto.',
        step_three_text_2:
          'Bewahre diese Codes so sicher auf, wie das Passwort zu deinem Bankkonto! Jeder dieser Codes kann nur einmal verwendet werden.',
        step_three_title: 'Speichere Wiederherstellungscodes',
        step_two_form: {
          error: 'Oh oh, der Code ist falsch oder nicht mehr gültig',
          label: 'Bestätigungscode',
        },
        step_two_label: 'Schritt 2 (Bergfest)',
        step_two_text:
          'Verwende deine Authenticator App, um diesen Strichcode zu scannen. Die App wird einen sechs Zeichen langen Bestätigungscode generieren; trage diesen hier unten ein.',
        step_two_text_mobile:
          'Trage diesen Schlüssel in der Authenticator App ein. Die App wird einen aus sechs Zeichen bestehenden Code generieren; trage diesen Code hier unten ein.',
        step_two_title: 'Scanne den Strichcode',
        step_two_title_mobile: 'Schlüssel eintragen',
        text: {
          protect_account:
            'Nutze dein Telefon, um dein Konto mit einer zusätzlichen Sicherheitsstufe zu schützen.',
        },
        title: 'Zwei-Faktor-Authentifizierung',
      },
    },
    'payment-cancellation': {
      bundle: {
        title: 'Das Beste von Paste® und Collect nutzen',
      },
      cta: 'Nein, ich möchte Pro behalten',
      'cta-2': 'Mein Abonnement kündigen',
      disclaimer: {
        collect:
          'Verkleinert sich dein Speicherplatz in Collect von 200 GB auf 5 GB',
        paste:
          'Kannst du in Paste® nur noch 3 statt unendlich vieler Präsentations-Decks nutzen',
        'team-member':
          'Du wirst aus dem %{currentTeam} auf WeTransfer Pro entfernt.',
        teams:
          'Wird dein %{amountOfMembers} Mann/Frau starkes Team aus dem Team %{currentTeam} auf WeTransfer entfernt',
        title: 'Wenn dein Abo am <strong>%{date}</strong> endet:',
        'transfer-expiry':
          'Werden deine vorhandenen Übertragungen nach 28 Tagen gelöscht',
        'transfer-team-member':
          'Du kannst keine Übertragungen als Teil des Teams senden und empfangen und du kannst keine vorhandenen Team-Übertragungen verwalten.',
      },
      'password-expiry': {
        title:
          'Passwortschutz und selbst gewählte Ablaufdaten für Übertragungen',
      },
      personalization: {
        title: 'Deine eigene WeTransfer-Seite personalisieren',
      },
      portals: {
        text: 'Mit %{planName} kannst du <a href="%{href}" target="_blank">Portals</a> verwenden, um deine Arbeit mit Kunden zu teilen—ganz ohne Downloads.',
        title: 'Arbeit teilen und Feedback erhalten – alles an einem Ort',
      },
      'stay-pro': 'Abonnement behalten',
      'storage-limit': {
        title: '%{storage_limit_pro} an Speicherplatz pro Person nutzen',
      },
      subtitle:
        'Wenn du dein Abo jetzt beendest, ist Folgendes ab dem %{date} nicht mehr möglich:',
      teams: {
        'individual-text':
          '<a href="%{href}" target="_blank">Lade Teammitglieder dazu ein</a>, gemeinsam Übertragungen zu senden, zu empfangen und zu verwalten—oder gratis allein zu arbeiten.',
        'team-member-text':
          'Du wirst aus deinem Team entfernt und ihr könnt nicht mehr gemeinsam Übertragungen senden, empfangen oder verwalten.',
        'team-owner-text':
          'Du hast <a href="%{href}" target="_blank">%{amountOfMembers} Teammitglieder</a>, die nicht mehr in der Lage sein werden, Übertragungen gemeinsam zu senden, zu empfangen oder zu verwalten.',
        title: 'An großen Ideen als Team arbeiten',
      },
      title: 'Möchtest du dich wirklich von %{planName} verabschieden?',
      'transfer-limit': {
        text: 'Momentan kannst du größere Übertragungen senden und empfangen—das ist sehr viel mehr als die kostenlosen %{transfer_limit_free}.',
        title: '100-mal größere Übertragungen senden',
      },
      'transfer-unlimited': {
        text: 'Du kannst Übertragungen ohne Dateigrößenbeschränkung senden (und empfangen) – das ist unendlich viel mehr als mit den kostenlosen %{transfer_limit_free}.',
        title: 'Beliebiges Übertragungsvolumen senden',
      },
    },
    pricing: {
      pro: {
        per_person: 'pro Person',
      },
    },
    pricing_panel: {
      cta: {
        create_account: 'Konto erstellen',
        current_plan: 'Aktuelles Abo',
        sign_up: 'Registrieren',
        switch_premium: 'Zu Premium wechseln',
        switch_pro: 'Pro werden',
        upgrade: 'Upgraden',
      },
      faq: {
        answers: {
          answer_1:
            'Du kannst WeTransfer Pro oder WeTransfer Premium nutzen, sobald du den Bezahlvorgang abgeschlossen hast. Wir schicken dir dann auch eine Bestätigungs-E-Mail, in deren Anhang du die bereits beglichene Rechnung findest.<br /><br />\n\nEinmal angemeldet, kannst du größere Übertragungen senden, Portals nutzen und direkt deine eigene WeTransfer-Seite gestalten. Wenn es zuvor mit einem kostenlosen Konto versendete Übertragungen geben sollte, kannst du frei entscheiden, wann diese ablaufen sollen.',
          answer_2:
            'Wenn du WeTransfer nutzt, kann jede(r) deine Dateien herunterladen – es ist hierzu nicht notwendig, dass sie sich anmelden oder registrieren. Sie müssen nur unsere Nutzungsbedingungen und ggf. unsere Cookies akzeptieren, das ist aber auch schon alles! <br /><br /> \n \nWenn du Arbeit teilen oder in Portals (der neuesten WeTransfer-Funktion) zusammenarbeiten möchtest, brauchen deine Kunden und die am Projekt Mitarbeitenden sich nicht zu registrieren, um Dateien ansehen, Kommentare hinzufügen, ihre Zustimmung erteilen oder deine Dateien herunterladen zu können. Du musst nur dann Teammitglieder an dein Pro- oder Premium-Abo hinzufügen, wenn du möchtest, dass sie Reviews hinzufügen und Portals mit dir gemeinsam gestalten können.',
          answer_3:
            'Mit einem Pro- oder Premium-Abo kannst du deine eigene WeTransfer-Seite erstellen, über die andere dir Dateien entsprechend der für dein Abo geltenden maximalen Dateigröße schicken können. Das bedeutet, dass du benötigte große Dateien von Kunden und an den jeweiligen Projekten Mitarbeitenden problemlos erhalten kannst und dass sie hierfür kein Konto erstellen müssen – sie benötigen hierzu nur die URL deiner Seite. (Es ist möglich, dass wir sie darum bitten, ihre E-Mail-Adresse zu bestätigen, um dich vor "Prinzen aus dem Ausland" zu schützen, die gerne "ihren Reichtum mit dir teilen möchten").',
          answer_4:
            'Zuallererst musst du dich für WeTransfer Pro oder WeTransfer Premium registrieren – mit einem kostenlosen Konto kannst noch keine Teammitglieder hinzufügen. Unabhängig davon, für welches Abo du dich entscheidest, kommen deine Teammitglieder allesamt in den Genuss derselben Vorteile (das heißt, dass du dich beispielsweise nicht selbst für Premium entscheiden und einigen Teammitgliedern Pro-Vorteile gönnen kannst). Teammitglieder können über deine WeTransfer-Seite größere Übertragungen senden und empfangen und Übertragungen auf einer zentralen Übersichtsseite verwalten. <br /><br /> \n \nSobald du dich für das Abo entschieden hast, das am besten zu deinem Team passt, kannst du über deine Einstellungsmenü für die Teamverwaltung so viele Teammitglieder einladen, wie du möchtest. Du kannst deinem Team während der Laufzeit deines Abonnements jederzeit Mitglieder hinzufügen oder Mitglieder löschen.',
          answer_5:
            'Wir akzeptieren sowohl PayPal als auch Kreditkarten der größeren Kreditkartengesellschaften wie Visa, Mastercard und American Express. In manchen Ländern akzeptieren wir auch andere Bezahlsysteme. <br /><br /> \n \nDirekte Banküberweisungen akzeptieren wir nicht, da du dich für für ein wiederkehrendes Jahres- oder Monatsabo registrierst. (Wir werden dich rechtzeitig vor der ersten Erneuerung deines Abos per E-Mail informieren.)',
          answer_6:
            'Wenn dir nicht der unbegrenzte Speicherplatz von WeTransfer Premium zur Verfügung steht, musst du entweder durch das Löschen bereits gesendeter Übertragungen Speicherplatz frei machen oder dein Abo upgraden. Vorher wirst du nicht in der Lage sein, neue Übertragungen zu senden. <br /><br /> \n \nWenn du WeTransfer kostenlos nutzt, werden all deine Übertragungen von bis zu 2 GB automatisch nach 7 Tagen gelöscht. Um deine Speicherplatzkapazität brauchst du dir also keine Sorgen zu machen, denn die kannst du auf diesem Weg nicht überschreiten.',
          answer_6_variant_asterisk:
            'Du musst etwas Speicherplatz frei machen und entweder einige deiner gesendeten Übertragungen löschen oder deinen Plan aktualisieren. Bis du das getan hast, kannst du keine neuen Übertragungen senden. <br /><br />\n\nWenn du ein Premium-Abonnement hast und 5 TB erreichst, kannst du dich an unser Support-Team wenden und mehr Speicherplatz bis zu einem maximalen jährlichen Limit von 15 TB beantragen. <br /><br />\n\nWenn du WeTransfer kostenlos nutzt, werden alle deine gesendeten Übertragungen von bis zu 2 GB nach 7 Tagen automatisch gelöscht. Mach dir also keine Sorgen, du kannst deinen verfügbaren Speicherplatz nicht überschreiten.',
          answer_6_variant_limited_storage:
            'Du musst etwas Speicherplatz frei machen und entweder einige deiner gesendeten Übertragungen löschen oder ein Upgrade deines Plans durchführen (es sei denn, du hast ein Premium-Abonnement). Bis du das getan hast, kannst du keine neuen Übertragungen senden. <br /><br />\n\nWenn du WeTransfer kostenlos nutzt, werden alle deinen gesendeten Transfers von bis zu 2 GB nach 7 Tagen automatisch gelöscht. Mach dir also keine Sorgen, du kannst deinen verfügbaren Speicherplatz nicht überschreiten.',
          answer_7:
            'Dein Abonnement wird automatisch erneuert (wir informieren dich vor der ersten Erneuerung deines Abos rechtzeitig per E-Mail), aber du kannst dein Abo zu jedem Zeitpunkt beenden.<br /><br /> \n \nDer Wechsel zur Nutzung von WeTransfer mit einem kostenlosen Konto ist ganz einfach. Öffne hierzu deine <strong>Konto</strong>einstellungen und beende dein Abonnement. Du (und eventuelle Teammitglieder) können dein Pro- oder Premium-Abo bis zum Ende der aktuellen Abonnementlaufzeit weiterhin nutzen.',
          answer_8:
            'Millionen von Menschen weltweit vertrauen WeTransfer und sie vertrauen unseren Tools, die Ideen in Bewegung bringen. Jeden Monat werden über unsere Filesharing-Plattform 2 Milliarden Dateien von 80 Millionen Menschen geteilt.<br /><br /> \n\nUm dafür zu sorgen, dass deine Ideen nicht angegriffen oder ausgenutzt werden, werden sie verschlüsselt, wenn sie übertragen (TLS) und wenn sie gespeichert (AES-256) werden. Nachdem deine Dateien gespeichert wurden, ist ein Zugriff darauf nur über den jeweiligen einzigartigen Link möglich, den der Sender und der/die Empfänger*innen von Übertragungen erhalten.',
        },
        questions: {
          question_1:
            'Was passiert, nachdem ich mich registriert und bezahlt habe?',
          question_2: 'Müssen meine Empfänger sich registrieren?',
          question_3: 'Kann jede(r) mir größere Übertragungen schicken? ',
          question_4: 'Wie entferne/füge ich Teammitglieder hinzu?',
          question_5: 'Welche Zahlungsmethoden kann ich nutzen?',
          question_6:
            'Was passiert, wenn ich meine maximale Speicherplatzkapazität erreiche?',
          question_7: 'Wie beende ich mein Abo?',
          question_8: 'Kann ich WeTransfer vertrauen? Wie sicher ist es?',
        },
        title: 'FAQ',
      },
      feature_table: {
        branding: {
          features: {
            advertising: 'Werbung (und Kunst)',
            custom: 'Hochladen von eigenen/m',
            feature_1: 'Selbst gestaltete WeTransfer-Seite',
            feature_2: 'Wallpaper-Hintergründe',
            feature_3: 'Personalisierte WeTransfer-E-Mails',
          },
          title: 'Zeige deine Marke von ihrer besten Seite',
        },
        bundle: {
          collect: {
            storage: '%{collectStorageLimit} Speicherplatz',
            title: 'Collect von WeTransfer',
          },
          paste: {
            limited_decks:
              'Bis zu %{pasteDecksLimit} Präsentations-Decks mit standardmäßigem Paste-Logo',
            title: 'Paste® von WeTransfer',
            unlimited_decks: 'Unbegrenzt viele Decks mit eigenem Branding',
          },
          title: 'Vervollständige deinen kreativen Werkzeugkasten',
        },
        expiry: 'Übertragungen laufen nach %{days} ab',
        extra_storage: 'Zusätzliche %{storageLimit} pro Person',
        monthly_price: '%{price} monatlich pro Person',
        portals: {
          features: {
            feature_1: 'Portals',
            feature_2: 'Reviews',
            feature_3: 'Kunden-Branding',
          },
          title: 'Feedback und Zustimmung für Arbeiten einholen',
        },
        security: {
          features: {
            feature_1: 'Individuelle Ablaufdaten',
            feature_2: 'Passwortschutz für Übertragungen',
            feature_3: 'Dateiverschlüsselung',
            feature_4: 'Zwei-Faktor-Authentifizierung',
          },
          title: 'Schütze deine Übertragungen',
        },
        storage_limit: '%{storageLimit} pro Person',
        teams: {
          features: {
            feature_1: 'Lade Teammitglieder ein',
            feature_2: 'Geteilte Übertragungsübersicht',
            feature_3: 'Geteilter Speicherplatz',
            feature_4: 'Geteiltes Branding',
          },
          title: 'Liefere Arbeiten als Team',
          subtext: {
            text: 'Wird nur unterstützt, wenn du ein Abonnement von unserer Website kaufst.',
            learn_more: 'Mehr Info',
          },
        },
        tooltips: {
          tooltip_1:
            'Alle von dir versendeten Übertragungen verringern deinen Speicherplatz',
          tooltip_10:
            'Du kannst Dateien mit TLS- und AES-256-Verschlüsselung sicher versenden und speichern',
          tooltip_11:
            'Gemeinsam Downloads nachverfolgen und Übertragungen verwalten',
          tooltip_12:
            '(Team-)Arbeit präsentieren mit Marken-Hintergründen und -E-Mails.',
          tooltip_13:
            'Paste ist ein Präsentations-Tool, das für dich Decks mit responsiven Farben sowie responsiver Anordnung und responsivem Layout erstellt',
          tooltip_14:
            'Collect ermöglicht es dir, Bilder, Videos, Musik und Links geräteübergreifend zu verwalten',
          tooltip_2:
            'Andere können deine Dateien herunterladen, ohne sich anzumelden oder zu registrieren',
          tooltip_3:
            'Behalte die Übersicht darüber, wer deine Dateien heruntergeladen hat (und wer nicht)',
          tooltip_4: 'Verwalte deine Arbeit für jeden Kunden und jedes Projekt',
          tooltip_5:
            'Lade Kunden dazu ein, sich Dateien anzusehen, Kommentare hinzuzufügen und Vorschlägen zuzustimmen – ganz ohne etwas herunterladen zu müssen',
          tooltip_6:
            'Füge ein Logo und einen Titel hinzu und richte deine Portals kundenspezifisch ein',
          tooltip_7:
            'Deine WeTransfer-Seite ist der Ort, über den andere deine Dateien herunterladen und dir Übertragungen in Übereinstimmung mit dem maximalen Übertragungsvolumen deines Abos senden können',
          tooltip_8:
            'Hintergründe sind die Videos und Bilder, die du im Hintergrund siehst, wenn du Dateien auf wetransfer.com versendest oder empfängst',
          tooltip_9:
            'Wow, wir hätten nicht gedacht, dass jemand das hier lesen würde – du hast uns eines Besseren belehrt. Glückwunsch! Bildschirmfotos werden von @WeTransfer möglicherweise retweetet.',
        },
        transfer_classic: {
          features: {
            feature_1: 'Beschränkung des Übertragungsvolumens',
            feature_2: 'Speicherplatz',
            feature_3: 'Downloads ohne Konto',
            feature_4: 'Downloads nachverfolgen',
            feature_5: 'iOS-App',
          },
          title: 'Große Dateien senden',
        },
        unlimited: 'Unbegrenzt',
        yearly_price: '%{price} jährlich pro Person',
      },
      header: {
        subtitle:
          'Ganz gleich, ob das Versenden großer Dateien für dich reines Privatvergnügen oder Teil deiner Arbeit ist – mit WeTransfer sorgst du dafür, dass deine kreativen Projekte in Bewegung bleiben.',
        title: {
          english_1: 'Du hast die Ideen,',
          english_2: 'wir haben die Abos',
          general: 'Abos und Preise',
        },
      },
      plans: {
        billing: {
          discount: 'Spare %{percentage} (nice)',
          monthly: 'Monatliche Zahlung',
          yearly: 'Jährliche Zahlung',
        },
        free: {
          subtitle: 'Versende Dateien von Zeit zu Zeit',
          title: 'Gratis',
          usp: {
            feature_1: 'Sende bis zu %{transferLimit}',
            feature_2: 'Kein Bestätigen von Übertragungen mehr',
          },
        },
        premium: {
          subtitle: 'Teile Arbeit ohne Einschränkung',
          title: 'Premium',
          usp: {
            feature_1: 'Keine Größenbeschränkung beim Übertragungsvolumen',
            feature_2: 'Unbegrenzter Speicherplatz',
            feature_2_subtitle:
              '*Das anfängliche Limit beträgt %{storageLimit}, mit der Option, auf Anfrage zusätzlichen Speicherplatz hinzuzufügen. Es gilt eine jährliche Höchstgrenze von %{annualStorageLimit}. Weitere Informationen findest du in unseren <a href="/legal/terms" data-route-type="premium" target="_blank">Nutzungsbedingungen</a>.',
            feature_3: 'Unbegrenzt viele Portals und Reviews',
          },
        },
        pro: {
          subtitle: 'Versende wirklich große Dateien regelmäßig',
          title: 'Pro',
          usp: {
            feature_1: 'Versende und empfange bis zu %{transferLimit}',
            feature_2: '%{storageLimit} Speicherplatz pro Person',
            feature_3: '%{portalsLimit}-Portal, unbegrenzt viele Reviews',
          },
        },
        tagline: {
          free: 'Kein Geld, kein Problem',
          monthly: 'monatlich pro Person',
          yearly: 'jährlich pro Person',
          per_person_monthly: 'pro Person, monatlich abgerechnet',
          per_person_yearly: 'pro Person, jährlich abgerechnet',
          tax_included: 'Inklusive Steuern',
        },
        title: 'Abo auswählen',
        month: 'Monat',
      },
      skip_link: 'Mehr Funktionen ansehen',
    },
    pro_classic: {
      hero: {
        cta_1: 'Mehr Info',
      },
    },
    splashpage: {
      bundle: {
        title_new: 'Du hast die Ideen, wir die Abos',
      },
      cta: 'Ich möchte nur Dateien senden',
      free_panel: {
        cta: 'Jetzt anmelden',
      },
      plan: {
        free: {
          feature_1: 'Versende bis zu <strong>%{transfer_limit}</strong>',
          feature_2: 'Kein Bestätigen von Übertragungen mehr',
          subtitle_new: 'Für gelegentliche Dateiversender',
          title: 'Gratis',
        },
        pro: {
          feature_1:
            'Verschicke und empfange bis zu <strong>%{transfer_limit}</strong>',
          feature_2: 'Entscheide, wann Übertragungen ablaufen',
          feature_5: '1 TB Speicherplatz pro Person',
          subtitle_new: 'Für professionelle Nutzer und Teams',
          title: 'Pro',
        },
      },
      reciever: {
        free: {
          cta: 'Jetzt registrieren',
          descripttion: 'Behalte deine Übertragungen im Blick',
          feature_1: 'Sende bis zu 2 GB',
          feature_2: 'Empfange Übertragungen in einer Übersicht',
          title: 'Gratis',
        },
        pro: {
          cta: 'Mehr erfahren',
          descripttion: 'Hol dir das Beste von WeTransfer',
          feature_1: 'Sende und empfange bis zu %{transfer_size}',
          feature_2: '%{storage_size} Übertragungs-Speicherplatz pro Person',
          feature_3: 'Sende Übertragungen mit individuellen Einstellungen',
          title: 'Pro',
        },
        title:
          'Lass nicht zu, dass Übertragungen in deinem Posteingang verloren gehen.',
      },
      title: 'Hol das Beste aus dem neuen WeTransfer',
    },
    teamsettings: {
      invite: {
        cta: 'Team einladen',
        pagename: 'Team einladen',
      },
      manage: {
        cta: 'Team verwalten',
      },
      members:
        'Du hast %{amountOfMembers} Team-Mitglieder. <a href="%{href}">%{cta}</a>',
      no_members:
        'Aktuell noch eine One-(Wo)man-Show! <a href="%{href}">%{cta}</a>',
      settings: {
        pagename: 'Team-Einstellungen',
      },
    },
    universal_onboarding: {
      team_feature: {
        subtitle: 'Gemeinsam als Team übertragen',
        context:
          'Übertragungen als Team senden und empfangen, mit gemeinsamem Speicherplatz, Branding und Zugriff auf die jeweils anderen Übertragungen.',
        invite_team: 'Team einladen',
        dismiss: 'Vielleicht später',
      },
      feature_highlight: {
        free_context:
          "Du kannst jetzt versendete und empfangene Übertragungen in einer einfachen Übersicht verwalten und wirst direkt informiert, wenn deine Dateien heruntergeladen werden. Mit einem Klick kannst du deine Übertragungen erneut senden, weiterleiten oder herunterladen. Viel einfacher geht's nicht.",
        free_subtitle: 'All deine Übertragungen an einem Ort',
        paste_collect_link:
          'Gehe zu <a href="%{pasteUrl}" rel="external">%{pasteName}</a> oder zu <a href="%{collectUrl}" rel="external">%{collectName}</a>',
        premium_context:
          'Du kannst ab sofort beliebig große Übertragungen versenden und deine eigene <b>WeTransfer-Seite</b> erstellen. Bestimme selbst, was andere sehen, wenn sie deine Dateien herunterladen. Bist du startklar, um deine URL und Hintergründe auszuwählen?',
        premium_cta: 'Seite erstellen',
        premium_dismiss: 'Vielleicht später',
        premium_subtitle: 'Richte deine WeTransfer-Seite ein',
        premium_team_context:
          'Du kannst ab sofort beliebig große Übertragungen über deine teameigene WeTransfer-Seite senden und empfangen.',
        pro_context:
          'Du kannst jetzt bist zu %{transfer_limit} auf einmal versenden und deine eigene <b>WeTransfer-Seite</b> erstellen. Bestimme selbst, was andere sehen, wenn sie deine Dateien herunterladen. Bist du startklar, um deine URL und Hintergründe auszuwählen?',
        pro_team_context:
          'Du kannst ab sofort %{transfer_limit}-Übertragungen über deine  <b>teameigene WeTransfer-Seite</b> senden und empfangen.',
        send_cta: 'Gehe zu gesendete Dateien',
        team_subtitle: 'Liefere kreative Arbeit als Team',
      },
      marketing: {
        context:
          'Jetzt, da wir dich ein wenig besser kennen, würden wir dir auch gerne etwas mehr über uns erzählen. Wie wäre es z. B. mit Geschichten über Kreativität und die letzten WeTransfer-Neuigkeiten?',
        image_alt_text:
          'Exemplarische E-Mail-Texte, einschließlich neuer Produktfunktionen, Branchenberichten und WePresent-Artikeln, die Geschichten über Kreativität erzählen.',
        opt_in: 'Ja gerne',
        opt_out: 'Nein danke',
        unsubscribe:
          'Du kannst dich später jederzeit wieder abmelden – nichts für ungut.',
      },
      welcome: {
        context:
          'Es hilft uns, unsere Dienstleistung zu verbessern, wenn wir dich etwas besser kennenlernen.',
        cta: 'Weiter',
        dismiss: 'Überspringen',
        dropdown_options: {
          architecture: 'Architektur / Bauwesen',
          data: 'Daten / Finanzen / Rechtswesen',
          design: 'Design/Abbildung',
          education: 'Bildung / Weiterbildung',
          marketing: 'Marketing/PR',
          music: 'Musik / Sound',
          other: 'Anders (und stolz darauf)',
          photography: 'Fotografie',
          product: 'Produkt / Software',
          sales: 'Sales / Kundenbeziehungen',
          video: 'Video/Animationen',
        },
        free_tier_title: 'Willkommen bei WeTransfer, %{name}!',
        placeholder: 'Okay, mal sehen...',
        question:
          'Zunächst würden wir gerne wissen, in welcher Branche du arbeitest.',
        team_title: 'Du bist Teil des Teams, %{name}!',
        tier_title: 'Willkommen bei WeTransfer %{tier}, %{name}!',
        data_opt_in: {
          checkbox_label:
            'Lass WeTransfer deine Daten verwenden, um dir Werbung, dir zu dir passt, auf unseren Websites und außerhalb davon zu zeigen.',
          tooltip_anchor: 'Was bedeutet das?',
          tooltip: {
            title: 'Wie verwendet WeTransfer meine Daten?',
            p1: 'Wir verwenden deine E-Mail-Adresse, um dir (und anderen wie dir) WeTransfer-Werbung auf den von dir besuchten Websites zu zeigen, z. B. in den sozialen Medien.',
            p2: 'Wir nutzen auch dein Arbeitsfeld, um dir ein besseres Erlebnis auf unseren Websites zu bieten.',
            p3: 'Die Daten, die du uns zur Verfügung stellst, sind zu jeder Zeit sicher.',
            button: 'Alles klar',
          },
        },
      },
    },
    workspace_bar: {
      tooltip_text: 'Füge andere zu deinem Arbeitsbereich hinzu',
      workspace: 'Arbeitsbereich',
      manage_workspace: 'Arbeitsbereich verwalten',
    },
  },
  exception: {
    activate_subscription_exception:
      'Hmm, irgendetwas ist schiefgelaufen – bitte versuch\'s nochmal oder kontaktiere unser &gt;<a href="https://wetransfer.zendesk.com" rel="external">Hilfecenter</a>',
    complete_payment_exception:
      'Hmm, irgendetwas ist schiefgelaufen – bitte versuch\'s nochmal oder kontaktiere unser &gt;<a href="https://wetransfer.zendesk.com" rel="external">Hilfecenter</a>',
    retrieve_checkout_exception:
      'Hmm, irgendetwas ist schiefgelaufen – bitte versuch\'s nochmal oder kontaktiere unser <a href="https://wetransfer.zendesk.com" rel="external">Hilfecenter</a>',
    source_id_error:
      "Sorry, wir konnten diese Anfrage nicht ausführen – bitte versuch's nochmal",
    three_d_secure:
      'Wir unterstützen momentan keine 3D Secure-Kartenidentifizierung.',
    something_went_wrong:
      'Hmm, irgendetwas ist schiefgelaufen – bitte versuch\'s nochmal oder kontaktiere unser <a href="https://wetransfer.zendesk.com" rel="external">Hilfecenter</a>',
    signin_no_data_exception:
      "Hmm, irgendetwas ist schiefgelaufen – bitte check deinen Benutzernamen und dein Passwort, und versuch's nochmal",
    signin_exception:
      "Sorry, wir konnten dich nicht einloggen – bitte versuch's nochmal",
    signout_exception:
      'Hmm, wir konnten dich anscheinend nicht ausloggen. Seltsam. Bitte lade diese Seite neu, um zu sehen, ob du noch eingeloggt bist.',
    signup_account_error:
      "Hmm, bei deiner Anmeldung ist irgendetwas schiefgelaufen – bitte check deine Daten und versuch's nochmal",
    retrieve_account_exception:
      "Hmm, irgendetwas ist schiefgelaufen. Ist uns echt unangenehm, aber könntest du's bitte nochmal versuchen?",
    update_account_error:
      "Sorry, wir konnten deine Kontodaten nicht aktualisieren. Bitte versuch's nochmal!",
    retrieve_subscription_exception:
      "Deine Zahlungsdaten wurden nicht gefunden – bitte versuch's nochmal",
    update_subscription_exception:
      'Wir konnten deine Zahlungsdaten nicht aktualisieren – bitte versuch\'s nochmal oder kontaktiere unser <a href="https://wetransfer.zendesk.com" rel="external">Hilfecenter</a>',
    autorenewal_not_supported:
      'Automatische Verlängerung wird für dieses Konto nicht unterstützt',
    email_background_upload_validation_error:
      "Die Datei ist zu groß oder wurde nicht im png- oder jpg-Format gespeichert – versuch's bitte mit einem anderen Bild",
    email_background_upload_validation_error_videos:
      "Die Datei ist zu groß oder wurde nicht im png- oder jpg-Format gespeichert – versuch's bitte mit einem anderen Bild",
    update_password_exception:
      "Sorry, wir konnten dein Passwort nicht aktualisieren – bitte versuch's nochmal",
    retrieve_device_exception:
      "Wir konnten keine verbundenen Geräte finden. Nicht ein einziges! Bitte versuch's nochmal.",
    remove_device_exception: 'Wir konnten dieses Gerät nicht entfernen',
    renew_subscription_exception:
      "Wir können dein Abo im Moment nicht verlängern – bitte versuch's später nochmal",
    invoices_retrieve_exception:
      "Deine Rechnungen wurden nicht gefunden – bitte versuch's nochmal",
    invoice_download_exception:
      "Diese Rechnung wurde nicht heruntergeladen – bitte versuch's nochmal",
    image_not_valid:
      'Hmm, dieses Bild kann anscheinend nicht hochgeladen werden',
    update_profile_error:
      "Hmm, wir konnten dein Profil nicht aktualisieren – bitte versuch's nochmal",
    retrieve_profile_exception:
      "Wir konnten deine Profileinstellungen nicht finden – bitte versuch's nochmal",
    s3_exception:
      "Hmm, irgendetwas ist während des Hochladens schiefgelaufen – bitte versuch's nochmal",
    file_size_limit_reached:
      'Größer ist nicht immer besser – die maximale Bildgröße ist 3 MB',
    retrieve_transferlist_exception:
      'Wir konnten die Liste mit deinen Übertragungen nicht finden',
    retrieve_transfer_exception:
      'Wir konnten die Übertragungsdetails nicht finden',
    delete_transfer_exception: 'Wir konnten diese Übertragung nicht löschen',
    delete_transfers_exception: 'Wir konnten diese Übertragungen nicht löschen',
    update_expiry_exception:
      'Wir konnten dieses Verfallsdatum nicht aktualisieren',
    add_contact_exception: 'Wir konnten diesen Kontakt nicht hinzufügen',
    complete_last_order_exception:
      'Wir konnten deine Bestellung nicht ausführen',
    edit_contact_exception: 'Wir konnten diesen Kontakt nicht aktualisieren',
    remove_contact_exception: 'Wir konnten diesen Kontakt nicht löschen',
    request_password_reset_exception:
      "Sorry, wir konnten das Passwort nicht zurücksetzen – bitte versuch's nochmal",
    request_password_reset_no_user:
      "Wir erkennen diese E-Mail-Adresse leider nicht. Bitte überprüf sie und versuch's nochmal",
    reset_password_error:
      "Beim Zurücksetzen deines Passworts ist etwas schiefgelaufen – bitte versuch's nochmal",
    reset_password_exception:
      "Sorry, wir können das Passwort im Augenblick nicht zurücksetzen – bitte versuch's nochmal",
    reset_password_token_invalid:
      'Hmm, dieser Link hat nicht funktioniert – bitte folge den Anweisungen, die wir dir gemailt haben, oder fang nochmal von vorne an',
    retrieve_last_order_exception: 'Wir konnten deine Bestellung nicht finden',
    retrieve_ternot_exception:
      "Hmm, wir können deine Übertragung nicht finden – bitte versuch's nochmal",
    signin_invalid_credentials:
      "E-Mail-Adresse und Passwort passen nicht zusammen – bitte check sie nochmal und versuch's erneut",
    unsubscribe_expiration_exception:
      "Irgendetwas ist bei der Abmeldung schiefgelaufen – bitte versuch's nochmal",
    unsubscribe_expiration_invalid_signature:
      "Hmm, der Link zur Abmeldung hat nicht funktioniert – bitte versuch's nochmal",
    cancel_subscription_exception:
      'Wir konnten dein Abo noch nicht beenden, weil etwas schiefgegangen ist. Versuch es bitte später noch einmal.',
    payment_cancelled:
      'Hmm, irgendetwas ist schiefgelaufen – bitte versuch\'s nochmal oder kontaktiere unser <a href="https://wetransfer.zendesk.com" rel="external">Hilfecenter</a>',
    profile_picture_upload_validation_error:
      "Die Datei ist zu groß oder wurde nicht im png- oder jpg-Format gespeichert – versuch's bitte mit einem anderen Bild",
    reactivate_subscription_exception:
      'Etwas ist schiefgelaufen. Probiere es bitte nochmal.',
    retrieve_contactlist_exception:
      'Wir konnten deine Kontaktliste nicht finden',
    source_retrieve_error:
      'Hmm, irgendetwas ist schiefgelaufen – bitte versuch\'s nochmal oder kontaktiere unser <a href="https://wetransfer.zendesk.com" rel="external">Hilfecenter</a>',
    token_error: 'Da ist etwas schiefgegangen. Nochmal versuchen?',
    update_user_error:
      'Beim Aktualisieren deiner Informationen ist ein Problem aufgetreten',
    wallpaper_upload_validation_error:
      "Die Datei ist zu groß oder wurde nicht im png- oder jpg-Format gespeichert – versuch's bitte mit einem anderen Bild",
    wallpaper_upload_validation_error_videos:
      'Ups, es sieht ganz danach aus, als wenn dein Video unsere Anforderungen noch nicht erfüllt — versuch es noch einmal',
    declined_contact_bank_error:
      'Sorry, diese Zahlung konnte nicht verarbeitet werden – wende dich bitte an deine Bank',
    invalid_password: 'Das Passwort wurde nicht erkannt',
    otp_token_invalid: 'Oh oh, der Code ist falsch oder nicht mehr gültig',
    projects_load_exception: 'Wir können deine Projekte zurzeit nicht laden',
    update_information_throttle:
      'Beim Aktualisieren deiner Informationen ist ein Problem aufgetreten. Mache eine %{throttle_time} Pause, bevor du es erneut versuchst.',
    price_amount:
      'The transfer price must be greater than %{currencySymbol}1.00 and less than %{currencySymbol}999',
  },
  navigation: {
    about_us: {
      items: {
        products: 'Produkte',
        plans_and_pricing: 'Abos und Preise',
        pricing: 'Preise',
        pro_and_premium: 'WeTransfer Pro und Premium',
        about: 'WeTransfer',
        plus: 'Pro',
        apps: 'Apps',
        advertise: 'Werben',
        upgrade: 'Upgraden',
      },
      name_1_2019: 'Unternehmen',
      name: 'Unternehmen',
    },
    home: {
      name: 'Startseite',
    },
    help: {
      name: 'Hilfe',
    },
    got_plus: {
      name: 'Got Pro?',
    },
    signed_in: {
      name: 'Pro',
    },
    user: {
      items: {
        transfers: 'Übertragungen',
        contacts: 'Kontakte',
        profile: 'Profile',
        account: 'Konto',
        received: 'Empfangen',
        sent: 'Gesendet',
        teams: 'Team',
        projects: 'Projects',
      },
    },
    feedback: {
      name: 'Feedback',
    },
    sign_out: 'Abmelden',
    signin: {
      name: 'Anmelden',
    },
    branding: 'Branding',
    label: {
      beta: 'Beta',
      new: 'Neu',
    },
    login: 'Einloggen',
    logout: 'Abmelden',
    portals: 'Portals',
    signup: 'Registrieren',
    features: {
      name: 'Funktionen',
      all: 'Alle Funktionen',
      file_sharing: 'Für das Teilen von Dateien',
      collaboration: 'Für die Zusammenarbeit',
      security: 'Für die Datensicherheit',
      branding: 'Für das Branding',
      fast_feedback: 'Für schnelles Feedback',
    },
    referral: 'Freunde empfehlen',
    switcher: {
      create_free_account: 'Gratis hinzufügen',
      just_you: 'Du allein',
      team: 'Team',
      team_member_count: '%{amountOfMembers} Mitglieder',
    },
  },
  transfer: {
    bubble: {
      errors: {
        no_internet: 'Hmm, du bist nicht mit dem Internet verbunden',
        begins_space:
          "Dateien, deren Namen mit einem Leerzeichen beginnen, können wir leider nicht übertragen. Bitte benenn sie um und versuch's nochmal.",
        begins_stop:
          "Dateien, deren Namen mit einem Punkt beginnen, können wir leider nicht übertragen. Bitte benenn sie um und versuch's nochmal.",
        blocked:
          'Wir können WeTransfer nicht laden – anscheinend wird die Seite blockiert',
        generic: 'Leider ist während deiner Übertragung etwas schiefgelaufen',
        has_blackslash:
          "Dateien, deren Namen einen Backslash enthalten, können wir leider nicht übertragen. Bitte benenn sie um und versuch's nochmal.",
        has_linebreak:
          "Dateien, deren Namen einen Zeilenumbruch enthalten, können wir leider nicht übertragen. Bitte benenn sie um und versuch's nochmal.",
        incorrect_recipient:
          'Eine der E-Mail-Adressen, die du eingegeben hast, scheint falsch zu sein',
        incorrect_sender:
          'Es scheint ein Problem mit deiner E-Mail-Adresse zu geben',
        io_error: 'Mit deinen Dateien gibt es ein Problem',
        long_filename:
          "Dateien, deren Namen länger als 250 Zeichen sind, können wir leider nicht übertragen. Bitte benenn sie um und versuch's nochmal.",
        long_message:
          'Diese Nachricht ist leider ein bisschen zu lang geraten – bitte versuch dich kürzer zu fassen',
        missing_default_recipient:
          'Du kannst mehr als %{free_transfer_limit} nur an die registrierte WeTransfer Pro-E-Mail-Adresse senden. Lade die Seite neu, wenn du von vorne beginnen willst.',
        no_clipboard: 'Sieht so aus, als hättest du den Link nicht kopiert',
        no_files:
          'Sieht so aus, als hättest du noch keine Dateien hinzugefügt!',
        no_folders:
          'Du musst den Ordner komprimieren, damit wir ihn übertragen können',
        no_recipient:
          'Wir brauchen die E-Mail-Adresse, an die diese Daten gesendet werden sollen',
        no_sender:
          'Jetzt brauchen wir nur noch deine E-Mail-Adresse und dann sind wir soweit',
        too_big:
          'Holla! Wir können nur bis zu %{upload_limit} pro Übertragung senden',
        too_many_recipient:
          'Ups, es können maximal %{count} Empfänger eingetragen werden. An mehr Leute verschicken? Dann kannst du unsere Übertragung per Link nutzen.',
        unavailable:
          'Sorry, diese Übertragung wurde gelöscht und ist nicht länger verfügbar',
        wrong_password:
          "Hmm, das Passwort ist leider falsch. Bitte versuch's nochmal oder frag bei der Person nach, die dir diese Dateien gesendet hat.",
        default_title: 'Hoppla!',
        duplicate_filename:
          "Dateien mit dem gleichen Namen, können wir nicht senden. Bitte benenn sie um und versuch's nochmal.",
        firstaccept:
          'Vor dem Abschicken musst du das Ganze erst noch bestätigen',
        not_downloadable:
          "Hmm, beim Herunterladen deiner Dateien ist etwas schiefgelaufen. Bitte lade die Seite neu und versuch's nochmal.",
        recaptcha: {
          text: 'Das ging in die Hose. Versuch es bitte noch einmal!',
          title: 'Oh, oh...',
        },
        too_big_text:
          'Du kannst nicht mehr als %{upload_limit} auf einmal verschicken. Mit Pro hingegen sind Übertragungen bis zu %{plus_limit} möglich. ',
        too_big_title: 'Hallo Schwerlastversender',
        too_many_files:
          'Du kannst nicht mehr als %{count} Dateien gleichzeitig verschicken',
        too_many_recipient_text:
          'Mit Pro kannst du Dateien an bis zu 50 Empfänger senden.',
        too_many_recipient_title: 'Das sind zu viele Empfänger',
        unavailable_forward:
          'Es sieht leider so aus, als sei diese Übertragung gelöscht worden – sie kann daher nicht weitergeleitet werden',
        verify: {
          button: 'Einen neuen Code bitte!',
          text: 'Versuche es noch einmal oder beantrage einen neuen Code. ',
          title: 'Hoppla!',
        },
      },
      buttons: {
        check_out: "Probier's mal aus!",
        help: 'Hilfecenter',
        plus: 'Hol dir Pro',
        get_link: 'Link erstellen',
      },
      tips: {
        change_type:
          'Sende Dateien per E-Mail oder generiere einen eigenen Übertragungslink, den du nach Belieben teilen kannst',
        contacts:
          'Jede Adresse, an die du Dateien sendest, wird automatisch deinen Kontakten hinzugefügt',
        expiry:
          'Mit WeTransfer Pro entscheidest du, wann deine Übertragungen ablaufen. (Du kannst das Verfallsdatum der Übertragung sogar noch nach dem Versenden ändern!)',
        free_limit:
          'Die gute Nachricht ist, dass du bis zu %{size} pro Übertragung senden kannst, die bessere, dass du den Service so oft nutzen kannst, wie du möchtest!',
        message:
          'Wenn du möchtest, kannst du mit deiner Übertragung auch eine persönliche Nachricht verschicken',
        password:
          'Du kannst deine Übertragung zusätzlich mit einem Passwort schützen. Das Passwort wird nicht mit der E-Mail mitgesendet – du musst es selbst an die entsprechenden Personen schicken!',
        recipient_limit:
          'Füge bis zu %{email_limit} E-Mail-Adressen hinzu oder öffne das Menü neben der Übertragungstaste, um einen Link zu erstellen',
        transfer_history:
          'Deine Übertragung wurde in deiner Übertragungsübersicht gespeichert',
        your_email:
          'Gib hier deine eigene E-Mail-Adresse ein – du bekommst dann eine E-Mail, sobald deine Dateien heruntergeladen wurden',
        link_transfer:
          'Wusstest du schon, dass die Übertragung auch über einen Link möglich ist?',
        previews_receiver:
          'Für Bilder, die von Pro Usern gesendet wurden, ist eine Vorschau vor dem Download verfügbar. Klicken Sie einfach eine Datei an, um zu sehen, was sich dahinter verbirgt!',
        previews_sender:
          'Eine Bildvorschau der von Ihnen gesendeten Bilder ist nun vor dem Download verfügbar',
        vrl_text:
          'Du kannst dir deine Dateien jetzt ohne vorheriges Herunterladen ansehen.',
        vrl_title: 'Vorschau ansehen',
        zip_text: 'Einen ganzen Ordner versenden? Wir zippen ihn für dich.',
        zip_title: 'Zippen? Überflüssig!',
        add_display_name_tooltip:
          'Gib deinen Übertragungen einen Titel, damit jeder weiß, worum es sich handelt. So lassen die Dateien sich später auch leichter wiederfinden.',
        anonymous_sender: {
          button: 'Erhalte einen Link',
          text: 'Trage hier deine E-Mail-Adresse ein, damit wir dich informieren können, sobald deine Dateien heruntergeladen wurden.  \n  \nDu musst deine E-Mail-Adresse erst noch bestätigen, damit wir sicher sein können, dass du es bist. Keine Lust, deine E-Mail-Adresse stets zu bestätigen?',
          text_locked_recipient:
            'Trage hier deine E-Mail-Adresse ein, damit wir dich informieren können, sobald deine Dateien heruntergeladen wurden.  \n  \nDu musst deine E-Mail-Adresse erst noch bestätigen, damit wir sicher sein können, dass du es bist.',
        },
        prefer_link: {
          button: 'Erhalte einen Link',
          text: 'Du möchtest deine E-Mail nicht bestätigen? Das ist vollkommen okay.',
        },
      },
      button: {
        previews_receiver_learnmore: 'Erfahren Sie mehr',
        previews_sender_learnmore: 'Erfahren Sie mehr',
      },
      recipient_locked_text:
        'Über diese Seite empfängt der Eigentümer der Seite Dateien. Das bist du? Dann melde dich an oder gehe auf <a href="https://wetransfer.com">wetransfer.com</a> , um Dateien an andere Empfänger zu senden.',
      recipient_locked_title: 'Aufgepasst',
      title: {
        previews_receiver: 'Einführung Bildvorschau',
        previews_sender: 'Einführung Bildvorschau',
      },
    },
    download: {
      blocked: {
        link: 'Mehr erfahren',
        text: 'Diese Übertragung wurde gemeldet und kann nicht heruntergeladen werden',
        title: 'Übertragung gestoppt',
      },
      title: 'Wir sind startklar',
      expires: 'Übertragung läuft in %{relative_time} ab',
      expires_never: 'Kein Verfallsdatum',
      files: '%{count} Dateien, %{size}',
      format: '%{files}・%{expires}',
      expand: 'mehr',
      download_link: 'Download-Link',
      files_nosize: {
        one: '%{count} Datei',
        other: '%{count} Dateien',
      },
      show_all_files_mobile: 'Alle Dateien anzeigen',
      zip_information:
        'Wenn du alle Dateien auf ein Mal herunterlädst, erhälst du eine .zip-Datei – <a href="https://wetransfer.zendesk.com/hc/en-us/sections/201887176-Downloading-a-transfer-on-a-mobile-device" rel="external">weiterlesen</a>',
      files_label: 'Files',
      message: 'Nachricht',
      learn_more: 'Mehr Info',
      expires_in: 'Läuft in %{expiry} ab',
      download_all_zip:
        '„Alle herunterladen“ lädt alle Dateien als ZIP-Datei herunter',
      back_to_transfer: 'Zurück zur Übertragung',
      cookie_text:
        'Wir verwenden Cookies, um dir das beste Erlebnis zu bieten. Keine Angst, wir verkaufen deine Daten nicht an Dritte. Verwalte deine <a href="https://wetransfer.com/legal/manage-cookies" rel="external">Dateneinstellungen</a>.',
    },
    preview: {
      open_grid: 'Vorschau ansehen',
      click_to_open: 'Vorschau anzeigen',
      grid: 'Inhalte dieser Übertragung',
      link: 'Website',
      not_previewable: 'Vorschau nicht verfügbar',
      now_open: 'Vorschau',
      open_link: 'Link in neuem Tab öffnen',
      open_link_short: 'Link öffnen',
      overview: 'Übersicht',
      reload: 'Neu laden',
      something_went_wrong: 'Huch, da ist etwas schiefgelaufen',
      tap_to_open: 'Für Vorschau hier tippen',
      toobig_copy:
        'Hier können wir nur Bilder von bis zu 50MB anzeigen – <a href="https://wetransfer.zendesk.com/" rel="external">Mehr dazu erfährst du hier</a>',
      toobig_title: 'Puh! Das Bild ist zu groß für unsere Vorschau',
      unsupported_copy:
        'In diesem <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115003447483" rel="external"> Artikel</a> erfährst du, für welche Dateiformate wir die Vorschaufunktion anbieten',
      unsupported_title: 'Für diese Datei ist (noch) keine Vorschau möglich',
      visit_website: 'Website besuchen',
    },
    complete_mobile: {
      email_text:
        'Die Übertragungs-E-Mail wurde verschickt – deine Übertragung ist für %{expires} verfügbar',
      link_text: 'Kopiere deinen Download-Link:',
      email_text_no_expiry: 'Eine E-Mail wurde an den Empfänger versendet.',
    },
    'consent-manager': {
      art: {
        'short-v': {
          subtitle:
            '<b>Wusstest du schon, dass wir 30% unserer Werbeflächen Künstlern zur Verfügung stellen?</b> Durch das Akzeptieren von Cookies gestattest du uns, dir ein wenig Kunst, Anliegen, die uns am Herzen liegen, und preisgekrönte, nicht störende Werbung zu zeigen. ',
          text: 'Akzeptierst du auch Cookies von Drittanbietern, unseren Werbepartnern, sodass wir dir personalisierte Anzeigen zeigen können? ',
          title: 'Unsere Cookies sind Futter für Kultur',
        },
        subtitle:
          '<b>Deswegen stellen wir Künstlern 30% unserer Werbeflächen zur Verfügung.</b> Durch das Akzeptieren von Cookies gestattest du uns, dir ein wenig Kunst, Anliegen, die uns am Herzen liegen, und preisgekrönte, nicht störende Werbung zu zeigen. ',
        text: 'Unsere Website verwendet Cookies, die ihre Funktion gewährleisten, uns helfen, zu verstehen, wie du WeTransfer nutzt, und uns bei der Optimierung unseres Angebots unterstützen. Akzeptierst du auch Cookies von Drittanbietern, unseren Werbepartnern, sodass wir dir personalisierte Anzeigen zeigen können?',
        title: 'Wir glauben, dass Kunst Berge versetzen kann',
        'title-small': 'Willkommen bei WeTransfer',
      },
      'button-accept': 'Ich akzeptiere',
      'button-accept-all': 'Alle akzeptieren',
      'button-ccpa': 'Deaktivierung des Verkaufs personenbezogener Daten',
      'button-cookies-privacy': 'Deine Datenschutz-Einstellungen',
      'button-reject': 'Nein danke',
      'button-save': 'Speichern',
      'button-save-and-exit': 'Speichern und schließen',
      'ccpa-banner-text':
        'Wir verwenden Cookies, um sicherzustellen, dass du das beste Erlebnis auf unserer Website hast. Keine Angst, wir verkaufen deine Daten nicht an Dritte. Möchtest du dich trotzdem abmelden? <a href="%{href}">Einstellungen verwalten</a>',
      'ccpa-body':
        'Weil du in den USA bist, sind deine Rechte durch den California Consumer Privacy Act (CCPA) geschützt und du kannst uns bitten, den Verkauf deiner personenbezogenen Daten einzustellen. Das bedeutet nicht, dass wir deine personenbezogenen Daten oder privaten Dateien andernfalls an den Meistbietenden versteigern—das haben wir nie und werden es auch nie tun! Wir setzen alles daran, deinen digitalen Fußabdruck so klein, so sicher und für dich so kontrollierbar wie möglich zu halten. Du kannst in <a href="%{href}">deinen Datenschutzoptionen</a> mehr darüber erfahren, welche Daten wir erfassen und warum.',
      'ccpa-donotsell': 'Meine persönlichen Daten nicht verkaufen',
      'ccpa-header': 'Deaktivierung des Verkaufs personenbezogener Daten',
      'ccpa-intro':
        'Als verantwortungsbewusstes Technologieunternehmen, das sich für ein besseres Internet einsetzt, verkaufen wir deine Daten nicht an Dritte. Aber du hast trotzdem das Recht, dich offiziell abzumelden.',
      'ccpa-variant-test-text':
        'Wir verwenden Cookies für eine reibungslose Erfahrung mit unserer Website und um die dir angezeigte Werbung zu personalisieren. <a href="%{href}">Cookies verwalten</a>',
      headline: 'Cookies und Werbung',
      intro:
        'Wir verwenden das Geld, das wir mit unseren stilvollen Werbeanzeigen verdienen, zur Bezahlung unserer Rechnungen. So sind wir in der Lage, unseren Filesharing-Service gratis anzubieten.',
      'manage-cookies': 'Cookies verwalten',
      'partners-consent': 'Einwilligung',
      'partners-features': 'Funktionen',
      'partners-headline': 'Unsere Partner',
      'partners-text':
        '<p>Nachfolgend eine alphabetisch geordnete Liste mit sorgfältig ausgewählten Partnern, denen wir es gestatten, deine Daten zu messen, damit wir unser Angebot nachverfolgen und verbessern können.</p>',
      'preferences-headline': 'Cookies verwalten ',
      'preferences-text':
        '<p>Wir respektieren dein Recht auf Privatsphäre und deine Entscheidungen in Bezug auf deine Daten. Wir müssen allerdings während deiner Benutzung unserer Tools einige deiner personenbezogenen Daten verarbeiten, verpflichten uns aber zu einem wertegeleiteten Ansatz in Bezug auf unser unternehmerisches Handeln, unsere Technologie und unsere Beziehung zu dir.</p>  \n<p>Deswegen tun wir alles dafür, deinen digitalen Fußabdruck so klein, so sicher und für dich so kontrolliebar wie möglich zu halten.</p>  \n<p>Standardmäßig sammeln und verarbeiten wir Daten nur, wenn dies strikt notwendig ist. Wenn du unsere Dienstleistung aber unterstützen und dazu beitragen möchtest, dass WeTransfer auch in Zukunft gratis bleibt, gestatte uns bitte, Informationen mit unseren Werbepartnern zu teilen.</p>',
      'preferences-text-allow-cookies':
        'Cookies zulassen, damit wir und/oder unsere Partner:<br><br>',
      'purpose-description-first-intro':
        'Um für Produkte auf der Website/in den Apps oder außerhalb davon zu werben, kann WeTransfer: ',
      'purpose-description-first-list':
        '<ul><li>Informationen darüber sammeln, wie du mit unserer/n Website(s) interagierst, z. B. dein Klickverhalten und die besuchten Seiten, und (wenn möglich) diese Informationen mit Daten kombinieren, die wir über dich gespeichert haben, z. B. die E-Mail-Adresse deines Kontos</li><li>Die von uns gesammelten Informationen verwenden, um dir per E-Mail Angebote machen und Werbung zusenden zu können; auf/in unserer/n eigenen Website(s) oder Apps; und auf Webseiten oder in Apps Dritter. Es kann beispielsweise sein, dass wir für eines unserer anderen Produkte werben, wenn du WeTransfer Pro verwendest.</li></ul>',
      'purpose-description-second-intro':
        'Zu Werbezwecken für Produkte auf unserer Website / in unseren Apps oder außerhalb davon, können unsere Partner: ',
      'purpose-description-second-list':
        '<ul><li>Informationen darüber sammeln, wie du mit unserer/n Website(s) interagierst, z. B. dein Klickverhalten und die besuchten Seiten, und (wenn möglich) diese Informationen mit Daten kombinieren, die sie über dich gespeichert haben</li><li>Die von ihnen gesammelten Informationen verwenden, um dir per E-Mail Angebote machen und Werbung zusenden zu können; auf/in ihrer/n eigenen Website(s) oder Apps; und auf Webseiten oder in Apps Dritter, mit denen sie zusammenarbeiten.</li></ul>',
      'purpose-title':
        'Für Produkte auf der Website/in den Apps oder außerhalb davon werben',
      'switch-by-partners': 'Von Partnern',
      'switch-by-we-transfer': 'Von WeTransfer',
      text: '<p>Unsere Website verwendet <a href="%{href}">Cookies</a>, die ihre Funktion verbessern, deine Interaktion mit ihr analysieren und uns bei der Optimierung unseres Angebots unterstützen.</p> \n<p>Möchtest du auch Cookies von unseren Werbepartnern zulassen, damit wir die Werbung personalisieren können, die dir angezeigt wird, und damit wir für Produkte von WeTransfer und für Produkte unserer Partner auf unseren Webseiten/in unseren Apps und außerhalb davon werben können?</p>',
      'text-panel':
        '<p>Unsere Website verwendet Cookies, die ihre Funktion verbessern, deine Interaktion mit ihr analysieren und uns bei der Optimierung unseres Angebots unterstützen.</p> \n<p>Möchtest du auch Cookies von unseren Werbepartnern zulassen, damit wir die Werbung personalisieren können, die dir angezeigt wird, und damit wir für Produkte von WeTransfer und für Produkte unserer Partner auf unseren Webseiten/in unseren Apps und außerhalb davon werben können?</p>',
      'tos-experiment': {
        'cookie-intro':
          'Ganz einfach große Dateien versenden und dabei großartige Kunst und preisgekrönte Werbung entdecken.',
        'cookie-text':
          'Unsere Website verwendet Cookies, die ihre Funktion verbessern, deine Interaktion mit ihr analysieren und uns bei der Optimierung unseres Angebots unterstützen.  \nDurch das Akzeptieren von Cookies gestattest du uns, dir personalisierte Werbung anzuzeigen. Haben wir oft genug "Cookies" gesagt? (Cookies!)',
      },
      trees: {
        'short-v': {
          subtitle:
            'Wir wollen die Welt mit preisgekrönter Werbung, die nicht stört und mit der wir zur Restaurierung von Meereswäldern beitragen können, noch ein bisschen schöner machen.',
          title: 'Unsere Cookies schützen die Erde',
        },
        subtitle:
          'Indem du unsere Cookies akzeptierst, hilfst du uns direkt, unser Versprechen an den Planeten zu erfüllen. Allein in diesem Jahr hat WeTransfer sich dazu verpflichtet, über 175.000 Bäume zu pflanzen, und wir haben gerade erst angefangen. Du tust somit schon etwas Gutes, indem du dir einfach unsere preisgekrönten Anzeigen ansiehst. ',
        text: 'Unsere Website verwendet Cookies, um die Funktionen und den Service zu verbessern und an deine Bedürfnisse anzupassen. Wenn du unsere Drittanbieter-Cookies akzeptierst, können wir und unsere Partner dir relevantere Werbung über unsere und außerhalb unserer Webseite(n) und Apps anbieten.',
        title: 'Übertrage Ideen. <b>Verändere die Welt.</b>',
      },
    },
    pro_pass_upsell_one: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_collect',
      text: 'Collect Pro freischalten',
      title: 'Inspiration unterwegs speichern und teilen',
    },
    pro_pass_upsell_three: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_three',
      text: 'Erzähle mir mehr',
      title:
        'Paste® Pro und Collect Pro sind jetzt in deinem Abonnement enthalten',
    },
    pro_pass_upsell_two: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_paste',
      text: 'Paste® Pro freischalten',
      title: 'Verwandele großartige Ideen in schöne Präsentationen',
    },
    terms_conditions: {
      experiment: {
        text: 'Akzeptiere bitte, um fortzufahren, zunächst unsere <a href="/legal/terms" data-route-type="plus"> AGB</a>.',
        title: "Du bist<span class='tc-title-exp'>fast</span> startklar",
        ustitle:
          "Willkommen bei der einfachsten Methode, <span class='tc-title-exp'>große Dateien zu senden.</span>",
      },
      title: 'Zuallererst...',
      text: 'Akzeptiere bitte zunächst unsere <a href="/legal/terms" data-route-type="plus">AGB</a> und  <a href="/legal/privacy" data-route-type="plus">Cookie-Richtlinien</a>. Wir nutzen Cookies (von Drittanbietern) zu Funktions-, Analyse- und Werbezwecken.',
      language: 'Deine Spracheinstellung:',
      button: 'Ich akzeptiere',
    },
    upsell_pricing: {
      text: 'Abos vergleichen',
      title: 'Möchtest du größere Übertragungen senden?',
      receiving: {
        title: 'Möchtest du das Maximale aus WeTransfer herausholen?',
      },
    },
    welcome: {
      card1:
        'Sende und empfange %{transfer_limit}-Übertragungen und sieh sie dir über eine <strong>zentrale Übersicht</strong> an',
      card2:
        'Liefere Arbeit über eure <strong>teameigene WeTransfer-Seite</strong> ab',
      card3:
        'Arbeite gemeinsam an Decks in <strong>Paste®</strong> und an Boards in <strong>Collect</strong>',
      cta: 'Jetzt loslegen',
      headline: 'Du gehörst zum Team, <strong>%{first_name}!</strong>',
      'opt-in':
        'Ich erhalte gerne Artikel über Kreativität und die neuesten WeTransfer-Nachrichten',
    },
    form: {
      num_files: {
        one: '%{count} Datei · %{remaining} verbleibend',
        other: '%{count} Dateien · %{remaining} verbleibend',
      },
      add_files: 'Dateien hochladen',
      more_files: 'Füge weitere Dateien hinzu',
      available_space: 'Füge bis zu %{size} hinzu',
      message: 'Nachricht',
      from: 'Deine E-Mail',
      to: 'E-Mail an',
      other_recipients: {
        one: '+%{count} weiterer',
        other: '+%{count} weitere',
      },
      reset_forward: 'Diese Weiterleitung abbrechen',
      drop_files: 'oder ziehen und ablegen',
      files_count: {
        one: '%{count} Datei hinzugefügt · Insgesamt %{fileSize}',
        other: '%{count} Dateien hinzugefügt · Insgesamt %{fileSize}',
      },
      select_folder: 'Oder einen Ordner auswählen',
    },
    progress: {
      title: 'Übertragung läuft...',
      title_cancel: 'Übertragung abbrechen?',
      uploaded: '%{sent} von %{total} hochgeladen',
      remaining: {
        minutes: {
          zero: 'Weniger als eine Minute verbleibend',
          one: 'Nur noch circa eine Minute verbleibend',
          other: 'Noch etwa %{count} Minuten verbleibend',
        },
        hours: {
          one: 'Noch etwa 1 Stunde verbleibend',
          other: 'Noch etwa %{count} Stunden verbleibend',
        },
      },
      document_title: '%{percentage}% - Übertragung läuft...',
      meta: {
        email: {
          one_file_one_recipient:
            'Sende %{filesCount} Datei an %{recipientsCount} Empfänger',
          one_file_other_recipients:
            'Sende %{filesCount} Datei an %{recipientsCount} Empfänger',
          other_files_one_recipient:
            'Sende %{filesCount} Dateien an %{recipientsCount} Empfänger',
          other_files_other_recipients:
            'Sende %{filesCount} Dateien an %{recipientsCount} Empfänger',
        },
        link: {
          one: '%{count} Datei wird gesendet',
          other: '%{count} Dateien werden gesendet',
        },
      },
    },
    complete_link: {
      title: 'Geschafft!',
      text: 'Download-Link kopieren oder <a href="/transfer/progress">Vorschau ansehen</a>',
      text_copied: 'Der Link wurde in die Zwischenablage kopiert',
      text_manual_copy:
        'Dein Link ist fertig\nDrücke %{shortcut}, um ihn in die Zwischenablage zu kopieren',
      document_title: 'Fertig!',
      text_pre_qr: 'Copy your download link or',
      text_get_qr: 'Get QR code',
      text_see_qr: 'See QR code',
    },
    storage_full_block: {
      information_detail_link: 'a lot of files',
      information_detail_text: 'You’re storing ',
      instruction_detail_link: 'request a storage boost',
      instruction_detail_text: 'Please <b>clean up some old files</b> or ',
      title: 'Hey, big sender',
      cta: 'Clean up',
    },
    complete_forward: {
      title: 'Deine Übertragung wurde weitergeleitet',
    },
    complete_email: {
      title: 'Fertig!',
      text: 'Die Übertragungs-E-Mail wurde verschickt – deine Übertragung ist für %{expires} verfügbar. <a href="/transfer/progress">Sieh dir die Vorschau an</a>',
      text_no_expiry:
        'Die Übertragungs-E-Mail wurde verschickt. <a href="/transfer/progress">Sieh dir die Vorschau an</a>',
      document_title: 'Versendet!',
      text_no_details:
        'Die Übertragungs-E-Mail wurde verschickt – deine Übertragung ist für %{expires} verfügbar.',
      team_discovery_title: 'Übertragung gesendet!',
      team_discovery_text:
        'Deine Übertragung ist bis zum %{expires} als Download verfügbar',
    },
    failed: {
      title: 'Hmm, irgendetwas ist schiefgelaufen',
      text: "Deine Übertragung ist anscheinend fehlgeschlagen – bitte versuch's nochmal",
    },
    pending: {
      title: 'Wir arbeiten daran',
      subtitle: 'Läuft...',
    },
    downloading: {
      title: 'Dateien werden verpackt.',
      text: 'Dein Download wird vorbereitet',
    },
    downloaded: {
      title: 'Dein Download hat begonnen',
      text: 'Die Dateien findest du am Ende im (von dir festgelegten) Downloads-Ordner deines Computers.',
      download_links:
        'Die Links auf diesem Board werden übrigens nicht angezeigt – <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115005062963" rel="external"> mehr dazu erfährst du hier</a>.',
    },
    expired: {
      title: 'Die Übertragung ist abgelaufen',
      text: 'Sorry, diese Übertragung ist abgelaufen und nicht länger verfügbar',
    },
    password: {
      title: 'Passwort eingeben',
      text: 'Du benötigst ein Passwort, um diese Übertragung herunterzuladen',
    },
    options: {
      transfer_type: 'Senden als',
      password: 'Passwort',
      password_placeholder: 'Passwort wählen',
      expiry: 'Endet nach',
      expire_in: {
        '1w': '1 Woche',
        '2w': '2 Wochen',
        '1m': '4 Wochen',
        never: 'Nie',
        '14d': '2 Wochen',
        '28d': '4 Wochen',
        '365d': '1 Jahr',
        '7d': '1 Woche',
        '90d': '3 Monate',
      },
      email: 'E-Mail',
      link: 'Link',
      email_transfer: 'E-Mail-Übertragung versenden',
      transfer_link: 'Übertragungslink erstellen',
    },
    buttons: {
      transfer: 'Senden',
      forward: 'Weiterleiten',
      new_transfer: 'Datei senden?',
      cancel: 'Abbrechen',
      cancel_no: 'Nein',
      cancel_yes: 'Ja',
      copy_link: 'Link kopieren',
      ok: 'Ok',
      done: 'Mehr senden?',
      team_discovery_done: 'Sende eine neue Übertragung',
      retry: 'Nochmal versuchen',
      continue: 'Fortsetzen',
      download: 'Herunterladen',
      download_all: 'Alle herunterladen',
      back_to_home: 'Zurück zu Home',
      cleanup: 'Transfers prüfen ',
      download_all_files: 'Alle Dateien herunterladen',
      help: 'Hilfecenter',
      payment: 'Jetzt verlängern',
      complete_order: 'Zur Bezahlung',
      download_all_experiment: 'Alles als .zip herunterladen',
      download_experiment: 'Datei herunterladen',
      download_file: 'Datei herunterladen',
      download_zip: 'Alles als .zip herunterladen',
      get_link: 'Her mit dem Link',
      go_to_transfer: 'Weiter zur Übertragung',
      openinapp: 'Speichern mit WeTransfer-App',
      openinapp_experiment: 'Speichern mit WeTransfer-App',
      openincollectapp: 'Mit Collect App speichern',
      get_a_link: 'Erhalte einen Link',
    },
    account_expired: {
      text: 'Verlängere jetzt – dann kannst du die Vorteile deines Pro-Kontos weiterhin genießen – oder <a href="#signout">wechsle zu unserem kostenlosen Service</a>',
      title: 'Dein Pro-Konto ist abgelaufen',
    },
    invalid: {
      text: 'Wir konnten deine Dateien nicht finden',
      title: 'Uups...',
      link: 'Mehr erfahren',
    },
    outdated_browser: {
      text: 'WeTransfer unterstützt verschiedene Internetbrowser. Dein Browser scheint veraltet zu sein – bitte aktualisiere ihn.',
      title: 'Dein Internetbrowser ist veraltet',
    },
    spam: {
      text: 'Die Übertragung wurde als Spam gemeldet und gelöscht',
      title: 'Hmm ...',
    },
    upsell: {
      text: 'Limit erhöhen',
      limit: 'Bis zu %{limit} kostenlos',
      remaining: '%{remaining} verbleibend',
    },
    upsell_five: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Hol dir WeTransfer Pro',
      title: 'Passwortgeschützte Übertragungen für noch mehr Sicherheit',
    },
    upsell_four: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Hol dir WeTransfer Pro',
      title: 'Übertragungen smarter & einfacher managen',
    },
    upsell_one: {
      bubble: {
        button: 'Hol dir Pro',
        text: 'Schütze deine Übertragungen mit einem Passwort und entscheide, wann deine Übertragung ablaufen soll',
        title: 'Übertragung upgraden?',
        text_experiment:
          'Mit Pro kannst du Passwörter und Verfallsdaten deiner Übertragungen festlegen.',
      },
      href: 'https://facebook.com/wetransfer',
      text: 'WeTransfer auf Facebook',
      title: 'Trete der WeTransfer Community auf Facebook bei',
    },
    upsell_three: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Hol dir WeTransfer Pro',
      title: 'Personalisiere dein WeTransfer-Profil',
    },
    upsell_two: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Hol dir WeTransfer Pro',
      title: 'Werde größer, besser, stärker, schneller',
    },
    account_inactive: {
      text: 'Schließ deine Registrierung ab, damit du mit Pro loslegen kannst',
      title: 'Dein Konto wurde\nnoch nicht aktiviert ',
      tiers: {
        text: 'Veranlasse deine Bezahlung, um direkt mit %{plan} loslegen zu können.',
        title: 'Dein Abonnement ist noch nicht aktiv',
      },
    },
    add_items: {
      files: 'Dateien',
      folders: 'Ordner',
    },
    complete: {
      open_panel: '<a href="/transfer/progress">Mal sehen, was drin ist</a>?',
    },
    details: {
      button: {
        dismiss: 'Ablehnen',
      },
    },
    download_preview: 'Datei herunterladen',
    error: {
      expired: {
        link: 'Dann wende dich an unseren Support.',
        text: 'Schade. Es sieht so aus, als ob deine Übertragung verfallen ist.\nDas kann nicht sein?',
        title: 'Übertragung nicht mehr verfügbar',
      },
    },
    item: {
      details: {
        folder: 'Ordner',
      },
    },
    items: {
      zero: 'leer',
      one: '%{count} Element',
      other: '%{count} Elemente',
    },
    mobile: {
      button: {
        back: 'Zurück',
        cancel: 'Nochmal von vorne anfangen',
        next: 'Weiter',
      },
      email: {
        title: 'Füge eine E-Mail-Adresse hinzu',
      },
      message: {
        placeholder: 'Füge deiner Übertragung eine persönliche Nachricht hinzu',
        title: 'Nachricht',
      },
      options: {
        email: 'E-Mail senden',
        'email-description':
          'Sende deine Übertragung mit einer einfachen E-Mail und wir werden dich informieren, wenn sie heruntergeladen worden ist.',
        link: 'Hol dir einen Link',
        'link-description':
          'Wandle deine Dateien in einen Link um, den du beliebig teilen kannst.',
      },
    },
    recaptcha: {
      button: '100% menschlich',
      text: 'Wir wollen nur sichergehen, dass du kein Roboter bist (bitte nicht persönlich nehmen)',
      title: 'Du bist fast am Ziel!',
    },
    upsell_survey: {
      href: 'https://www.surveymonkey.com/r/2HTSNSZ',
      text: 'Hilf uns aus',
      title: 'Können wir dich nach deiner Arbeitsweise fragen?',
    },
    'verification-code': 'Bestätigungscode',
    verify: {
      button: 'Übertragung starten',
      text: 'Kontrolliere in deinem Posteingang, ob du einen Bestätigungscode von uns erhalten hast, und trage diesen unten ein.',
      title: 'Du hast Post!',
      'verification-code': 'Bestätigungscode',
    },
    'account-verification-failed': {
      body: 'Bei der Bestätigung deiner E-Mail-Adresse ist ein Problem aufgetreten. Neuen Link schicken, um es nochmal zu versuchen.',
      cta: 'Neuen Link senden?',
      title: 'Das hat nicht geklappt',
    },
    'cookie-banner': {
      'button-accept': 'Okay',
      'button-decline': 'Nein',
      text: 'Wir verwenden <a href="%{href}">Cookies</a> für eine bessere Funktionsfähigkeit und zur allgemeinen Optimierung der Website sowie zur Analyse der Interaktion unserer Nutzer mit der Website. Möchtest du Cookies von Drittanbietern erlauben, um personalisierte Werbung zu erhalten?',
    },
    'cookie-manager': {
      analytical: {
        description:
          'Wir verwenden Analyse-Cookies, um zu verstehen, wie du WeTransfer verwendest. Sie ermöglichen es uns, neue Funktionen zu testen, sicherzustellen, dass alles so funktioniert, wie es sollte und Bots und bösartiges Verhalten wie Spam zu stoppen. Diese Cookies können Cookies von Drittanbietern enthalten, die personenbezogene Daten verarbeiten. ',
        title: 'Analyse-Cookies',
      },
      clear: {
        'clear-all-cookies': 'Alle Cookies löschen',
        description:
          'Du kannst all deine Daten aus unseren Cookies entfernen. Für permanente Anonymitätsanfragen <a href="mailto:support@wetransfer.com">wende dich bitte an unser Support-Team. </a>',
        title: 'Cookies löschen',
        warning:
          'Du wirst nach dem Löschen von Cookies bei WeTransfer abgemeldet. Dies hat keine Auswirkungen auf Übertragungen auf deinem Konto.',
      },
      functional: {
        description:
          'Wir verwenden funktionale Cookies, um ein nahtloses Erlebnis für dich auf WeTransfer zu schaffen. Sie sind erforderlich, um unseren Service zu nutzen.',
        title: 'Funktionale Cookies',
      },
      'not-yet-set':
        'Es sieht so aus, als hätten wir deine Cookie-Einstellungen noch nicht. Bitte schließe dieses Feld und lege deine Einstellungen fest. Du kannst es später jederzeit hier ändern.',
      'save-and-reload': 'Einstellungen speichern',
      tracking: {
        description:
          'Wir verwenden Werbe-Cookies in unserem Service, um den Erfolg unserer kommerziellen, redaktionellen und Werbemaßnahmen zu messen. Werbe-Cookies werden nicht auf Seiten gesetzt, die Informationen über unsere Marke und Produkte enthalten. Mit Werbe-Cookies können wir beispielsweise aufzeichnen, dass du auf eine bestimmte Anzeige geklickt hast. Wenn von Drittanbietern gesetzte Cookies auch auf anderen Domains und Websites gesetzt werden, können Werbetreibende möglicherweise dein Verhalten im Internet verfolgen. WeTransfer kann jedoch nicht auf diese möglicherweise gesammelten persönlichen Informationen zugreifen oder diese verwenden. Lies also bitte die Datenschutzrichtlinien der jeweiligen Drittanbieter.',
        title: 'Werbe-Cookies',
      },
    },
    'email-verification-resend': {
      account: {
        error: 'Ups, da ist was schiefgelaufen',
        'error-email-exists':
          'Ups, diese E-Mail wird scheinbar schon verwendet',
        'throttle-error':
          'Oh, jetzt haben wir dir zu viele E-Mails geschickt. Warte bitte %{throttle_time}, bevor du einen neuen Code beantragst.',
      },
      back: 'Zurück zur Code-Verifizierung',
      body: 'Stimmt alles? Das hier ist die E-Mail-Adresse, die du auf WeTransfer nutzt.',
      email: 'E-Mail',
      error: 'Ups, da ist was schiefgelaufen',
      'error-email-exists': 'Ups, diese E-Mail wird scheinbar schon verwendet',
      submit: 'Erneut senden',
      'throttle-error':
        'Das waren leider zu viele Versuche. Bitte starte deine Übertragung erneut.',
      'throttle-error-action': 'Neu starten',
      'throttle-error-link':
        'Oh, jetzt haben wir dir zu viele E-Mails geschickt. Warte bitte %{throttle_time}, bevor du einen neuen E-Mail beantragst.',
      title: 'Check deinen Posteingang',
    },
    'email-verification-success': {
      body: 'Jetzt können Empfänger darauf vertrauen, dass Übertragungen wirklich von dir stammen.',
      free_signup: 'Erstelle ein kostenloses Konto',
      onboarding_body:
        'High five, du bist drin! Möchtest du gleich deine eigene URL und deine eigenen Hintergründe wählen?',
      onboarding_title: 'Willkommen bei<br/>WeTransfer Pro!',
      send_files: 'Dateien senden',
      start_onboarding: "Auf geht's",
      title: 'Dein Konto wurde bestätigt!',
      upsell:
        'Du möchtest deine E-Mail-Adresse nicht jedes Mal aufs Neue bestätigen?',
      verified_sender_tooltip:
        'Deine E-Mail wurde verifiziert. Jetzt können die Empfänger sich darauf verlassen, dass die Übertragungen tatsächlich von dir gesendet wurden. Um diese E-Mail zu ändern, aktualisiere bitte deine <a href="%{href}">Personendaten</a>.',
      verified_sender_tooltip_icon:
        'Du hast deine E-Mail-Adresse verifiziert. So können Benutzer darauf vertrauen, dass die Übertragungen von dir gesendet wurden.',
    },
    'email-verification': {
      account: {
        'error-expiry-time':
          'Oh-oh, der Code ist nicht korrekt oder verfallen. Codes sind, nachdem sie versendet wurden, nur %{expiry_time} aktiv.',
        'error-expiry-time-action': 'Einen neuen Code bitte',
        'throttle-error':
          'Du hast zu oft einen falschen oder abgelaufenen Code eingegeben. Warte bitte %{throttle_time}, bevor du einen neuen Code beantragst.',
      },
      back: 'Zurück',
      body: 'Wir haben einen Verifizierungscode an <strong title="%{account_email}">%{account_email}</strong> gesendet, um sicherzustellen, dass du es wirklich bist. (Vergiss nicht, deinen Spam-Ordner zu überprüfen).',
      body_link:
        'Wir wollen sichergehen, dass du es bist.<br/><br/>Deswegen haben wir einen Bestätigungslink an <strong title="%{account_email}">%{account_email}</strong> geschickt. (Nicht gefunden? Schau mal im Spam nach).',
      error: 'Oh oh, der Code ist falsch oder nicht mehr gültig',
      'error-expiry-time':
        'Oh-oh, der Code ist nicht korrekt oder verfallen. Codes sind, nachdem sie versendet wurden, nur %{expiry_time} aktiv.',
      'error-expiry-time-action': 'Einen neuen Code bitte',
      resend: 'Keine E-Mail erhalten?',
      submit: 'Bestätigen',
      'throttle-error':
        'Das waren leider zu viele Versuche. Bitte starte deine Übertragung erneut.',
      'throttle-error-action': 'Neu starten',
      title: 'Bestätige deine E-Mail-Adresse',
      'verification-code': 'Bestätigungscode eintragen',
    },
    'force-account-verification': {
      body: 'Wir schicken dir einen Link, mit dem du die E-Mail-Adresse, die du bei We Transfer verwendest, bestätigen kannst.',
      cta: 'E-Mail versenden',
    },
    'marketing-email-prompt': {
      body: 'Noch eine Frage: Möchtest du WeTransfer-Nachrichten und Produkt-Updates empfangen?',
      skip: 'Nein danke',
      subscribe: 'Ja gerne',
      title: 'Du bist verifiziert!',
    },
    'terms_conditions-no-cookies': {
      text: 'Akzeptiere, um fortzufahren, zunächst unsere <a href="/legal/terms?from_home" data-route-type="plus">AGB</a>.',
    },
    mobile_web: {
      ios_banner_prompt: 'Hol dir deine Dateien in der WeTransfer-App',
      ios_banner_prompt_send: 'Versende Dateien schnell und einfach',
      tnc_subtitle: 'Der einfachste Weg große Dateien zu senden',
    },
  },
  account: {
    legend: {
      plan: 'Abonnement',
      save: 'speichere %{amount}%',
      subscription: 'Abonnement',
      summary: 'Deine Bestellung',
      wetransfer_premium: 'WeTransfer Premium',
    },
    'verify-info': 'Warum wir dich bitten, deine E-Mail-Adresse zu bestätigen',
    workspace: {
      default_workspace: 'Arbeitsbereich von %{name}',
      your_workspace: 'Dein Arbeitsbereich',
    },
    consent_manager: {
      data_opt_in: {
        title: 'Deine Datenschutz-Einstellungen',
        subtitle: 'Verwalte deine Daten',
        p1: 'Wir möchten dir immer das beste Erlebnis bieten, auch wenn es um unsere Werbung geht.',
        p2: 'Wir möchten die Daten nutzen, die du uns zur Verfügung stellst – wie deine E-Mail-Adresse – um zu verstehen, welche Art von Inhalten dir am besten gefällt und um dir (und anderen wie dir) WeTransfer-Werbung zu zeigen, die am besten zu deinen Bedürfnissen passt.',
        p3: 'Alles, was du erstellst und mit WeTransfer teilst, bleibt privat – wir lesen es nicht und verwenden es nicht für Werbezwecke.',
        p4: 'Wenn du dich entscheidest, etwas mit uns zu teilen, bleiben diese Informationen immer geschützt.',
        control_label:
          'Lass WeTransfer deine Daten verwenden, wie deine E-Mail Adresse und dein Arbeitsfeld, um dir Werbung zu zeigen, die zu dir passt. Auf unseren Websites und außerhalb davon.',
      },
      vertical_nav: {
        terms_of_service: 'Nutzungsbedingungen',
        privacy_and_cookie_statement: 'Datenschutz- und Cookie-Richtlinie',
        your_privacy_choices: 'Deine Datenschutz-Einstellungen',
        notice_and_takedown_policy: 'Richtlinie zu Meldung und Entfernung',
        responsible_disclosure_policy:
          'Richtlinie zu verantwortungsvoller Offenlegung',
        advertising_terms_and_conditions:
          'Allgemeine Geschäftsbedingungen für Werbung',
      },
    },
  },
  account_onboarding_navigation: {
    cta: 'Schließen und nur Dateien senden',
  },
  account_start_screen: {
    'collect-description':
      'Speichere Inspirationsmaterial von deinem Telefon, Laptop oder Tablet aus an einem zentralen Ort.',
    'collect-title': 'Gehe zu Collect',
    'paste-description':
      'Erstelle schöne Folien in Sekunden, mit Präsentations-Decks, die sich selbst gestalten.',
    'paste-title': 'Gehe zu Paste®',
    title: 'Drei Tools. Ein Konto. Unendlich viele Möglichkeiten.',
    'transfer-cta': "Auf geht's",
    'transfer-description':
      'Schinde Eindruck, wenn jemand deine Dateien herunterlädt. Bereit, deine eigene URL und Wallpaper auszuwählen?',
    'transfer-title': 'Richte deine eigene WeTransfer-Seite ein',
  },
  account_welcome_screen: {
    'pro-title': 'Willkommen bei WeTransfer Pro, <strong>%{name}!</strong>',
    accept: 'Ja gerne',
    'accept-short': 'Okay',
    body_1:
      'Möchtest du Artikel über Kreativität und die aktuellsten WeTransfer-Nachrichten erhalten?',
    body_2: '(Du kannst dich jederzeit wieder abmelden.)',
    decline: 'Nein danke',
    'decline-short': 'Nein, danke',
    title: 'Willkommen bei WeTransfer, <strong>%{name}!</strong>',
  },
  cookie_wall_paid: {
    button: {
      accept: 'Cookies akzeptieren',
      deny: 'Cookies ablehnen',
      manage: 'Cookies verwalten',
    },
    description:
      'Wir verwenden reguläre Cookies und Analyse-Cookies, um ein großartiges Erlebnis zu gewährleisten und Cookies von Drittanbietern zu Werbezwecken.',
    heading: 'Entdecke den einfachsten Weg, große Dateien zu senden',
    snippet: 'Willkommen bei WeTransfer',
  },
  dropzone: {
    pro: {
      title: "<span>Drop</span> it<br>like it's hot",
    },
    title: "Drop it like it's hot",
    text: 'Lade Dateien oder Ordner durch ein Drag-and-drop in dieses Fenster hoch',
  },
  form: {
    account: {
      billing_address: 'Rechnungsadresse',
      billing_cta: 'Gehe zu Zahlung',
      billing_title: 'Rechnungsinformationen',
      legend: {
        details: 'Deine Rechnungsdaten',
        coupon_code: 'Rabattcode hinzufügen',
        free_plus: 'Hol dir dein kostenloses Pro-Konto',
      },
      label: {
        year_label: 'jährlich',
        year_sublabel: 'Bestes Angebot: du sparst %{discount_rate}%!',
        month_label: 'monatlich',
        month_sublabel: 'Monatliche Zahlung',
        email: 'E-Mail-Adresse',
        not_required: '(freiwillig)',
        current_password: 'Aktuelles Passwort',
        new_password: 'Neues Passwort',
        repeat_new_password: 'Neues Passwort bestätigen',
        password: 'Passwort',
        password_confirm: 'Passwort bestätigen',
        full_name: 'Vor- und Nachname',
        company: 'Firma',
        street_and_number: 'Straße und Hausnummer',
        city: 'Ort',
        zipcode: 'Postleitzahl',
        country_code: 'Land',
        vat_number: 'MwSt.',
        coupon_code: 'Rabattcode',
        family_name: 'Nachname',
        given_name: 'Vorname',
        state_code: 'Bundesstaat',
      },
      description: {
        password: 'Erstelle ein Passwort mit mind. 6 Zeichen',
        vat_number:
          'Für Unternehmen mit Sitz in den Niederlanden berechnen wir 21 % MwSt. Von Unternehmen mit Sitz in einem anderen EU-Mitgliedsland benötigen wir die Firmendaten und die EU-Umsatzsteueridentifikationsnummer. Die MwSt. wird dann in der Rechnung nicht ausgewiesen.\n\nAuch wenn dein Unternehmen seinen Sitz außerhalb der EU hat, brauchen wir deine Rechnungsdaten. Wir berechnen dann jedoch keine MwSt.',
      },
      error: {
        email: {
          blank: 'Bitte gib deine E-Mail-Adresse ein',
          invalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
          taken: 'Diese E-Mail-Adresse wird bereits verwendet',
          taken_login:
            'Sieht so aus, als hättest du bereits ein Konto. <a class="form-notification__message-link" href="%{login_url}">Anmelden?</a>',
        },
        current_password: {
          invalid: 'Das Passwort wurde nicht erkannt',
          blank: 'Bitte gib dein aktuelles Passwort ein',
        },
        password: {
          blank: 'Bitte gib dein neues Passwort ein',
          too_short: 'Dein Passwort muss aus mind. 6 Zeichen bestehen',
        },
        password_confirm: {
          blank: 'Bitte bestätige dein neues Passwort',
          confirm: 'Diese Passwörter stimmen leider nicht überein',
        },
        full_name: {
          blank: 'Bitte gib deinen vollständigen Namen ein',
          too_short: 'Hoppla, dein Name muss mindestens drei Zeichen lang sein',
        },
        street_and_number: {
          blank: 'Bitte gib deine Straße und Hausnummer ein',
        },
        city: {
          blank: 'Bitte gib deinen Wohnort ein',
        },
        zipcode: {
          blank: 'Bitte gib deine PLZ ein',
        },
        country_code: {
          inclusion: 'Rechtschreibung prüfen oder anderes Land wählen',
          blank: 'Bitte gib dein Land ein',
        },
        vat_number: {
          vat_number: 'Bitte gib eine gültige Umsatzsteuernummer ein',
        },
        terms_of_service: {
          accepted:
            'Um fortzufahren, akzeptiere bitte unsere Nutzungsbedingungen',
        },
        no_results: 'Rechtschreibung prüfen oder anderes Land wählen',
        convert: {
          expired:
            'Sorry, diese Übertragung ist bereits abgelaufen und kann nicht mehr gespeichert werden. Wusstest du, dass WeTransfer Pro-Nutzer Übertragungen so lange behalten können, wie sie wollen? Hier erfährst du mehr dazu.',
        },
        coupon_code: {
          coupon_code: 'Bitte gib einen gültigen Rabattcode ein',
        },
        no_state_results: 'Ist das ein Bundesstaat?',
      },
      complete_order: 'Vervollständige deine Bestellung',
      terms_conditions:
        'Ich stimme den <a href="/legal/terms" %{options}>Nutzungsbedingungen </a> zu und habe die <a href="/legal/privacy" %{options}>Datenschutz- und Cookie-Erklärung </a> gelesen',
      signup_for_plus: 'Hol dir WeTransfer Pro',
      account_cta: "Auf geht's",
      signup_for_account: 'Jetzt WeTransfer-Konto registrieren',
      'email-verification-not-verified-link':
        'Bestätige deine E-Mail-Adresse. Lies dir bitte die E-Mail durch, die wir dir geschickt haben, oder <button type="button" class="button button--link"> beantrage eine neue</button>.',
      'email-verification-resend': {
        error: 'Ups, da ist was schiefgelaufen',
        info: 'Neuer Code gesendet! Überprüfe bitte deinen Posteingang',
        info_link: 'Neue E-Mail gesendet! Schau in deinen Posteingang',
        'throttle-error':
          'Oh, jetzt haben wir dir zu viele E-Mails geschickt. Warte bitte %{throttle_time}, bevor du einen neuen Code beantragst.',
      },
      'force-account-verification': {
        message:
          'Bitte bestätige deine E-Mail-Adresse, damit wir wissen, dass du es wirklich bist.',
      },
      marketing_opt_in:
        'Ich möchte per E-Mail über Neuigkeiten und Produkt-Updates von WeTransfer informiert werden',
      sso: {
        header: 'Personendaten',
        password_reset: {
          button: 'E-Mail senden',
          instructions:
            'Du möchtest etwas ändern (z. B. dein Passwort)? Kein Problem. Klick einfach auf die Schaltfläche unten, dann senden wir dir eine E-Mail an <span>%{email}</span> mit einem Link, über den du dein Passwort ändern kannst.',
          success: 'E-Mail gesendet! Überprüfe deinen Posteingang.',
          title: 'Dein Passwort ändern',
        },
        wrong_user: 'Das bist nicht du? Abmelden',
      },
    },
    payment_cancel: {
      submit: 'Bestätigen',
      client_request:
        'Ein Kunde hat mich gebeten, WeTransfer zu nutzen und aktuell brauche ich es nicht',
      different_tool: 'Ich habe ein anderes (Online-)Tool gefunden',
      extra_features: 'Ich brauche Zusatzfunktionen, die es nicht bietet',
      not_enough_storage: 'Der angebotene Speicherplatz reicht mir nicht aus',
      not_often_large_files: 'Große Dateien verschicke ich einfach zu selten',
      other: 'Anders',
      other_more: 'Kannst du uns mehr verraten?',
      skip: 'Überspringen und Abo kündigen',
      temp_project:
        'Ich musste nur ein paar größere Dateien im Rahmen eines zeitlich abgesteckten Projektes verschicken',
      too_expensive: 'Ich finde es zu teuer',
    },
    payment_cancel_reason: {
      skip: 'Ich möchte kein Feedback geben',
    },
    profile: {
      label: {
        profile_title: 'Profilname',
        wallpaper_link: 'Internetadresse zur Verlinkung mit Hintergründen',
      },
      error: {
        subdomain_name: {
          too_short:
            'Weniger ist mehr – stimmt. Aber zwei Zeichen sollte deine WeTransfer-URL schon enthalten',
          domain_name:
            'Sorry, diesen Namen hat sich schon jemand vor dir geschnappt',
          invalid:
            'Deine WeTransfer-URL darf nur Buchstaben und Zahlen (und mittendrin einen Bindestrich) enthalten',
          taken: 'Sorry, diesen Namen hat sich schon jemand vor dir geschnappt',
        },
        subdomain: {
          too_short: 'Mach weiter bis zu mindestens 2 Zeichen',
          too_long: 'Warte, gib weniger als 63 Zeichen ein',
          invalid:
            'Warte, hier stimmt was nicht—deine WeTransfer-URL darf nur Buchstaben und Zahlen (und mittendrin einen Bindestrich) enthalten',
          domain_name: 'Diese URL ist bereits vergeben',
        },
        default_recipient_email: {
          invalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
        },
        wallpaper_link: {
          invalid: 'Bitte gib eine gültige Internetadresse ein',
        },
      },
      success: {
        subdomain: {
          updated: 'Deine URL wurde aktualisiert',
          available: 'Gute Neuigkeiten, diese URL ist verfügbar',
        },
      },
      change_background: 'Hintergrund hochladen',
      delete_avatar: 'Avatar löschen',
      delete_background: 'Hintergrund löschen',
      description: {
        title:
          'Hey, beschränke dich auf 150 Zeichen, damit auf der Seite nichts abgeschnitten wird',
        wallpaper_link:
          'Dein Hintergrundbild wird mit dieser Internetadresse verlinkt',
        recipient_email_locked:
          'Dateien, die über dein Profil gesendet werden, können nur an diese E-Mail-Adresse geschickt werden',
      },
      upload_avatar: 'Avatar hochladen',
      use_email_background_checkbox_label:
        'Dieses Hintergrundbild für alle Übertragungen verwenden, die über mein Profil gesendet werden',
      account_email_checkbox: 'E-Mail-Adresse im Profil anzeigen',
      default_recipient_email_info:
        'Du kannst diese E-Mail-Adresse in deinen <a href="/account">persönlichen Daten</a> ändern',
      change_subdomain: {
        message:
          'URL zu <a href="%{url}">%{subdomain}.wetransfer.com</a> ändern? Deine vorherige ist sofort wieder verfügbar.',
        confirm: 'Ja, URL ändern',
        cancel: 'Zurück',
      },
    },
    fill_in_password: 'Gib dein Passwort ein, um diese Änderungen zu speichern',
    select_all: 'Alle auswählen',
    deselect_all: 'Keine auswählen',
    save_changes: 'Änderungen speichern',
    save: 'Speichern',
    submitting: 'In Bearbeitung...',
    cancel: 'Abbrechen',
    forward: 'Weiter',
    proceed: 'Weiter',
    delete: 'Löschen',
    onboarding: {
      placeholder: {
        subdomain_name: 'ein-guter-profilname',
      },
      validated: {
        subdomain_name: 'Gute Nachrichten – diese Domain ist verfügbar',
      },
    },
    confirm_leave:
      'Willst du diese Seite wirklich verlassen? Alle nicht gespeicherten Änderungen gehen dann verloren.',
    unsaved_changes:
      'Seite verlassen? Du verlierst alle nicht gespeicherten Änderungen.',
    contact: {
      add_contact: 'Kontakt hinzufügen',
      error: {
        email: {
          duplicate:
            'Diese E-Mail-Adresse ist in deinen Kontakten bereits vorhanden',
          invalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
        },
      },
      label: {
        company: 'Firma',
        email: 'E-Mail-Adresse',
        name: 'Name',
      },
    },
    error: {
      current_password: {
        blank: 'Bitte gib dein aktuelles Passwort ein',
        invalid: 'Das Passwort wurde nicht erkannt',
      },
      email: {
        blank: 'Bitte gib deine E-Mail-Adresse ein',
        duplicate:
          'Diese E-Mail-Adresse ist in deinen Kontakten bereits vorhanden',
        invalid: 'Bitte gib eine gültige E-Mail-Adresse ein',
        taken: 'Diese E-Mail-Adresse wird bereits verwendet',
      },
    },
    leave: 'Verlassen',
    resetpassword: {
      button: {
        request_submit: 'Mail mir!',
        reset_submit: 'Speichern',
      },
      label: {
        confirm_new_password: 'Neues Passwort bestätigen',
        email: 'E-Mail-Adresse',
        new_password: 'Neues Passwort',
      },
      legend: {
        request_description:
          'Ausgesperrt? Wir mailen dir, was du tun musst, um dein Passwort zurückzusetzen.',
        request_title: 'Hast du dein Passwort vergessen?',
        reset_description:
          'Gib ein neues Passwort ein, um dich wieder einloggen zu können',
        reset_title: 'Neues Passwort festlegen',
        request_description_success_or_article:
          'Du hast Post! Folge den Anweisungen in unserer Mail, um dein Passwort zurückzusetzen oder <a href="https://wetransfer.zendesk.com/hc/en-us/articles/360033809331" rel="external">kontaktier uns</a>, wenn du innerhalb der nächsten zehn Minuten keine E-Mail erhalten haben solltest.',
      },
    },
    signin: {
      button: {
        submit: 'Anmelden',
      },
      label: {
        email: 'E-Mail-Adresse',
        password: 'Passwort',
        remember_me: 'Angemeldet bleiben',
      },
      link: {
        forgot_password: 'Passwort vergessen?',
      },
      title: 'Einloggen',
    },
    stay_on_page: 'Auf dieser Seite bleiben',
    close_panel: 'Schließen',
    go_back: 'Zurück',
    labels: {
      email: 'E-Mail-Adresse',
    },
    plan: {
      change: {
        month: 'Monatlich (%{currency}%{price})',
        title: 'Zahlungsplan ändern',
        year: 'Jährlich (%{currency}%{price})',
      },
      change_plan: 'Zahlungsplan ändern',
      month: {
        copy: 'Periodische Abrechnung',
        label: 'Monatlich',
        'label-payment': 'Monatliche Zahlung',
        'sub-label': 'Eine Rechnung pro Monat',
        title: 'WeTransfer Pro: Monatliche Zahlung',
      },
      title: 'Gönne deinen Ideen die Premium-Behandlung, die sie verdienen',
      year: {
        discount: '%{rate}% Ersparnis (jawollja!)',
        'label-payment': 'Jährliche Zahlung',
        'sub-label': 'Du sparst (festhalten!) 17%',
        title: 'WeTransfer Pro: Jährliche Zahlung',
      },
      your_order: 'Deine Bestellung',
    },
    save_and_continue: 'Speichern und weiter',
    upgrade: null,
    fill_in_password_two_factor_authentication:
      'Zum Fortfahren bitte dein Passwort eintragen',
  },
  mobileweb: {
    'app-upsell': {
      cta: {
        false: 'Gerade nicht',
        true: 'In der WeTransfer App öffnen',
      },
      headline: 'Warum nicht größer denken?',
      headline2: 'Dateien in der App ansehen?',
      subheader: 'Sende und empfange 200 GB mit WeTransfer Pro',
      subheader2:
        'Datei-Vorschau vor dem Download. Übertragungen senden und empfangen, Downloads nachverfolgen und Meldungen erhalten.',
    },
  },
  panel: {
    warning: {
      account_expired_subtitle_tier:
        'Jetzt verlängern, damit du weiterhin alle Vorteile deines %{tier}-Kontos genießen kannst',
      account_expired_title_tier: 'Dein %{tier}-Konto ist abgelaufen',
      account_inactive_title_tier: 'Bereit für %{tier}',
      account_inactive_action: 'Ja, fortfahren',
      account_inactive_subtitle:
        'Noch ein letzter Schritt, dann bist du soweit. Meinung geändert? Kein Problem –',
      account_inactive_title: 'Ab jetzt Pro?',
      account_subscription_action: 'Jetzt verlängern',
      account_subscription_expired: 'Dein Pro-Konto ist abgelaufen',
      account_subscription_subtitle:
        'Jetzt verlängern, um deine Übertragungen, deine eigenen Hintergründe und deine Internetadresse zu behalten. Sonst wird in Kürze alles gelöscht!',
      account_expired_action: 'Jetzt verlängern',
      account_expired_subtitle:
        'Verlängere jetzt – dann kannst du die Vorteile deines Pro-Kontos weiter genießen',
      account_expired_title: 'Dein Pro-Konto ist abgelaufen',
      expired_transfer_subtitle:
        'Die Dateien sind nicht mehr verfügbar. Du kannst sie <a>hier</a> dauerhaft aus der Übertragungsübersicht löschen.',
      expired_transfer_title: 'Diese Übertragung ist abgelaufen',
      account_email_verify_logged_out:
        'Bitte anmelden, um deine E-Mail zu bestätigen',
      account_inactive_sublink: 'storniere deine Bestellung.',
      email_unverified_mobile_cta: 'Bereit zur Bestätigung',
      email_unverified_text:
        "Wir haben einen Bestätigungscode an %{email} gesendet. <a href='%{href}'>Das bist nicht du?</a>",
      email_unverified_text_link:
        "Wir haben eine E-Mail an %{email} gesendet. <a href='%{href}'>Das bist du nicht?</a>",
      email_unverified_title: 'Bitte bestätige deine E-Mail-Adresse',
      'force-account-verification': {
        body: 'Wir schicken dir einen Link, um sicherzustellen, dass du es wirklich bist.',
      },
      'receiving-email':
        'Damit du Bescheid weißt! Wir haben %{receiving_email} in deinem Profil geändert. Das bedeutet, dass neue Übertragungen nur in deiner Übertragungsübersicht auftauchen, wenn sie an %{account_email} gesendet werden. Wenn du dies ändern möchtest, kannst du deine <a href="/account">persönlichen Daten</a> jederzeit ändern.',
    },
    design:
      'Dir ist sicher aufgefallen, dass wir hier einiges geändert haben. Das meiste auf Anregung von euch Nutzern. Also schaue dir die neue (und wie wir finden, verbesserte) Seite an, und wir würden uns über dein eventuelles Feedback freuen.',
    loading_error:
      'Hmm, die Seite kann gerade nicht geladen werden.\nWir bleiben dran – oder versuche selbst, <a href="%{path}">die Seite neu zu laden</a>.',
    redesign_notice:
      'Dir ist sicher aufgefallen, dass wir hier <a href="/about/redesign">einiges geändert</a> haben. Das meiste auf Anregung von euch Nutzern. Also schaue dir die neue (und wie wir finden, verbesserte) Seite an, und wir würden uns über dein eventuelles <a href="/contact" rel="external">Feedback</a> freuen.',
    return_to: 'Zurück zu(r) %{pageName}',
    close: 'Schließen',
    cookie: {
      accept: 'Okay',
      text: 'Wir verwenden Cookies. Freunde des Kleingedruckten werden <a href="/legal/terms">hier</a> fündig.',
    },
    footer: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      jobs: 'Jobs',
      press: 'Presse',
      terms: 'AGB',
      twitter: 'Twitter',
      youtube: 'YouTube',
    },
  },
  upsell_tiers: {
    button: 'Upgrade',
    free_limit:
      'Du kannst nicht mehr als 2 GB auf einmal senden. Möchtest du größere Übertragungen senden?',
    compare_plans: {
      button: 'Abos vergleichen',
      text: 'Du kannst ein Upgrade eines Abos machen, um mehr als 2 GB auf einmal zu übertragen.',
      title: 'Willst du noch mehr Dateien senden?',
    },
    mobile: {
      cta: 'Mehr Info',
      header: 'Hol dir das Beste von WeTransfer',
      upsell_enjoy: 'Nutze mehr Speicherplatz',
      upsell_one: 'Versende größere Übertragungen',
      upsell_two: 'Personalisiere deine WeTransfer-Seite',
    },
    pro_limit:
      'Du kannst nicht mehr als 200 GB auf einmal senden. Möchtest du beliebig große Übertragungen senden?',
  },
  upsell_tiers_one: {
    text: 'Interesse an Passworten und Ablaufdaten für deine Übertragungen?',
  },
  upsell_tiers_three: {
    text: 'Möchtest du Übertragungen an mehr als %{email_limit} E-Mail-Adressen gleichzeitig versenden?',
    title: 'Das ist 1 zu viel',
  },
  browser: {
    assets_failed: {
      text: 'Wir konnten einige wichtige Teile der Webseite nicht laden.\nMöglicherweise wurden diese von deiner Firewall, deinem Proxy oder deinen Browser-Einstellungen blockiert.\nVersuche die Seite erneut zu laden oder kontaktiere unser <a href="https://wetransfer.zendesk.com" rel="external">Hilfecenter</a>. ',
      title: 'Oh, oh...',
    },
    javascript_needed:
      'Du brauchst einen JavaScript-fähigen Browser, um WeTransfer nutzen zu können',
  },
  languages: {
    en: 'Englisch',
    nl: 'Niederlande',
  },
  shortcuts: {
    cmd_alt_l: '⌘-Alt-L',
    cmd_j: '⌘-J',
    cmd_c: '⌘-C',
    cmd_shift_j: '⌘-Shift-J',
    control_alt_l: 'Ctrl-Alt-L',
    control_j: 'Ctrl-J',
    control_c: 'Ctrl-C',
  },
  discount: {
    billing_page: {
      legal_notice:
        'Dieses Angebot ist bis zum %{end_date} verfügbar. Der Rabatt gilt für dein erstes Jahr mit %{user_tier}, danach verlängert sich das Abonnement zum vollen Preis von %{yearly_amount}/%{billing_period}.',
    },
    modal: {
      title: '%{discount_amount} % Rabatt auf Pro jährlich',
      subtitle: 'Rabattcode: %{coupon_code_name}',
      text_content:
        'Das ist es. Das ist das Angebot. Wir geben dir einen Rabatt von %{discount_amount} % auf ein jährliches Pro-Abo.',
      argument: {
        size_limit: 'Sende und empfange 200 GB Dateiübertragungen',
        storage_size: 'Freu dich über 1 TB Speicherplatz',
        unlimited_review: 'Erstelle unbegrenzte Reviews',
      },
      cta_label: 'Beanspruche einen Rabatt',
      dismiss_label: 'Jetzt nicht',
    },
    banner: {
      title:
        'Hol dir %{discount_amount} % Rabatt auf WeTransfer Pro für ein Jahr—unser bestes Angebot',
      cta_label: 'Upgrade',
    },
    pricing_page: {
      pill_label: '%{coupon_code_name} – %{discount_amount}% off',
    },
  },
  drawer: {
    first_viewing: {
      title: 'Arbeite bei Übertragungen mit %{first_recipient_email} zusammen',
      subtitle:
        'Lade dein Team ein, Übertragungen auf deinem %{user_plan}-Abo zu senden und zu empfangen.',
      list: {
        overview_item: 'Gemeinsame Übertragungsübersicht',
        storage_limit_item:
          'Gemeinsamer Speicherplatz mit %{storage_limit} extra pro Person',
        branding_item: 'Gemeinsames Team-Branding',
        subscription_item: 'Gemeinsames Abonnement und gemeinsame Abrechnung',
      },
      cta: 'Team einladen',
      dismiss_button: 'Heute nicht',
    },
    second_viewing: {
      title: 'Arbeite bei Übertragungen mit ${first_recipient_email} zusammen',
      subtitle:
        'Lade dein Team ein, Übertragungen auf deinem %{user_plan}-Abo zu senden und zu empfangen.',
      list: {
        overview_item: 'Gemeinsame Übertragungsübersicht',
        storage_limit_item:
          'Gemeinsamer Speicherplatz mit %{storage_limit} extra pro Person',
        branding_item: 'Gemeinsames Team-Branding',
        subscription_item: 'Gemeinsames Abonnement und gemeinsame Abrechnung',
      },
      cta: 'Team einladen',
      dismiss_button: 'Für immer ausblenden',
    },
  },
  external_links: {
    android_app: 'https://we.tl/android',
    ios_app: 'https://we.tl/iosapp',
    facebook: 'https://www.facebook.com/wetransfer',
    homerun: 'https://wetransfer.com/jobs',
    instagram: 'https://www.instagram.com/WeTransfer/',
    twitter: 'https://twitter.com/WeTransfer',
    prco: 'https://wetransfer.pr.co',
    youtube: 'https://www.youtube.com/WeTransfer',
  },
  notification: {
    update_account: 'Dein Konto wurde aktualisiert',
    update_password: 'Dein Passwort wurde geändert',
    update_subscription: 'Dein Zahlungsplan wurde aktualisiert',
    update_profile_success: 'Dein Profil wurde aktualisiert',
    link_copied: 'Dieser Link wurde in deine Zwischenablage kopiert',
    copy_link_manual: 'Link wurde ausgewählt – kopiere ihn mit %{shortcut}',
    delete_transfer_success: 'Diese Übertragung wurde gelöscht',
    delete_transfers_success: 'Übertragungen wurden gelöscht',
    update_expiry_success: 'Das Ablaufdatum wurde geändert',
    onboarding_success:
      "Hier geht's zu deinen Übertragungen, Kontakten, Profileinstellungen ...",
    add_contact_success: 'Dieser Kontakt wurde hinzugefügt',
    edit_contact_success: 'Dieser Kontakt wurde aktualisiert',
    remove_contact_success: 'Dieser Kontakt wurde gelöscht',
    already_signed_in: 'Du bist angemeldet',
    cancel_subscription_success:
      'Wie schade, dass du uns verlässt – dein Abo wurde beendet.',
    collect_app_banner_desc:
      'Dateien speichern und verwalten und in einer Vorschau ansehen in der Collect App',
    contact_added_confirmation:
      'Der Kontakt wurde der Empfängerliste hinzugefügt',
    contact_recipient_locked_text:
      'Über diese Seite empfängt der Eigentümer der Seite Dateien. An jemand anders versenden?',
    forward_ready: 'Deine Übertragung ist sendebereit',
    mobile_app_banner_desc: 'Vorschau, speichern und verwalten in der App',
    mobile_app_banner_title: 'In der App speichern',
    reactivate_subscription_success:
      'Willkommen zurück! Dein Konto wurde reaktiviert. ',
    refresh_transfer_upload_lost:
      'Möchtest du das Hochladen wirklich abbrechen?',
    update_payment_success: 'Deine Daten wurden erfolgreich aktualisiert.',
    update_user: 'Deine Details wurden aktualisiert',
    current_team_notification: 'Du verwendest %{plan} als %{currentTeam}',
    display_name_updated: 'Titel aktualisiert!',
    download_started:
      'Dein Download wurde gestartet Die Dateien findest du anschließend auf deinem Computer (häufig im Download-Ordner).',
    logged_out:
      'Scheinbar wurdest du über ein anderes Browserfenster abgemeldet. Bitte melde dich erneut an.',
    project_delete:
      '<strong>%{projectName}</strong>und alle Dateien löschen, die du hinzugefügt hast?',
    project_delete_success: '<strong>%{projectName}</strong>wurde gelöscht',
    password_changed: 'Passwort geändert',
    password_removed: 'Passwort entfernt',
  },
  alert: {
    confirm_cancel_upload_image:
      'Möchtest du das Hochladen wirklich abbrechen? ',
    cancel_recipient_locked: 'Abbrechen',
    cancel_refresh_transfer_upload_lost: 'Nein',
    confirm_refresh_transfer_upload_lost: 'Ja',
    go_to_transfer: 'Weiter zur Übertragung',
    redirect_recipient_locked: 'Ja',
    stay: 'Auf der Seite bleiben',
    cancel_project_delete: 'Abbrechen',
    confirm_project_delete: 'Löschen',
  },
  force_update:
    "Jetzt wird's spannend! Bitte <a href=\"/\" onClick='javascript:window.location.reload();'>aktualisiere deinen Browser</a>, damit du die jüngste Version von WeTransfer nutzen kannst.",
  user: {
    already_logged_in:
      'Du bist bereits angemeldet – bist du dir sicher, dass du das Passwort zurücksetzen möchtest?',
    roles: {
      admin: 'Administrator',
      owner: 'Owner',
      user: 'User',
    },
    sign_out_and_reset: 'Abmelden und Passwort zurücksetzen',
  },
  click_here: 'Hier klicken',
  cookiebox: {
    notice:
      '<bold>Du bist gegenwärtig angemeldet</bold>, nach dem Löschen der Cookies wirst du abgemeldet. Vergangene Übertragungen auf deinem Konto werden davon nicht beeinflusst.',
  },
  notice: {
    general_issues:
      'Funzt irgendwas nicht? Weil wir wissen, wie frustrierend das sein kann, arbeiten wir gerade <a target="_blank" href=%{link}>mit Hochdruck</a> daran, dass alles wieder ruckelfrei funktioniert.',
    transfer_issues:
      'Probleme mit deiner Übertragung? Wir wissen, dass das frustrierend sein kann und arbeiten aktuell daran, dass alles <a target="_blank" href=%{link}>schnellstmöglich</a> wieder einwandfrei funktioniert.',
    verification:
      'Hi, du musst noch <a href="/account">deine E-Mail-Adresse bestätigen</a>.',
  },
  site: {
    name: 'WeTransfer',
    titles: {
      about: 'Über | WeTransfer',
      advertise: 'Werben auf | WeTransfer',
      apps: 'Kostenlose Apps für Mac, iOS und Android | WeTransfer Apps',
      forgot_password: 'Passwort zurücksetzen | WeTransfer Pro',
      help: 'Wie du große Dateien sendest | WeTransfer Hilfe',
      home: 'Große Dateien einfach und kostenlos teilen | WeTransfer',
      plus: 'Jetzt upgraden und größere Dateien senden | WeTransfer Pro',
      sign_in: 'Anmelden | WeTransfer Pro',
      sign_up: 'Registrieren | WeTransfer Pro',
      upgrade: 'Upgrade | WeTransfer Pro',
      pricing:
        'Preisgestaltung | WeTransfer – Große Dateien senden und Fotos online teilen – bis zu 2 GB kostenlos',
    },
    descriptions: {
      help: 'Need WeTransfer tech support? Find out how to send large files in our Quick Help section or get in touch.',
      social_help: 'Du hast immer noch nicht gefunden, wonach du suchst?',
    },
  },
  splash: {
    footer: {
      or: 'oder',
      send_files: 'Ich möchte nur meine Dateien versenden',
      no_thanks: 'Nein danke',
    },
    heading: {
      line_1_free:
        'WeTransfer - die beste Adresse für das Versenden großer Dateien',
      line_2_free: 'Hol mehr aus WeTransfer',
      free_account: 'Willkommen zurück. Möchtest du es jetzt offiziell machen?',
    },
    plan: {
      plus: {
        feature_10: 'Gestalte deine E-Mails',
        feature_11: 'Speichere bis zu %{plus_storage_limit}',
        feature_12: 'Entscheide, wann Übertragungen verfallen',
        feature_13: 'Nutze passwortgeschützte Übertragungen',
        feature_7: 'Individualisiere dein Profil',
        feature_8: 'Erstelle dein eigenes Adressbuch',
        feature_9: 'Wähle deine WeTransfer-URL',
      },
      free_account: {
        cta: 'Kostenlos registrieren',
        feature_1: 'Kein Speicherplatz',
        feature_2: 'Versende bis zu %{free_transfer_limit}',
        feature_3: 'Übertragungen erneut senden und löschen',
        heading: 'WeTransfer-Konto',
        price_label: 'Immer kostenlos',
      },
      pro: {
        cta: 'Hol dir WeTransfer Pro',
        feature_1: '%{storage_limit_pro} Speicherplatz',
        feature_2: 'Verschicke und empfange bis zu %{transfer_limit_pro}',
        feature_2_unlimited:
          'Sende und empfange Dateien ohne Größenbeschränkungen',
        feature_3: 'Übertragungen erneut senden und löschen',
        feature_4: 'Passwortschutz für Übertragungen',
        feature_5: 'Deine eigene Pro-Seite und URL',
        heading: 'WeTransfer',
      },
    },
  },
  tooltip: {
    team_discovery: {
      title: '%{recipient} zu deinem Team hinzufügen?',
      text_content:
        'Teammitglieder können mit gemeinsam genutztem Speicherplatz und Branding auf die Übertragungen der anderen zugreifen. Dadurch wird deine Übertragung nicht abgebrochen.',
      cta: "Auf geht's",
    },
  },
  transfer_link: {
    buttons: {
      copied: 'Link wurde kopiert',
      copy: 'Link kopieren',
      copy_again: 'Erneut kopieren',
    },
    labels: {
      share: 'Teile diese Übertragung',
    },
  },
  callout: {
    pill: {
      pro_onboarding: 'PRO-TIPP',
    },
    'portals-onboarding': {
      'first-viewing': {
        cta: 'Portals ausprobieren',
        dismiss: 'Jetzt nicht',
        text: 'Lade Kunden und Partner dazu ein, sich deine Arbeit anzusehen und wähle ihre Favoriten mit <strong>portals</strong>. Das ewige Hin-und-Her-Mailen gehört ab jetzt zur Vergangenheit.',
        title: 'Brauchst du Feedback zu deiner Arbeit—und zwar schnell?',
      },
      'second-viewing': {
        cta: 'Portals jetzt ausprobieren',
        dismiss: 'Nicht mehr anzeigen',
        text: "Erhalte schnelles Feedback und teile neue Versionen—alles in einem. Mit <strong>portals</strong> geht's in einem Rutsch vom Review über die Revision zum Friedrich Wilhelm.",
        title: 'File versendet. Und jetzt?',
      },
    },
    pro_onboarding: {
      admin: {
        cta: 'Gehe zu Branding',
        text_2: 'Eigene Videos oder Bilder hinzufügen?',
      },
      individual: {
        cta: 'Seite einrichten',
        text: 'Hinterlasse jedes Mal, wenn deine Dateien heruntergeladen werden, einen guten Eindruck. Füge Videos oder Bilder hinzu und wähle eine eigene URL.',
        title:
          'Schaffe mit deiner eigenen WeTransfer-Seite optimale Voraussetzungen',
      },
      invitee: {
        cta: 'Alles klar',
        text_1:
          'Mit deiner teameigenen WeTransfer-Seite hinterlässt du jedes Mal einen guten Eindruck, wenn du deine Arbeit mit anderen teilst.',
        text_2:
          'Du kannst die Hintergründe deines Teams jederzeit ändern in <strong>Branding</strong>.',
        title: 'Ein Schaufenster für deine (Team-)Arbeit',
      },
      not_now: 'Jetzt nicht',
    },
  },
  cue: {
    inline: {
      teams: {
        onboarding: {
          transfers: {
            received: {
              mini: {
                branding_incomplete: {
                  cta: 'Seite einrichten',
                  premium: {
                    text: 'Jeder kann dir Übertragungen von beliebiger Größe über die WeTransfer-Seite deines Teams senden.',
                  },
                  text: 'Jeder kann dir %{transfer_limit_pro}-Übertragungen über die WeTransfer-Seite deines Teams senden',
                },
                premium: {
                  transfer_link: {
                    text: 'Jeder kann dir über %{custom_link} Übertragungen von beliebiger Größe senden.',
                  },
                },
                transfer_link: {
                  text: 'Jeder kann dir %{transfer_limit_pro}-Übertragungen über %{custom_link} senden',
                },
              },
              premium: {
                text: 'Jeder kann dir Übertragungen von beliebiger Größe über die WeTransfer-Seite deines Teams senden – alles, was sie dazu benötigen, ist dieser Link.',
              },
              regular: {
                cta: 'Alles klar',
                text: 'Jeder kann dir <strong>%{transfer_limit_pro}</strong>-Übertragungen über die WeTransfer-Seite deines Teams senden. Schicke Ihnen hierzu einfach diesen Link.',
                title: 'Ein Ort für alles, was dein Team empfängt',
              },
            },
            sent: {
              regular: {
                cta: 'Alles klar',
                text: 'Willkommen in der gemeinsamen Übersicht über die von deinem Team versendeten Übertragungen. Hier kannst du Downloads nachverfolgen, Ablaufdaten ändern und sogar die Übertragungen von anderen bearbeiten oder löschen – kurz Rücksprache halten ist zu empfehlen!',
                title: 'Verwalte die Übertragungen deines Teams',
              },
            },
          },
        },
      },
    },
  },
  feature_banner: {
    pro: 'WeTransfer Plus ist jetzt WeTransfer Pro mit 1 TB Speicherplatz — Das ist 10x mehr. <a href="/transfers">Probier\'s mal aus.</a>',
  },
  refer_friend: {
    title: 'Freunde empfehlen',
    account: {
      description:
        'Wir schenken dir und einem Freund/einer Freundin jeweils 10 $, wenn sie sich für WeTransfer Pro oder Premium registrieren. Teile deinen Empfehlungslink, um mit Prepaid-Karten, Spenden für wohltätige Zwecke oder Geschenkkarten von Hunderten von Partnern belohnt zu werden.',
    },
    window: {
      link: 'Hol dir den Empfehlungslink',
      send_another: 'Fortfahren',
      text: 'Wir schenken dir und einem Freund/einer Freundin jeweils <strong>10 $</strong>, wenn er/sie sich für WeTransfer Pro oder Premium registriert.',
      title: 'Eine(n) Freund(in) empfehlen',
      title_2: 'zum Senden von Übertragungen.',
    },
    message: {
      success:
        'Du hast hier einen tollen Freund/eine tolle Freundin! Registriere dich für WeTransfer Pro oder Premium, und ihr erhaltet eine Prepaid-Karte, eine Spende für eine Wohltätigkeitsorganisation oder einen Geschenkgutschein im Wert von 10 $.',
      self: 'Oh nein, der Empfehlungslink sieht komisch aus. Bitte deinen Freund/deine Freundin um einen neuen Link, um 10 $ zu erhalten, wenn du dich für WeTransfer Pro oder Premium registrierst.',
      fallback:
        'Oh nein, dieser Empfehlungslink sieht komisch aus. Bitte deinen Freund/deine Freundin um einen neuen Link, um 10 $ zu erhalten, wenn du dich für WeTransfer Pro oder Premium registrierst.',
      expired: 'Dein Empfehlungslink ist leider abgelaufen.',
      dismiss: 'Ablehnen',
    },
  },
  order_summary: {
    coupon: {
      link: 'Angebotscode anwenden',
      input_placeholder: 'Angebotscode',
      button_label: 'Anwenden',
      error_message:
        'Leider kann dieser Code kann nur zum Speichern eines %{billing_period}-Abonnements verwendet werden.',
      generic_error_message:
        'Leider ist dieser Code mit diesem Abonnement nicht kompatibel',
      input_error_message: 'Hmm, das ist kein gültiger Code.',
      pill_label: {
        percentage: '-%{percentage}%',
      },
    },
    total: 'Summe',
  },
  mobile_verify: {
    title: 'Du bist startklar',
    subtitle:
      'Deine E-Mail wurde verifiziert—du kannst die App jetzt verwenden, um Übertragungen zu senden und zu empfangen.',
    cta: 'Öffne die WeTransfer App',
  },
  pricing_panel: {
    current_solo_workspace_information:
      'Dein aktueller Plan von <b>%{formattedintervaltotal}</b>/%{subscriptioninterval} wird automatisch am <b>%{autorenewalattempt}</b> verlängert',
    current_team_workspace_information:
      'Dein aktueller Plan von <b>%{formattedTeamWorkspaceCost}</b> /%{subscriptioninterval} (%{membercount} x %{tieramount}) wird automatisch am <b>%{autorenewalattempt}</b> verlängert',
    next_payment_date:
      'Dein nächstes Zahlungsdatum ist der <b>%{recurring_billing_date}</b>',
    upgrade_price: '<b>%{totalprice}</b>/%{interval}',
    team_upgrade_calculation: '(%{membercount} Mitglieder x %{tierprice})',
    premium_title: 'WeTransfer Premium',
    premium_feature_one: 'Keine Volumenbeschränkungen für Übertragungen',
    premium_feature_two: 'Unbegrenzter Speicherplatz',
    premium_feature_three: 'Unbegrenzten Portalen und Reviews',
    premium_feature_four:
      '<a class="all-benefits-link" href="%{all_benefits_href}">Alle Vorteile</a> anzeigen',
    premium_switch_cta_text: 'Zu Premium wechseln',
    pill_text: 'Aktuelles Abonnement',
    member_count: '%{membercount} Mitglieder',
    see_all_benefits: 'Alle Vorteile des Plans anzeigen',
    pending_downgrade_current_subscription:
      'Dein Arbeitsbereich-Abonnement wurde gekündigt und endet am <b>%{cancellation_date}</b>.',
    pending_downgrade_reactivate_text:
      'Hast du es dir anders überlegt? Keine Panik, es ist ganz einfach, alles wieder in Gang zu bringen.',
    pending_downgrade_reactivate_cta: 'Pro reaktivieren',
    pending_downgrade_payment: 'Du hast keine anstehenden Zahlungen',
    update_payment_cta: 'Zahlungsdaten aktualisieren',
    cancel_plan:
      'Wenn du dein Abonnement kündigst, hast du bis zum %{subscriptionRenewalDate} Zugriff auf deinen%{planName}-Arbeitsbereich. ',
    cancel_expiry_text:
      'Dein Arbeitsbereich wird dann auf den kostenlosen Plan herabgestuft und deine vorhandenen Übertragungen laufen nach 28 Tagen ab.',
    pending_payment_text:
      'Um deinen Plan und deine Zahlungsinformationen zu sehen, schließe bitte deine Zahlung ab oder storniere deine Bestellung.',
    learn_more: 'Mehr über Pläne und Preise erfahren',
  },
  time: {
    days: {
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
      sunday: 'Sonntag',
    },
    months: {
      january: 'Januar',
      february: 'Februar',
      march: 'März',
      april: 'April',
      may: 'Mai',
      june: 'Juni',
      july: 'Juli',
      august: 'August',
      september: 'September',
      october: 'Oktober',
      november: 'November',
      december: 'Dezember',
    },
    remaining: {
      minutes: {
        zero: 'Restdauer unter einer Minute',
        one: 'Restdauer ca. 1 Minute',
        other: 'Restdauer ca. %{count} Minuten',
      },
      hours: {
        one: 'Restdauer ca. 1 Stunde',
        other: 'Restdauer ca. %{count} Stunden',
      },
    },
  },
  download: {
    shortcut:
      'Durch Klick auf %{command} wird der Status des Downloads angezeigt.',
    shortcuts: {
      control_j: 'Ctrl-J',
      control_alt_l: 'Ctrl-Alt-L',
      cmd_shift_j: '&#8984;-Shift-J',
      cmd_j: '&#8984;-J',
      cmd_alt_l: '&#8984;-Alt-L',
    },
  },
  upload: {
    title: 'Senden bis zu %{size}',
    progress: {
      busy: 'Übertragung läuft...',
    },
    buttons: {
      add: 'Dateien hinzufügen',
      transfer: 'Übertragung',
      forward: 'Weiterleiten',
      add_ios6: 'Fügen Sie Fotos und Videos hinzu',
      add_ios7: 'Fügen Sie Fotos hinzu',
    },
    forward: {
      done: 'Weiterleiten abgeschlossen',
    },
    friend_email: {
      title: 'E-Mail eines Freundes',
      more: 'Mehr Freunde hinzufügen',
    },
    your_email: {
      title: 'Ihre E-Mail',
    },
    message: {
      title: 'Nachricht',
    },
    done: {
      title: 'Transfer abgeschlossen',
      link: 'Kopieren Sie Ihren Download-Link:',
      copied: {
        title: 'Kopiert!',
        text: 'Der Download-Link wurde kopiert.',
      },
    },
    more_html: 'Mehr Dateien hinzufügen<span>(%{size})</span>',
    too_many_recipients:
      'Sie haben anscheinend zu viele E-Mail-Adressen eingegeben. Bitte denken Sie daran: Es gibt genug Platz für bis zu %{count} Empfänger gleichzeitig.',
    completed: '%{size} von %{total} abgeschlossen',
    addresses: {
      one: '%{count} Adresse',
      other: '%{count} Adressen',
      remove:
        'Möchten Sie %{address} aus Ihren vorherigen Empfängern entfernen?',
    },
    ads: {
      plus: {
        title: 'Machen Sie mehr aus WeTransfer durch Pro',
        text: "<ul><li>Hochladen größerer Datenmengen</li><li>Persönliche Übertragungen mit Ihren eigenen Hintergrundbildern</li><li>Passwort geschützte Übertragungen</li><li>Langzeitlagerung</li></ul><p><a target='_blank' href='/pro?trk=inapp'>Mehr Informationen</a></p>",
      },
      plus2: {
        title:
          'Eindruck machen mit Ihrer eigenen personalisierten Download-Seite',
        text: "<p>Verwenden Sie Ihre eigenen Hintergrundbilder und Ihre persönliche WeTransfer-URL (yourname.wetransfer.com), um  Ihre Empfänger zu beeindrucken.</p><p><a target='_blank' href='/pro?trk=inapp'>Mehr Informationen</a></p>",
      },
      plus3: {
        title: 'Intelligentes Verwalten<br/>Ihrer Übertragungen',
        text: "<p>Diese Übertragung wird nach einer Woche gelöscht, aber mit WeTransfer-Pro können Sie Dateien unbegrenzt speichern, weiterleiten oder sofort löschen, ohne erneut hochladen zu müssen.</p><p><a target='_blank' href='/pro?trk=inapp'>Mehr Informationen</a></p>",
      },
      plus4: {
        title: 'Zusätzlicher Schutz<br />für Ihre Dateien',
        text: "<p>Mit WeTransfer-Pro können Sie Ihre wertvollen und vertraulichen Daten durch ein Passwort schützen. Auf diese Weise werden sie niemals in falsche Hände gelangen.</p><p><a target='_blank' href='/pro?trk=inapp'>Mehr Informationen</a></p>",
      },
      facebook: {
        title: 'Treten Sie der WeTransfer Community auf Facebook bei',
        text: "<p>Erhalten Sie die neusten Nachrichten, gewinnen Sie Preise, entdecken Sie neue Künstler, lesen Sie Interviews und vieles mehr.</p><p><a target='_blank' href='https://www.facebook.com/wetransfer'>Mehr Informationen</a>",
      },
      flipflops: {
        title: 'Free flipflops by WeTransfer',
        text: "<p style='text-align:center;'><img src='/assets/flipflops.jpg'></p><p>As a thank you from us, we've teamed up with Suavesoles to get you this fantastic pair of flipflops for free!<br /><a target='_blank' href='http://suavesoles.com/we-transfer/?ref=wt-app'>Order now</a></p>",
      },
    },
    errors: {
      only_email:
        'Sorry, nur E-Mails werden unterstützt, wenn eine Übertragung erneut geschickt werden soll.',
      connect_twitter:
        'Ihr Twitter-Account ist noch nicht mit WeTransfer verbunden.',
      connect_facebook:
        'Ihr Facebook-Account ist noch nicht mit WeTransfer verbunden.',
      transferproblems: {
        title: 'Übertragungsproblem',
        text: 'Leider müssen wir Ihnen mitteilen, dass bei der Übertragung etwas nicht funktioniert hat.',
      },
      limitreached: {
        title: 'Speicherlimit',
        text: 'Sie haben Ihr Limit von 1 TB erreicht. Löschen Sie alte Übertragungen, um neue Dateien zu senden',
      },
      blocked: {
        title: 'Übertragungsproblem',
        text: 'Der Computer sagt nein. Tut uns leid, aber Sie wurden von WeTransfer blockiert.',
      },
      upload_error: {
        title: 'Übertragungsproblem',
        text: 'Leider müssen wir Ihnen mitteilen, dass bei der Übertragung etwas nicht funktioniert hat.',
      },
      unavailable: {
        title: 'Übertragungsproblem',
        text: 'Sorry, diese Übertragung wurde bereits gelöscht und kann deshalb nicht weitergeleitet werden.',
      },
      startswithdot: {
        title: 'Ups',
        text: 'Eine (oder mehrere) Ihrer Dateien hat einen Namen, der mit einem Punkt beginnt. Das funktioniert nicht. Bitte benennen Sie die Datei(en) um und versuchen Sie erneut, diese hinzuzufügen.',
      },
      startswithspace: {
        title: 'Ups',
        text: 'Eine (oder mehrere) Ihrer Dateien hat einen Namen, der mit einem Leerzeichen beginnt. Das funktioniert nicht. Bitte benennen Sie die Datei(en) um und versuchen Sie erneut, diese hinzuzufügen.',
      },
      containsreturn: {
        title: 'Ups',
        text: 'Eine oder (mehrere) Ihrer Dateien besitzt einen Namen, der einen Return enthält. Wir wissen nicht genau, wie Sie das geschafft haben, aber es funktioniert nicht. Bitte benennen Sie die Datei(en) um und versuchen Sie erneut, diese hinzuzufügen.',
      },
      alreadyinlist: {
        title: 'Huch',
        text: 'Eine Ihrer Dateien hat den gleichen Namen wie eine andere Datei, die Sie bereits ausgewählt haben. Ändern Sie den Namen ein bisschen!',
      },
      transfertoobig: {
        title: 'Oh-oh',
        text: 'Es tut uns sehr leid, aber wir können nicht mehr als  %{upload_limit}GB auf einmal übertragen.',
      },
      filetoobig: {
        title: 'Oh-oh',
        text: 'Es tut uns sehr leid, aber wir können nicht mehr als %{upload_limit}GB auf einmal übertragen.',
      },
      zerobytes: {
        title: 'Hoppla',
        text: 'Eine (oder mehrere) Ihrer Dateien ist leer oder konnte nicht gelesen werden.',
      },
      ioerror: {
        title: 'Fehlgeschlagen',
        text: 'Eine (oder mehrere) Ihrer Dateien konnten nicht gelesen werden oder ist größer als  %{upload_limit}GB. Das funktioniert nicht.',
      },
      filenametoolong: {
        title: 'Huch',
        text: 'Eine (oder mehrere) Ihrer Dateien hat einen Dateinamen, der länger als 250 Zeichen ist. Wir können keine Dateinamen akzeptieren, die länger sind, deshalb benennen Sie sie bitte um.',
      },
      nofolders: {
        title: 'Oh-oh',
        text: 'Tut uns leid, das Hochladen von Ordnern funktioniert noch nicht. Versuchen Sie, den Ordner zuerst zu zippen.',
      },
      nofiles: {
        title: 'Ups',
        text: 'Sie haben noch keine Dateien hinzugefügt.',
      },
      norecipients: {
        title: 'Oh nein!',
        text: 'Es sieht aus, als hätten Sie vergessen, E-Mail-Adressen einzugeben, an die gesendet werden soll.',
      },
      toomanyrecipients: {
        title: 'Huch',
        text: 'Zu viele Empfänger.',
      },
      bigmessage: {
        title: 'Hoppla',
        text: 'Sie haben fast einen Roman geschrieben. Bitte fassen Sie sich kürzer.',
      },
      nosender: {
        title: 'Wirklich?',
        text: 'Sie haben vergessen, Ihre eigene E-Mail-Adresse einzugeben. Wie konnte das passieren?',
      },
      senderemailinvalidformat: {
        title: 'Oh-oh',
        text: 'Ihre E-Mail-Adresse scheint falsch zu sein. Achten Sie auf die Schreibweise!',
      },
      probablynotcopied: {
        title: 'Ups',
        text: 'Sie scheinen den Link nicht kopiert zu haben.',
      },
      recipientemailinvalidformat: {
        title: 'Ups',
        text: 'Sie haben die E-Mail-Adresse eines Ihrer Freunde falsch eingegeben.',
      },
      requiresdefaultrecipient: {
        title: 'Uh-oh',
        text: 'Sorry! You can only send more than 2GB to the Pro Channel owner. Refresh the page to start again.',
      },
      containsbackslash: {
        title: 'Huch',
        text: 'Eine (oder mehrere) Ihrer Dateien besitzt einen Dateinamen, der einen umgekehrten Schrägstrich (backslash) beinhaltet. Wir können dies nicht akzeptieren, deshalb benennen Sie die Dateien bitte um, so dass sie keinen umgekehrten Schrägstrich (backslash) mehr enthalten.',
      },
      title: 'Ups',
      text: "Mit iOS7 können Sie über unsere Website keine Videos versenden, aber mit unserer <a href='%{wetransfer_ios_app_store_url}'>fantastischen WeTransfer-App</a> klappt es!",
    },
    tips: {
      maxfilesize_tip: {
        title: 'Tipp',
        text: 'Pro Übertragung können Sie bis zu 2 GB senden. Und was noch besser ist: Sie können so viele Übertragungen machen wie Sie nur möchten.',
      },
      maxfilesize_oldbrowser_tip: {
        title: 'Wichtig',
        text: "Ihr Pro-Konto kann bis zu 20 GB pro Übertragung senden, aber Ihr Browser verhindert dies. <a href='/questions/33'>Hier klicken für weitere Informationen.</a>",
      },
      recipients_tip: {
        title: 'Tipp',
        text: 'Sie können bis zu %{email_limit} E-Mail-Adressen als Empfänger eingeben. Wenn Sie nur einen Download-Link möchten, so klicken Sie unten auf Teilen.',
      },
      default_recipient: {
        title: 'Tip',
        text: 'To send over 2GB, make sure you upload your files to the Pro Channel owner only. Refreshing the page will pre-fill their address for you.',
      },
      sender_tip: {
        title: 'Tipp',
        text: 'Geben Sie hier Ihre eigene Email-Adresse ein, damit wir Sie kontaktieren können, wenn die Dateien heruntergeladen wurden.',
      },
      expire_tip: {
        title: 'Tipp',
        text: 'Sie können nun das Ablaufdatum Ihrer Pro-Übertragungen ändern.',
      },
      message_tip: {
        title: 'Tipp',
        text: 'Möchten Sie Ihren Freunden eine Nachricht zu den Dateien schicken? Hier haben Sie die Gelegenheit dazu - wenn Sie wollen.',
      },
      share_tip: {
        title: 'Tipp',
        text: 'Es gibt viele Arten, um Ihre Dateien mit anderen zu teilen: Schicken Sie Ihre Dateien per E-Mail oder holen Sie sich einen Download-Link.',
        text_plus:
          'Es gibt viele Arten, um Ihre Dateien mit anderen zu teilen: Schicken Sie Ihre Dateien per E-Mail, Twitter, Facebook oder holen Sie sich einen Download-Link.',
      },
      download: {
        title: '',
        chrome:
          "Das Herunterladen funktioniert jetzt anders als vorher. Wir laden jetzt alle Dateien über den Browser herunter, so dass Sie nicht länger den Fortschritt in WeTransfer sehen und Sie werden auch nicht gefragt, wo Sie die Datei speichern wollen. Der Download-Fortschritt sollte unterhalb Ihres Browserfensters sichtbar sein und Ihre Datei wird standardmäßig in Ihrem Downloads-Ordner gespeichert. <a href='/questions/24' target='_blank'>Lesen Sie hier, wie Sie diesen Vorgang ändern können</a>.",
        firefox:
          "Das Herunterladen funktioniert jetzt anders als vorher. Wir laden jetzt alle Dateien über den Browser herunter, so dass Sie nicht länger den Fortschritt in WeTransfer sehen und Sie werden auch nicht gefragt, wo Sie die Datei speichern wollen. Der Download-Fortschritt sollte unterhalb Ihres Browser-Downloadfensters sichtbar sein und Ihre Datei wird standardmäßig in Ihrem Downloads-Ordner gespeichert. <a href='/questions/24' target='_blank'>Erfahren Sie mehr</a>.",
        safari:
          "Das Herunterladen funktioniert jetzt anders als vorher. Wir laden jetzt alle Dateien über den Browser herunter, so dass Sie nicht länger den Fortschritt in WeTransfer sehen und Sie werden auch nicht gefragt, wo Sie die Datei speichern wollen. Der Download-Fortschritt sollte oben rechts Ihres Browserfensters sichtbar sein und Ihre Datei wird standardmäßig in Ihrem Downloads-Ordner gespeichert. <a href='/questions/24' target='_blank'>Erfahren Sie mehr</a>.",
        old_explorer:
          "Das Herunterladen funktioniert jetzt anders als vorher. Wir laden jetzt alle Dateien über den Browser herunter, so dass Sie nicht länger den Fortschritt in WeTransfer sehen und Sie werden auch nicht gefragt, wo Sie die Datei speichern wollen. Sie sehen evtl. auch eine Sicherheitswarnung oberhalb Ihres Browserfensters <a href='/questions/24' target='_blank'>Erfahren Sie mehr</a>.",
        explorer:
          "Das Herunterladen funktioniert jetzt anders als vorher. Wir laden jetzt alle Dateien über den Browser herunter, so dass Sie nicht länger den Fortschritt in WeTransfer sehen und Sie werden auch nicht gefragt, wo Sie die Datei speichern wollen. Der Download-Fortschritt sollte unterhalb Ihres Browserfensters sichtbar sein (Sie müssen evtl. erst auf Speichern klicken) und Ihre Datei wird standardmäßig in Ihrem Downloads-Ordner gespeichert. <a href='/questions/24' target='_blank'>Erfahren Sie mehr</a>.",
        settings:
          'Sie können den Speicherort von Downloads in Ihren Browsereinstellungen anpassen.',
      },
    },
  },
  warnings: {
    unsaved_changed:
      'You have made changes to your Channel. Are you sure you want to leave this page without saving?',
    forwarding:
      'Das Weiterleiten dieser Übertragung wird das Formular löschen, sind Sie sicher?',
    is_busy: 'Tut uns leid, das können wir gerade nicht tun.',
  },
  mobile_app: {
    remember_choice: 'Diese Meldung nicht mehr anzeigen',
    uploader: {
      description:
        'Unsere Website ist derzeit nicht für Mobilgeräte optimiert. Aber wir haben eine tolle App.',
      app_name: 'WeTransfer',
      download: 'App herunterladen',
      continue: 'Weiter zur WeTransfer.com',
    },
    downloader: {
      title: 'Ihre Dateien stehen zum Download bereit',
      description_ios:
        'Wir haben Ihre Dateien in einer ZIP-Datei verpackt. Sie brauchen eine App, um die ZIP-Datei zu entpacken und die Dateien anzuzeigen. Wir empfehlen <a href="https//itunes.apple.com/us/app/winzip/id500637987?mt=8">Winzip</a>.',
      description_android:
        'Wir haben Ihre Dateien in einer ZIP-Datei verpackt. Sie brauchen eine App, um die ZIP-Datei zu entpacken und die Dateien anzuzeigen. Wir empfehlen <a href="https//play.google.com/store/apps/details?id=com.estrongs.android.pop&hl=en">ES File Explorer</a>.',
      continue: 'Alles klar',
    },
  },
};
